/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface SendOTPBody {
  /** @pattern ^\+[1-9]\d{6,14}$ */
  phone: string;
  context?: "login" | "register" | "change_phone";
  source?: "register" | "checkout";
  cartSnapshot?: {
    courseId: string;
    title: string;
    priceInCents: number;
    mercadopagoPriceInCents?: number;
    currency: string;
  }[];
  termsAccepted?: boolean;
  /** @maxLength 200 */
  firstName?: string;
  /** @maxLength 200 */
  lastName?: string;
  /** @maxLength 2048 */
  turnstileToken?: string;
  turnstileTier?: "invisible" | "managed";
  /** @maxLength 64 */
  attemptId?: string;
  surface?:
    | "login"
    | "register"
    | "enroll"
    | "checkout_login"
    | "checkout_register"
    | "change_phone";
  clientSignals?: {
    /** @maxLength 200 */
    clientError?: string;
    waitedMs?: number;
    fillMs?: number;
    interactions?: number;
    webdriver?: boolean;
    /** @maxLength 200 */
    honeypot?: string;
  };
}

export interface GetAuthBotCheckConfigResponse {
  data: {
    enabled: boolean;
    invisibleSiteKey: string | null;
    managedSiteKey: string | null;
    graceMs: number;
  };
}

export interface VerifyOTPBody {
  /** @pattern ^\+[1-9]\d{6,14}$ */
  phone: string;
  /**
   * @minLength 6
   * @maxLength 6
   */
  code: string;
}

export interface VerifyOTPResponse {
  data:
    | {
        id: string;
        createdAt: string;
        updatedAt: string;
        email: string | null;
        phone: string | null;
        firstName: string;
        lastName: string;
        role: string;
        archived: boolean;
        deletedAt: string | null;
        profilePictureUrl: string | null;
        isNewUser: false;
        onboardingStatus: {
          id: string;
          createdAt: string;
          updatedAt: string;
          userId: string;
          dashboard: boolean;
          courses: boolean;
          announcements: boolean;
          profile: boolean;
          settings: boolean;
          providerInformation: boolean;
        };
      }
    | {
        verified: true;
        isNewUser: true;
        otpToken: string;
      };
}

export interface RegisterBody {
  /** @pattern ^\+[1-9]\d{6,14}$ */
  phone: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  lastName: string;
  otpToken: string;
}

export interface RegisterResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    email: string | null;
    phone: string | null;
    firstName: string;
    lastName: string;
    role: string;
    archived: boolean;
    deletedAt: string | null;
    profilePictureUrl: string | null;
  };
}

export type LogoutResponse = null;

export type RefreshTokensResponse = null;

export interface CurrentUserResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    email: string | null;
    phone: string | null;
    firstName: string;
    lastName: string;
    role: string;
    archived: boolean;
    deletedAt: string | null;
    profilePictureUrl: string | null;
    onboardingStatus: {
      id: string;
      createdAt: string;
      updatedAt: string;
      userId: string;
      dashboard: boolean;
      courses: boolean;
      announcements: boolean;
      profile: boolean;
      settings: boolean;
      providerInformation: boolean;
    };
  };
}

export interface GetUserStatisticsResponse {
  data: {
    averageStats: {
      lessonStats: {
        started: number;
        completed: number;
        completionRate: number;
      };
      courseStats: {
        started: number;
        completed: number;
        completionRate: number;
      };
    };
    quizzes: {
      totalAttempts: number;
      totalCorrectAnswers: number;
      totalWrongAnswers: number;
      totalQuestions: number;
      averageScore: number;
      uniqueQuizzesTaken: number;
    };
    courses: object;
    lessons: object;
    streak: {
      current: number;
      longest: number;
      activityHistory: object;
    };
    nextLesson: {
      /** @format uuid */
      courseId: string;
      courseTitle: string;
      courseDescription: string;
      courseThumbnail: string;
      /** @format uuid */
      lessonId: string;
      chapterTitle: string;
      lessonTitle?: string;
      chapterProgress: "not_started" | "in_progress" | "completed" | "blocked";
      completedLessonCount: number;
      lessonCount: number;
      chapterDisplayOrder: number;
    } | null;
  };
}

export interface GetAdminOverviewResponse {
  data: {
    scope: "all" | "author";
    totals: {
      registeredStudents: number | null;
      enrollments: number;
      enrolledStudents: number;
      completions: number;
      completionRate: number | null;
      certificates: number;
      finalQuizAttempted: number;
      finalQuizPassed: number;
      finalQuizPassRate: number | null;
    };
    funnel: {
      registered: number | null;
      enrolled: number;
      started: number;
      completed: number;
      certified: number;
    };
    monthly: {
      month: string;
      enrollments: number;
      completions: number;
      certificates: number;
    }[];
    courses: {
      /** @format uuid */
      courseId: string;
      title: string;
      status: string;
      enrolled: number;
      started: number;
      completed: number;
      completionRate: number | null;
      certificates: number;
      lastEnrollmentAt: string | null;
      finalQuizTitle: string | null;
      finalQuizAttempted: number;
      finalQuizPassed: number;
      finalQuizPassRate: number | null;
    }[];
  };
}

export interface FileUploadResponse {
  fileKey: string;
  fileUrl?: string;
  status?: string;
  uploadId?: string;
}

export interface InitVideoUploadBody {
  /** @minLength 1 */
  filename: string;
  /** @min 1 */
  sizeBytes: number;
  /** @minLength 1 */
  mimeType: string;
  title?: string;
  resource?: string;
  /** @format uuid */
  contextId?: string;
  /** @format uuid */
  entityId?: string;
  entityType:
    | "course"
    | "chapter"
    | "lesson"
    | "question"
    | "news"
    | "articles"
    | "user"
    | "category"
    | "announcement"
    | "global_settings";
}

export interface InitVideoUploadResponse {
  /** @format uuid */
  uploadId: string;
  provider: "bunny" | "s3";
  fileKey: string;
  bunnyGuid?: string;
  tusEndpoint?: string;
  tusHeaders?: object;
  expiresAt?: string;
  multipartUploadId?: string;
  /** @min 1 */
  partSize?: number;
  /** @format uuid */
  resourceId?: string;
  playbackUrl?: string;
}

export type GetVideoUploadStatusResponse = {
  uploadId: string;
  placeholderKey: string;
  status: "queued" | "uploaded" | "processed" | "failed";
  provider?: "bunny" | "s3";
  fileKey?: string;
  fileUrl?: string;
  bunnyVideoId?: string;
  multipartUploadId?: string;
  /** @min 1 */
  partSize?: number;
  fileType?: string;
  error?: string;
  userId?: string;
} | null;

export interface HandleBunnyWebhookBody {
  VideoLibraryId?: number | string;
  status?: number | string;
  Status?: number | string;
  videoId?: string;
  VideoId?: string;
  videoGuid?: string;
  VideoGuid?: string;
  guid?: string;
  Guid?: string;
}

export interface GetUsersResponse {
  data: ({
    id: string;
    createdAt: string;
    updatedAt: string;
    email: string | null;
    phone: string | null;
    firstName: string;
    lastName: string;
    role: string;
    archived: boolean;
    deletedAt: string | null;
    profilePictureUrl: string | null;
  } & {
    groups: {
      /** @format uuid */
      id: string;
      name: string;
    }[];
  })[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetUserByIdResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    email: string | null;
    phone: string | null;
    firstName: string;
    lastName: string;
    role: string;
    archived: boolean;
    deletedAt: string | null;
    profilePictureUrl: string | null;
    groups: {
      /** @format uuid */
      id: string;
      name: string;
    }[];
  };
}

export interface GetUserCoursesProgressResponse {
  data: {
    /** @format uuid */
    courseId: string;
    title: string;
    courseStatus: string;
    enrollmentStatus: string;
    progress: string;
    accessLevel: string;
    enrolledAt: string | null;
    completedAt: string | null;
    totalLessons: number;
    completedLessons: number;
    totalClasses: number;
    completedClasses: number;
    percent: number;
    lastActivityAt: string | null;
    certificateCode: string | null;
  }[];
}

export interface GetUserOrdersResponse {
  data: {
    /** @format uuid */
    id: string;
    status: string;
    provider: string;
    totalAmountInCents: number;
    currency: string;
    createdAt: string;
    courses: {
      /** @format uuid */
      courseId: string;
      title: string;
    }[];
  }[];
}

export interface GetUserActivityResponse {
  data: {
    kind:
      | "login"
      | "lesson_completed"
      | "lesson_viewed"
      | "enrolled"
      | "course_completed"
      | "credential_issued"
      | "order";
    at: string;
    label: string;
    courseId?: string | null;
    courseTitle?: string | null;
  }[];
}

export interface GetSecurityStatusResponse {
  data: {
    hasPassword: boolean;
  };
}

export interface GetUserDetailsResponse {
  data: {
    firstName: string | null;
    lastName: string | null;
    /** @format uuid */
    id: string;
    description: string | null;
    contactPhone?: string | null;
    jobTitle?: string | null;
    role?: "admin" | "student" | "content_creator";
    profilePictureUrl: string | null;
  };
}

export interface UpdateUserBody {
  firstName?: string;
  lastName?: string;
  groups?: string[] | null;
  email?: string | null;
  role?: "admin" | "student" | "content_creator";
  archived?: boolean;
}

export interface UpdateUserResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    email: string | null;
    phone: string | null;
    firstName: string;
    lastName: string;
    role: string;
    archived: boolean;
    deletedAt: string | null;
    profilePictureUrl: string | null;
  };
}

export interface UpsertUserDetailsBody {
  email?: string | null;
  description?: string;
  contactPhoneNumber?: string;
  jobTitle?: string;
}

export interface UpsertUserDetailsResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface ChangePhoneBody {
  /** @pattern ^\+[1-9]\d{6,14}$ */
  phone: string;
  /**
   * @minLength 6
   * @maxLength 6
   */
  code: string;
}

export interface ChangePhoneResponse {
  data: {
    success: boolean;
  };
}

export interface AdminUpdateUserBody {
  /** @maxLength 64 */
  firstName?: string;
  /** @maxLength 64 */
  lastName?: string;
  groups?: string[] | null;
  /**
   * @minLength 6
   * @maxLength 32
   */
  phone?: string;
  email?: string | null;
  role?: "admin" | "student" | "content_creator";
  archived?: boolean;
}

export interface AdminUpdateUserResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    email: string | null;
    phone: string | null;
    firstName: string;
    lastName: string;
    role: string;
    archived: boolean;
    deletedAt: string | null;
    profilePictureUrl: string | null;
  };
}

export interface DeleteBulkUsersBody {
  userIds: string[];
}

export type DeleteBulkUsersResponse = null;

export type BulkAssignUsersToGroupBody = {
  /** @format uuid */
  userId: string;
  groups: string[];
}[];

export interface ArchiveBulkUsersBody {
  userIds: string[];
}

export interface ArchiveBulkUsersResponse {
  data: {
    archivedUsersCount: number;
    usersAlreadyArchivedCount: number;
  };
}

export interface BulkUpdateUsersRolesBody {
  userIds: string[];
  role: "admin" | "student" | "content_creator";
}

export interface CreateUserBody {
  /**
   * @minLength 6
   * @maxLength 32
   */
  phone: string;
  email?: string | null;
  /**
   * @minLength 1
   * @maxLength 64
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  lastName: string;
  role: "admin" | "student" | "content_creator";
  language?: string;
}

export interface CreateUserResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface ImportUsersResponse {
  data: {
    importedUsersAmount: number;
    skippedUsersAmount: number;
    importedUsersList: {
      phone: string;
      name: string;
    }[];
    skippedUsersList: {
      phone: string;
      name: string;
      reason: string;
    }[];
  };
}

export interface ResetOnboardingStatusResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    userId: string;
    dashboard: boolean;
    courses: boolean;
    announcements: boolean;
    profile: boolean;
    settings: boolean;
    providerInformation: boolean;
  };
}

export interface MarkOnboardingCompleteResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    userId: string;
    dashboard: boolean;
    courses: boolean;
    announcements: boolean;
    profile: boolean;
    settings: boolean;
    providerInformation: boolean;
  };
}

export interface GetPublicGlobalSettingsResponse {
  data: {
    unregisteredUserCoursesAccessibility: boolean;
    enforceSSO: boolean;
    certificateBackgroundImage: string | null;
    companyInformation?: {
      companyName?: string;
      /** @maxLength 10 */
      companyShortName?: string;
      registeredAddress?: string;
      taxNumber?: string;
      emailAddress?: string;
      courtRegisterNumber?: string;
    };
    platformLogoS3Key: string | null;
    loginBackgroundImageS3Key: string | null;
    platformSimpleLogoS3Key: string | null;
    MFAEnforcedRoles: ("admin" | "student" | "content_creator")[];
    defaultCourseCurrency: "ars" | "pln" | "eur" | "gbp" | "usd";
    inviteOnlyRegistration: boolean;
    primaryColor: string | null;
    contrastColor: string | null;
    unregisteredUserQAAccessibility: boolean;
    QAEnabled: boolean;
    unregisteredUserNewsAccessibility: boolean;
    newsEnabled: boolean;
    unregisteredUserArticlesAccessibility: boolean;
    articlesEnabled: boolean;
    ageLimit: 13 | 16 | null;
    loginPageFiles: string[];
  };
}

export interface GetUserSettingsResponse {
  data:
    | {
        language: string;
        /** @default false */
        isMFAEnabled: boolean;
        MFASecret: string | null;
      }
    | {
        language: string;
        /** @default false */
        isMFAEnabled: boolean;
        MFASecret: string | null;
        configWarningDismissed: boolean;
      };
}

export type UpdateUserSettingsBody =
  | {
      language?: string;
      /** @default false */
      isMFAEnabled?: boolean;
      MFASecret?: string | null;
    }
  | {
      language?: string;
      /** @default false */
      isMFAEnabled?: boolean;
      MFASecret?: string | null;
      configWarningDismissed?: boolean;
    };

export interface UpdateUserSettingsResponse {
  data:
    | {
        language: string;
        /** @default false */
        isMFAEnabled: boolean;
        MFASecret: string | null;
      }
    | {
        language: string;
        /** @default false */
        isMFAEnabled: boolean;
        MFASecret: string | null;
        configWarningDismissed: boolean;
      };
}

export interface UpdateUnregisteredUserCoursesAccessibilityResponse {
  data: {
    unregisteredUserCoursesAccessibility: boolean;
    enforceSSO: boolean;
    certificateBackgroundImage: string | null;
    companyInformation?: {
      companyName?: string;
      /** @maxLength 10 */
      companyShortName?: string;
      registeredAddress?: string;
      taxNumber?: string;
      emailAddress?: string;
      courtRegisterNumber?: string;
    };
    platformLogoS3Key: string | null;
    loginBackgroundImageS3Key: string | null;
    platformSimpleLogoS3Key: string | null;
    MFAEnforcedRoles: ("admin" | "student" | "content_creator")[];
    defaultCourseCurrency: "ars" | "pln" | "eur" | "gbp" | "usd";
    inviteOnlyRegistration: boolean;
    primaryColor: string | null;
    contrastColor: string | null;
    unregisteredUserQAAccessibility: boolean;
    QAEnabled: boolean;
    unregisteredUserNewsAccessibility: boolean;
    newsEnabled: boolean;
    unregisteredUserArticlesAccessibility: boolean;
    articlesEnabled: boolean;
    ageLimit: 13 | 16 | null;
    loginPageFiles: string[];
  };
}

export interface UpdateEnforceSSOResponse {
  data: {
    unregisteredUserCoursesAccessibility: boolean;
    enforceSSO: boolean;
    certificateBackgroundImage: string | null;
    companyInformation?: {
      companyName?: string;
      /** @maxLength 10 */
      companyShortName?: string;
      registeredAddress?: string;
      taxNumber?: string;
      emailAddress?: string;
      courtRegisterNumber?: string;
    };
    platformLogoS3Key: string | null;
    loginBackgroundImageS3Key: string | null;
    platformSimpleLogoS3Key: string | null;
    MFAEnforcedRoles: ("admin" | "student" | "content_creator")[];
    defaultCourseCurrency: "ars" | "pln" | "eur" | "gbp" | "usd";
    inviteOnlyRegistration: boolean;
    primaryColor: string | null;
    contrastColor: string | null;
    unregisteredUserQAAccessibility: boolean;
    QAEnabled: boolean;
    unregisteredUserNewsAccessibility: boolean;
    newsEnabled: boolean;
    unregisteredUserArticlesAccessibility: boolean;
    articlesEnabled: boolean;
    ageLimit: 13 | 16 | null;
    loginPageFiles: string[];
  };
}

export interface GetPlatformLogoResponse {
  data: {
    url: string | null;
  };
}

export interface GetPlatformSimpleLogoResponse {
  data: {
    url: string | null;
  };
}

export interface GetLoginBackgroundResponse {
  data: {
    url: string | null;
  };
}

export interface GetCompanyInformationResponse {
  data: {
    companyName?: string;
    /** @maxLength 10 */
    companyShortName?: string;
    registeredAddress?: string;
    taxNumber?: string;
    emailAddress?: string;
    courtRegisterNumber?: string;
  };
}

export interface UpdateCompanyInformationBody {
  companyName?: string;
  /** @maxLength 10 */
  companyShortName?: string;
  registeredAddress?: string;
  taxNumber?: string;
  emailAddress?: string;
  courtRegisterNumber?: string;
}

export interface UpdateCompanyInformationResponse {
  data: {
    companyName?: string;
    /** @maxLength 10 */
    companyShortName?: string;
    registeredAddress?: string;
    taxNumber?: string;
    emailAddress?: string;
    courtRegisterNumber?: string;
  };
}

export interface UpdateMFAEnforcedRolesBody {
  admin?: boolean;
  student?: boolean;
  content_creator?: boolean;
}

export interface UpdateDefaultCourseCurrencyBody {
  defaultCourseCurrency: "ars" | "pln" | "eur" | "gbp" | "usd";
}

export interface UpdateConfigWarningDismissedBody {
  dismissed: boolean;
}

export interface UpdateConfigWarningDismissedResponse {
  data: {
    language: string;
    /** @default false */
    isMFAEnabled: boolean;
    MFASecret: string | null;
    configWarningDismissed: boolean;
  };
}

export interface UpdateAgeLimitBody {
  ageLimit: 13 | 16 | null;
}

export interface GetLoginPageFilesResponse {
  resources: {
    /** @format uuid */
    id: string;
    name: string;
    resourceUrl: string;
  }[];
}

export interface GetAllGroupsResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    characteristic: string | null;
    users?: {
      id: string;
      createdAt: string;
      updatedAt: string;
      email: string | null;
      phone: string | null;
      firstName: string;
      lastName: string;
      role: string;
      archived: boolean;
      deletedAt: string | null;
      profilePictureUrl: string | null;
    }[];
    createdAt?: string;
    updatedAt?: string;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetGroupByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    characteristic: string | null;
    users?: {
      id: string;
      createdAt: string;
      updatedAt: string;
      email: string | null;
      phone: string | null;
      firstName: string;
      lastName: string;
      role: string;
      archived: boolean;
      deletedAt: string | null;
      profilePictureUrl: string | null;
    }[];
    createdAt?: string;
    updatedAt?: string;
  };
}

export interface GetUserGroupsResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    characteristic: string | null;
    users?: {
      id: string;
      createdAt: string;
      updatedAt: string;
      email: string | null;
      phone: string | null;
      firstName: string;
      lastName: string;
      role: string;
      archived: boolean;
      deletedAt: string | null;
      profilePictureUrl: string | null;
    }[];
    createdAt?: string;
    updatedAt?: string;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface CreateGroupBody {
  name: string;
  characteristic?: string;
}

export interface CreateGroupResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpdateGroupBody {
  name: string;
  characteristic?: string;
}

export interface UpdateGroupResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    characteristic?: string;
    createdAt: string;
    updatedAt: string;
    isMandatory?: boolean;
    dueDate?: string | null;
  };
}

export interface DeleteGroupResponse {
  data: {
    message: string;
  };
}

export type BulkDeleteGroupsBody = string[];

export interface BulkDeleteGroupsResponse {
  data: {
    message: string;
  };
}

export type GroupIds = string[];

export interface SetUserGroupsResponse {
  data: {
    message: string;
  };
}

export interface GetGroupsByCourseResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    characteristic?: string;
    createdAt: string;
    updatedAt: string;
    isMandatory?: boolean;
    dueDate?: string | null;
  }[];
}

export interface GetAllCoursesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    thumbnailUrl: string | null;
    description: string;
    /** @format uuid */
    authorId?: string;
    author: string;
    authorAvatarUrl: string | null;
    category: string;
    courseChapterCount: number;
    enrolledParticipantCount: number;
    priceInCents: number;
    mercadopagoPriceInCents: number;
    currency: string;
    status?: "draft" | "published" | "private";
    createdAt?: string;
    hasFreeChapters?: boolean;
    mercadopagoProductId?: string | null;
    duration?: string | null;
    preinscriptionOpen?: boolean;
    isFeatured?: boolean;
    categorySlug?: string | null;
    enrolledCount?: number;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetStudentCoursesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    thumbnailUrl: string | null;
    description: string;
    /** @format uuid */
    authorId?: string;
    author: string;
    authorAvatarUrl: string | null;
    category: string;
    courseChapterCount: number;
    enrolledParticipantCount: number;
    priceInCents: number;
    mercadopagoPriceInCents: number;
    currency: string;
    status?: "draft" | "published" | "private";
    createdAt?: string;
    hasFreeChapters?: boolean;
    mercadopagoProductId?: string | null;
    duration?: string | null;
    completedChapterCount: number;
    courseLessonCount?: number;
    completedLessonCount?: number;
    shownLessonCount?: number;
    shownCompletedLessonCount?: number;
    partialLessonProgress?: number;
    enrolled?: boolean;
    purchased?: boolean;
    preinscribed?: boolean;
    dueDate: string | null;
    slug: string;
    availableLocales: string[];
    baseLanguage: string;
    isFeatured?: boolean;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetStudentsWithEnrollmentDateResponse {
  data: {
    firstName: string;
    lastName: string;
    enrolledAt: string | null;
    groups: {
      /** @format uuid */
      id: string;
      name: string;
    }[];
    /** @format uuid */
    id: string;
    isEnrolledByGroup: boolean;
    phone: string | null;
    accessLevel: ("free_preview" | "full") | null;
    completedLessonCount: number;
    totalLessonCount: number;
    completedClassCount: number;
    totalClassCount: number;
    courseCompletedAt: string | null;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetAvailableCoursesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    thumbnailUrl: string | null;
    description: string;
    /** @format uuid */
    authorId?: string;
    author: string;
    authorAvatarUrl: string | null;
    category: string;
    courseChapterCount: number;
    enrolledParticipantCount: number;
    priceInCents: number;
    mercadopagoPriceInCents: number;
    currency: string;
    status?: "draft" | "published" | "private";
    createdAt?: string;
    hasFreeChapters?: boolean;
    mercadopagoProductId?: string | null;
    duration?: string | null;
    completedChapterCount: number;
    courseLessonCount?: number;
    completedLessonCount?: number;
    shownLessonCount?: number;
    shownCompletedLessonCount?: number;
    partialLessonProgress?: number;
    enrolled?: boolean;
    purchased?: boolean;
    preinscribed?: boolean;
    dueDate: string | null;
    slug: string;
    availableLocales: string[];
    baseLanguage: string;
    isFeatured?: boolean;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetContentCreatorCoursesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    thumbnailUrl: string | null;
    description: string;
    /** @format uuid */
    authorId: string;
    author: string;
    authorAvatarUrl: string | null;
    category: string;
    courseChapterCount: number;
    enrolledParticipantCount: number;
    priceInCents: number;
    mercadopagoPriceInCents: number;
    currency: string;
    status?: "draft" | "published" | "private";
    createdAt?: string;
    hasFreeChapters?: boolean;
    mercadopagoProductId?: string | null;
    duration?: string | null;
    completedChapterCount: number;
    courseLessonCount?: number;
    completedLessonCount?: number;
    shownLessonCount?: number;
    shownCompletedLessonCount?: number;
    partialLessonProgress?: number;
    enrolled?: boolean;
    purchased?: boolean;
    preinscribed?: boolean;
    dueDate: string | null;
    slug: string;
    availableLocales: string[];
    baseLanguage: string;
    isFeatured?: boolean;
  }[];
}

export interface GetCourseResponse {
  data: {
    archived?: boolean;
    /** @format uuid */
    authorId?: string;
    category: string | null;
    categoryId: string | null;
    chapters: {
      /** @format uuid */
      id: string;
      title: string;
      lessonCount: number;
      lessons: {
        /** @format uuid */
        id: string;
        title: string;
        type: "content" | "quiz" | "ai_mentor" | "embed";
        displayOrder: number;
        status: "not_started" | "in_progress" | "completed" | "blocked";
        quizQuestionCount: number | null;
        hasVideo: boolean;
        isSurvey: boolean;
        isExternal?: boolean;
        visibilityCondition?: {
          /** @format uuid */
          questionId: string;
          /** @format uuid */
          optionId: string;
        } | null;
        skippedByCondition?: boolean;
        lessonResources?: {
          /** @format uuid */
          id: string;
          fileUrl: string;
          contentType: string;
          title?: string;
          description?: string;
          fileName?: string;
          allowFullscreen?: boolean;
        }[];
      }[];
      completedLessonCount?: number;
      chapterProgress?: "not_started" | "in_progress" | "completed" | "blocked";
      isFreemium?: boolean;
      enrolled?: boolean;
      isSubmitted?: boolean;
      createdAt?: string;
      updatedAt?: string;
      quizCount?: number;
      displayOrder: number;
    }[];
    completedChapterCount?: number;
    courseChapterCount: number;
    currency: string;
    description: string;
    enrolled?: boolean;
    purchased?: boolean;
    accessLevel?: ("free_preview" | "full") | null;
    hasFreeChapter?: boolean;
    preinscriptionOpen?: boolean;
    partialLessonProgress?: number;
    credentialType?: "none" | "constancia" | "certificado";
    /** @format uuid */
    id: string;
    status: "draft" | "published" | "private";
    isScorm?: boolean;
    priceInCents: number;
    mercadopagoPriceInCents: number;
    isFeatured?: boolean;
    thumbnailUrl?: string;
    title: string;
    slug: string;
    mercadopagoProductId: string | null;
    availableLocales: ("en" | "es")[];
    baseLanguage: "en" | "es";
    dueDate: string | null;
    seoTldr?: string | null;
    aiContext?: {
      geographic?: string[];
      audience?: string[];
      intent?:
        | "how-to-guide"
        | "course-overview"
        | "concept-explanation"
        | "comparison"
        | "case-study"
        | "reference"
        | "opinion"
        | "tutorial";
      topics?: string[];
      cite_when?: string[];
      expertise_level?: "beginner" | "intermediate" | "advanced";
    } | null;
    duration?: string | null;
  };
}

export interface LookupCourseResponse {
  data: {
    status: "found" | "redirect";
    slug?: string;
  };
}

export interface GetBetaCourseByIdResponse {
  data: {
    archived?: boolean;
    /** @format uuid */
    authorId?: string;
    category: string | null;
    categoryId: string | null;
    chapters: {
      /** @format uuid */
      id: string;
      title: string;
      lessonCount: number;
      lessons?: {
        /** @format uuid */
        id: string;
        title: string;
        type: "content" | "quiz" | "ai_mentor" | "embed";
        description?: string | null;
        displayOrder: number;
        fileS3Key?: string | null;
        avatarReferenceUrl?: string;
        fileType?: string | null;
        questions?: {
          /** @format uuid */
          id?: string;
          type:
            | "brief_response"
            | "detailed_response"
            | "match_words"
            | "scale_1_5"
            | "single_choice"
            | "multiple_choice"
            | "true_or_false"
            | "photo_question_single_choice"
            | "photo_question_multiple_choice"
            | "fill_in_the_blanks_text"
            | "fill_in_the_blanks_dnd";
          description?: string | null;
          title: string;
          displayOrder?: number;
          solutionExplanation?: string;
          photoS3Key?: string | null;
          isSurvey?: boolean;
          required?: boolean;
          options?: {
            /** @format uuid */
            id?: string;
            /** @maxLength 250 */
            optionText: string;
            displayOrder: number | null;
            isStudentAnswer?: boolean | null;
            isCorrect: boolean | null;
            /** @format uuid */
            questionId?: string;
            matchedWord?: string | null;
            scaleAnswer?: number | null;
            /** @default "es" */
            language?: "en" | "es";
          }[];
          /** @default "es" */
          language?: "en" | "es";
        }[];
        aiMentor?: {
          /** @format uuid */
          id: string;
          /** @format uuid */
          lessonId: string;
          aiMentorInstructions: string;
          completionConditions: string;
          type: "mentor" | "teacher" | "roleplay";
          avatarReference: string | null;
        } | null;
        completionCriteria?: string | null;
        autoAdvance?: boolean | null;
        persistedFraction?: number;
        outroTitle?: string | null;
        outroBody?: string | null;
        videoWebUrl?: string | null;
        videoMobileUrl?: string | null;
        contentRole?: string | null;
        supplementTitle?: string | null;
        supplementSummary?: string | null;
        supplementEstimatedMinutes?: number | null;
        updatedAt?: string;
      }[];
      completedLessonCount?: number;
      chapterProgress?: "not_started" | "in_progress" | "completed" | "blocked";
      isFreemium?: boolean;
      enrolled?: boolean;
      isSubmitted?: boolean;
      createdAt?: string;
      updatedAt?: string;
      quizCount?: number;
      displayOrder: number;
    }[];
    completedChapterCount?: number;
    courseChapterCount: number;
    currency: string;
    description: string;
    enrolled?: boolean;
    hasFreeChapter?: boolean;
    credentialType?: "none" | "constancia" | "certificado";
    /** @format uuid */
    id: string;
    status: "draft" | "published" | "private";
    isScorm?: boolean;
    priceInCents: number;
    mercadopagoPriceInCents: number;
    isFeatured?: boolean;
    preinscriptionOpen?: boolean;
    mercadopagoProductId?: string | null;
    thumbnailUrl?: string;
    thumbnailS3Key?: string;
    thumbnailS3SingedUrl?: string | null;
    title: string;
    availableLocales: ("en" | "es")[];
    baseLanguage: "en" | "es";
    duration?: string | null;
    seoTldr?: string | null;
    aiContext?: {
      geographic?: string[];
      audience?: string[];
      intent?:
        | "how-to-guide"
        | "course-overview"
        | "concept-explanation"
        | "comparison"
        | "case-study"
        | "reference"
        | "opinion"
        | "tutorial";
      topics?: string[];
      cite_when?: string[];
      expertise_level?: "beginner" | "intermediate" | "advanced";
    } | null;
  };
}

export type CreateCourseBody = {
  title: string;
  description: string;
  status?: "draft" | "published" | "private";
  thumbnailS3Key?: string;
  priceInCents?: number;
  mercadopagoPriceInCents?: number;
  currency?: string;
  /** @format uuid */
  categoryId: string;
  isScorm?: boolean;
  credentialType?: "none" | "constancia" | "certificado";
  duration?: string | null;
  /** @default "es" */
  language: "en" | "es";
} & {
  chapters?: string[];
};

export interface CreateCourseResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpdateCourseBody {
  title?: string;
  description?: string;
  thumbnailS3Key?: string;
  status?: "draft" | "published" | "private";
  priceInCents?: number;
  mercadopagoPriceInCents?: number;
  currency?: string;
  /** @format uuid */
  categoryId?: string;
  chapters?: string[];
  /** @default "es" */
  language?: "en" | "es";
  isFeatured?: boolean;
  preinscriptionOpen?: boolean;
  seoTldr?: string | null;
  aiContext?: {
    geographic?: string[];
    audience?: string[];
    intent?:
      | "how-to-guide"
      | "course-overview"
      | "concept-explanation"
      | "comparison"
      | "case-study"
      | "reference"
      | "opinion"
      | "tutorial";
    topics?: string[];
    cite_when?: string[];
    expertise_level?: "beginner" | "intermediate" | "advanced";
  } | null;
  duration?: string | null;
}

export interface UpdateCourseResponse {
  data: {
    message: string;
  };
}

export interface UpdateCredentialTypeBody {
  credentialType: "none" | "constancia" | "certificado";
}

export interface UpdateCredentialTypeResponse {
  data: {
    message: string;
  };
}

export interface UpdateCourseSettingsBody {
  /** @default false */
  lessonSequenceEnabled?: boolean;
  /** @default true */
  quizFeedbackEnabled?: boolean;
}

export interface UpdateCourseSettingsResponse {
  data: {
    message: string;
  };
}

export interface GetCourseSettingsResponse {
  data: {
    /** @default false */
    lessonSequenceEnabled: boolean;
    /** @default true */
    quizFeedbackEnabled: boolean;
  };
}

export interface GetLessonSequenceEnabledResponse {
  data: {
    lessonSequenceEnabled: boolean;
  };
}

export interface EnrollCourseResponse {
  data: {
    message: string;
  };
}

export interface InstantEnrollResponse {
  data: {
    message: string;
    orderId: string | null;
    accessLevel: "free_preview" | "full";
    outcome:
      | "enrolled"
      | "already_owned"
      | "preinscribed"
      | "upgraded"
      | "pending_payment"
      | "revoked";
  };
}

export interface EnrollCoursesBody {
  studentIds: string[];
}

export interface EnrollCoursesResponse {
  data: {
    message: string;
  };
}

export interface EnrollGroupsToCourseBody {
  groups: {
    /** @format uuid */
    id: string;
    isMandatory: boolean;
    dueDate?: string | null;
  }[];
}

export interface EnrollGroupsToCourseResponse {
  data: {
    message: string;
  };
}

export interface UnenrollGroupsFromCourseBody {
  groupIds: string[];
}

export interface UnenrollGroupsFromCourseResponse {
  data: {
    message: string;
  };
}

export type DeleteCourseResponse = null;

export interface DeleteManyCoursesBody {
  ids: string[];
}

export type DeleteManyCoursesResponse = null;

export type UnenrollCoursesResponse = null;

export interface GetCourseStatisticsResponse {
  data: {
    enrolledCount: number;
    completionPercentage: number;
    averageCompletionPercentage: number;
    courseStatusDistribution: {
      status: "not_started" | "in_progress" | "completed" | "blocked";
      count: number;
    }[];
    averageSeconds: number;
  };
}

export interface GetCourseLearningTimeStatisticsResponse {
  data: {
    users: {
      /** @format uuid */
      id: string;
      name: string;
      studentAvatarUrl: string | null;
      totalSeconds: number;
      groups:
        | {
            id: string;
            name: string;
          }[]
        | null;
    }[];
  };
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetCourseLearningStatisticsFilterOptionsResponse {
  data: {
    groups: {
      /** @format uuid */
      id: string;
      name: string;
    }[];
  };
}

export interface GetAverageQuizScoresResponse {
  data: {
    averageScoresPerQuiz: {
      /** @format uuid */
      quizId: string;
      name: string;
      averageScore: number;
      finishedCount: number;
      passedCount: number;
      lessonOrder: number;
    }[];
  };
}

export interface GetCourseStudentsProgressResponse {
  data: {
    /** @format uuid */
    studentId: string;
    studentName: string;
    studentAvatarUrl: string | null;
    groups:
      | {
          id: string;
          name: string;
        }[]
      | null;
    completedLessonsCount: number;
    lastActivity: string | null;
    lastCompletedLessonName: string | null;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetCourseStudentsQuizResultsResponse {
  data: {
    /** @format uuid */
    studentId: string;
    studentName: string;
    studentAvatarUrl: string | null;
    /** @format uuid */
    lessonId: string;
    quizName: string;
    quizScore: number | null;
    isPassed: boolean;
    attempts: number;
    lastAttempt: string;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetCourseStudentsAiMentorResultsResponse {
  data: {
    /** @format uuid */
    studentId: string;
    studentName: string;
    studentAvatarUrl: string | null;
    /** @format uuid */
    lessonId: string;
    lessonName: string;
    score: number | null;
    lastSession: string;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface TransferCourseOwnershipBody {
  /** @format uuid */
  courseId: string;
  /** @format uuid */
  userId: string;
}

export interface GetCourseOwnershipResponse {
  data: {
    currentAuthor: {
      /** @format uuid */
      id: string;
      name: string;
      phone: string | null;
    };
    possibleCandidates: {
      /** @format uuid */
      id: string;
      name: string;
      phone: string | null;
    }[];
  };
}

export interface GetDeletionImpactResponse {
  data: {
    affectedStudents: number;
    studentsWithProgress: number;
    studentsWithAnswers: number;
    preinscriptions: number;
  };
}

export interface GetPublishChecklistResponse {
  data: {
    isPublishable: boolean;
    blockingCount: number;
    warningCount: number;
    items: {
      key: string;
      ok: boolean;
      severity: "blocking" | "warning";
      label: string;
      detail?: string;
    }[];
    issues: {
      rule: string;
      severity: "blocking" | "warning";
      message: string;
      chapterTitle?: string;
      lessonTitle?: string;
      lessonDisplayOrder?: number | null;
    }[];
  };
}

export interface DuplicateCourseResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface GetChapterWithLessonResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    lessonCount: number;
    lessons: {
      /** @format uuid */
      id: string;
      title: string;
      type: "content" | "quiz" | "ai_mentor" | "embed";
      displayOrder: number;
      status: "not_started" | "in_progress" | "completed" | "blocked";
      quizQuestionCount: number | null;
      hasVideo: boolean;
      isSurvey: boolean;
      isExternal?: boolean;
      visibilityCondition?: {
        /** @format uuid */
        questionId: string;
        /** @format uuid */
        optionId: string;
      } | null;
      skippedByCondition?: boolean;
      lessonResources?: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string;
        title?: string;
        description?: string;
        fileName?: string;
        allowFullscreen?: boolean;
      }[];
    }[];
    completedLessonCount?: number;
    chapterProgress?: "not_started" | "in_progress" | "completed" | "blocked";
    isFreemium?: boolean;
    enrolled?: boolean;
    isSubmitted?: boolean;
    createdAt?: string;
    updatedAt?: string;
    quizCount?: number;
    displayOrder: number;
  };
}

export type BetaCreateChapterBody = {
  title: string;
  lessons?: {
    /** @format uuid */
    id: string;
    title: string;
    type: "content" | "quiz" | "ai_mentor" | "embed";
    description?: string | null;
    displayOrder: number;
    fileS3Key?: string | null;
    avatarReferenceUrl?: string;
    fileType?: string | null;
    questions?: {
      /** @format uuid */
      id?: string;
      type:
        | "brief_response"
        | "detailed_response"
        | "match_words"
        | "scale_1_5"
        | "single_choice"
        | "multiple_choice"
        | "true_or_false"
        | "photo_question_single_choice"
        | "photo_question_multiple_choice"
        | "fill_in_the_blanks_text"
        | "fill_in_the_blanks_dnd";
      description?: string | null;
      title: string;
      displayOrder?: number;
      solutionExplanation?: string;
      photoS3Key?: string | null;
      isSurvey?: boolean;
      required?: boolean;
      options?: {
        /** @format uuid */
        id?: string;
        /** @maxLength 250 */
        optionText: string;
        displayOrder: number | null;
        isStudentAnswer?: boolean | null;
        isCorrect: boolean | null;
        /** @format uuid */
        questionId?: string;
        matchedWord?: string | null;
        scaleAnswer?: number | null;
        /** @default "es" */
        language?: "en" | "es";
      }[];
      /** @default "es" */
      language?: "en" | "es";
    }[];
    aiMentor?: {
      /** @format uuid */
      id: string;
      /** @format uuid */
      lessonId: string;
      aiMentorInstructions: string;
      completionConditions: string;
      type: "mentor" | "teacher" | "roleplay";
      avatarReference: string | null;
    } | null;
    completionCriteria?: string | null;
    autoAdvance?: boolean | null;
    persistedFraction?: number;
    outroTitle?: string | null;
    outroBody?: string | null;
    videoWebUrl?: string | null;
    videoMobileUrl?: string | null;
    contentRole?: string | null;
    supplementTitle?: string | null;
    supplementSummary?: string | null;
    supplementEstimatedMinutes?: number | null;
    updatedAt?: string;
  }[];
  chapterProgress?: "not_started" | "in_progress" | "completed" | "blocked";
  isFreemium?: boolean;
  enrolled?: boolean;
  isSubmitted?: boolean;
  createdAt?: string;
  updatedAt?: string;
  quizCount?: number;
} & {
  /** @format uuid */
  courseId: string;
};

export interface BetaCreateChapterResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export type UpdateChapterBody = ({
  title?: string;
  lessons?: {
    /** @format uuid */
    id: string;
    title: string;
    type: "content" | "quiz" | "ai_mentor" | "embed";
    description?: string | null;
    displayOrder: number;
    fileS3Key?: string | null;
    avatarReferenceUrl?: string;
    fileType?: string | null;
    questions?: {
      /** @format uuid */
      id?: string;
      type:
        | "brief_response"
        | "detailed_response"
        | "match_words"
        | "scale_1_5"
        | "single_choice"
        | "multiple_choice"
        | "true_or_false"
        | "photo_question_single_choice"
        | "photo_question_multiple_choice"
        | "fill_in_the_blanks_text"
        | "fill_in_the_blanks_dnd";
      description?: string | null;
      title: string;
      displayOrder?: number;
      solutionExplanation?: string;
      photoS3Key?: string | null;
      isSurvey?: boolean;
      required?: boolean;
      options?: {
        /** @format uuid */
        id?: string;
        /** @maxLength 250 */
        optionText: string;
        displayOrder: number | null;
        isStudentAnswer?: boolean | null;
        isCorrect: boolean | null;
        /** @format uuid */
        questionId?: string;
        matchedWord?: string | null;
        scaleAnswer?: number | null;
        /** @default "es" */
        language?: "en" | "es";
      }[];
      /** @default "es" */
      language?: "en" | "es";
    }[];
    aiMentor?: {
      /** @format uuid */
      id: string;
      /** @format uuid */
      lessonId: string;
      aiMentorInstructions: string;
      completionConditions: string;
      type: "mentor" | "teacher" | "roleplay";
      avatarReference: string | null;
    } | null;
    completionCriteria?: string | null;
    autoAdvance?: boolean | null;
    persistedFraction?: number;
    outroTitle?: string | null;
    outroBody?: string | null;
    videoWebUrl?: string | null;
    videoMobileUrl?: string | null;
    contentRole?: string | null;
    supplementTitle?: string | null;
    supplementSummary?: string | null;
    supplementEstimatedMinutes?: number | null;
    updatedAt?: string;
  }[];
  chapterProgress?: "not_started" | "in_progress" | "completed" | "blocked";
  isFreemium?: boolean;
  enrolled?: boolean;
  isSubmitted?: boolean;
  createdAt?: string;
  updatedAt?: string;
  quizCount?: number;
} & {
  /** @format uuid */
  courseId?: string;
}) & {
  /** @default "es" */
  language: "en" | "es";
};

export interface UpdateChapterResponse {
  data: {
    message: string;
  };
}

export interface UpdateChapterDisplayOrderBody {
  /** @format uuid */
  chapterId: string;
  displayOrder: number;
}

export interface UpdateChapterDisplayOrderResponse {
  data: {
    message: string;
  };
}

export interface RemoveChapterResponse {
  data: {
    message: string;
  };
}

export interface UpdateFreemiumStatusBody {
  isFreemium: boolean;
}

export interface UpdateFreemiumStatusResponse {
  data: {
    message: string;
  };
}

export interface GetLessonsResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    type: "content" | "quiz" | "ai_mentor" | "embed";
    description: string | null;
    displayOrder: number;
    lessonCompleted?: boolean;
    /** @format uuid */
    courseId: string;
    courseTitle: string;
    /** @format uuid */
    chapterId: string;
    chapterTitle: string;
    chapterDisplayOrder: number;
    searchRank?: number;
  }[];
}

export interface GetLessonByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    type: "content" | "quiz" | "ai_mentor" | "embed";
    description: string | null;
    fileType: string | null;
    fileUrl: string | null;
    quizDetails?: {
      questions: {
        /** @format uuid */
        id: string;
        type:
          | "brief_response"
          | "detailed_response"
          | "match_words"
          | "scale_1_5"
          | "single_choice"
          | "multiple_choice"
          | "true_or_false"
          | "photo_question_single_choice"
          | "photo_question_multiple_choice"
          | "fill_in_the_blanks_text"
          | "fill_in_the_blanks_dnd";
        description?: string | null;
        title: string;
        displayOrder?: number;
        solutionExplanation: string | null;
        photoS3Key?: string | null;
        isSurvey?: boolean;
        required?: boolean;
        options?: {
          /** @format uuid */
          id: string;
          optionText: string | null;
          displayOrder: number | null;
          isStudentAnswer: boolean | null;
          studentAnswer: string | null;
          isCorrect: boolean | null;
          /** @format uuid */
          questionId?: string;
        }[];
        /** @default "es" */
        language?: "en" | "es";
        passQuestion: boolean | null;
      }[];
      questionCount: number;
      correctAnswerCount: number | null;
      wrongAnswerCount: number | null;
      score: number | null;
    };
    lessonCompleted?: boolean;
    thresholdScore: number | null;
    attemptsLimit: number | null;
    quizCooldownInHours: number | null;
    isSurvey?: boolean;
    completionCriteria?: string | null;
    autoAdvance?: boolean | null;
    persistedFraction?: number;
    outroTitle?: string | null;
    outroBody?: string | null;
    videoWebUrl?: string | null;
    videoMobileUrl?: string | null;
    contentRole?: string | null;
    supplementTitle?: string | null;
    supplementSummary?: string | null;
    supplementEstimatedMinutes?: number | null;
    isQuizPassed: boolean | null;
    attempts: number | null;
    scrollFraction?: number | null;
    videoPositionSeconds?: number | null;
    videoWatchedSeconds?: number | null;
    videoDurationSeconds?: number | null;
    videoWatchedRanges?: [number, number][] | null;
    updatedAt: string | null;
    displayOrder: number;
    isExternal?: boolean;
    nextLessonId: string | null;
    userLanguage?: "en" | "es";
    status?: "active" | "completed" | "archived";
    /** @format uuid */
    threadId?: string;
    hasPreviousAttempt?: boolean;
    lessonResources?: {
      /** @format uuid */
      id: string;
      fileUrl: string;
      contentType: string;
      title?: string;
      description?: string;
      fileName?: string;
      allowFullscreen?: boolean;
    }[];
    hasOnlyVideo?: boolean;
    hasVideo?: boolean;
    isQuizFeedbackRedacted?: boolean;
    aiMentorDetails?: {
      minScore: number | null;
      maxScore: number | null;
      score: number | null;
      percentage: number | null;
      requiredScore: number | null;
    } | null;
    aiMentor?: {
      name: string;
      avatarReferenceUrl?: string;
    } | null;
  };
}

export type BetaCreateLessonBody = {
  title: string;
  type: "content" | "quiz" | "ai_mentor" | "embed";
  description?: string | null;
  fileS3Key?: string | null;
  avatarReferenceUrl?: string;
  fileType?: string | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "brief_response"
      | "detailed_response"
      | "match_words"
      | "scale_1_5"
      | "single_choice"
      | "multiple_choice"
      | "true_or_false"
      | "photo_question_single_choice"
      | "photo_question_multiple_choice"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string;
    photoS3Key?: string | null;
    isSurvey?: boolean;
    required?: boolean;
    options?: {
      /** @format uuid */
      id?: string;
      /** @maxLength 250 */
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean | null;
      /** @format uuid */
      questionId?: string;
      matchedWord?: string | null;
      scaleAnswer?: number | null;
      /** @default "es" */
      language?: "en" | "es";
    }[];
    /** @default "es" */
    language?: "en" | "es";
  }[];
  aiMentor?: {
    /** @format uuid */
    id: string;
    /** @format uuid */
    lessonId: string;
    aiMentorInstructions: string;
    completionConditions: string;
    type: "mentor" | "teacher" | "roleplay";
    avatarReference: string | null;
  } | null;
  completionCriteria?: string | null;
  autoAdvance?: boolean | null;
  persistedFraction?: number;
  outroTitle?: string | null;
  outroBody?: string | null;
  videoWebUrl?: string | null;
  videoMobileUrl?: string | null;
  contentRole?: string | null;
  supplementTitle?: string | null;
  supplementSummary?: string | null;
  supplementEstimatedMinutes?: number | null;
  updatedAt?: string;
} & {
  /** @format uuid */
  chapterId: string;
  displayOrder?: number;
  contextId?: string;
  visibilityCondition?: {
    /** @format uuid */
    questionId: string;
    /** @format uuid */
    optionId: string;
  } | null;
};

export interface BetaCreateLessonResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface InitializeLessonContextResponse {
  data: {
    /** @format uuid */
    contextId: string;
  };
}

export type BetaCreateAiMentorLessonBody = {
  title: string;
  description?: string | null;
  fileS3Key?: string | null;
  avatarReferenceUrl?: string;
  fileType?: string | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "brief_response"
      | "detailed_response"
      | "match_words"
      | "scale_1_5"
      | "single_choice"
      | "multiple_choice"
      | "true_or_false"
      | "photo_question_single_choice"
      | "photo_question_multiple_choice"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string;
    photoS3Key?: string | null;
    isSurvey?: boolean;
    required?: boolean;
    options?: {
      /** @format uuid */
      id?: string;
      /** @maxLength 250 */
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean | null;
      /** @format uuid */
      questionId?: string;
      matchedWord?: string | null;
      scaleAnswer?: number | null;
      /** @default "es" */
      language?: "en" | "es";
    }[];
    /** @default "es" */
    language?: "en" | "es";
  }[];
  aiMentor?: {
    /** @format uuid */
    id: string;
    /** @format uuid */
    lessonId: string;
    aiMentorInstructions: string;
    completionConditions: string;
    type: "mentor" | "teacher" | "roleplay";
    avatarReference: string | null;
  } | null;
  completionCriteria?: string | null;
  autoAdvance?: boolean | null;
  persistedFraction?: number;
  outroTitle?: string | null;
  outroBody?: string | null;
  videoWebUrl?: string | null;
  videoMobileUrl?: string | null;
  contentRole?: string | null;
  supplementTitle?: string | null;
  supplementSummary?: string | null;
  supplementEstimatedMinutes?: number | null;
  updatedAt?: string;
} & {
  /** @format uuid */
  chapterId: string;
  displayOrder?: number;
  aiMentorInstructions: string;
  completionConditions: string;
  type: "mentor" | "teacher" | "roleplay";
  name?: string;
};

export interface BetaCreateAiMentorLessonResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export type BetaUpdateAiMentorLessonBody = ({
  title: string;
  description?: string | null;
  fileS3Key?: string | null;
  avatarReferenceUrl?: string;
  fileType?: string | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "brief_response"
      | "detailed_response"
      | "match_words"
      | "scale_1_5"
      | "single_choice"
      | "multiple_choice"
      | "true_or_false"
      | "photo_question_single_choice"
      | "photo_question_multiple_choice"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string;
    photoS3Key?: string | null;
    isSurvey?: boolean;
    required?: boolean;
    options?: {
      /** @format uuid */
      id?: string;
      /** @maxLength 250 */
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean | null;
      /** @format uuid */
      questionId?: string;
      matchedWord?: string | null;
      scaleAnswer?: number | null;
      /** @default "es" */
      language?: "en" | "es";
    }[];
    /** @default "es" */
    language?: "en" | "es";
  }[];
  aiMentor?: {
    /** @format uuid */
    id: string;
    /** @format uuid */
    lessonId: string;
    aiMentorInstructions: string;
    completionConditions: string;
    type: "mentor" | "teacher" | "roleplay";
    avatarReference: string | null;
  } | null;
  completionCriteria?: string | null;
  autoAdvance?: boolean | null;
  persistedFraction?: number;
  outroTitle?: string | null;
  outroBody?: string | null;
  videoWebUrl?: string | null;
  videoMobileUrl?: string | null;
  contentRole?: string | null;
  supplementTitle?: string | null;
  supplementSummary?: string | null;
  supplementEstimatedMinutes?: number | null;
  updatedAt?: string;
} & {
  aiMentorInstructions: string;
  completionConditions: string;
  type: "mentor" | "teacher" | "roleplay";
  name?: string;
}) & {
  /** @default "es" */
  language: "en" | "es";
};

export interface BetaUpdateAiMentorLessonResponse {
  data: {
    message: string;
  };
}

export type BetaCreateQuizLessonBody = {
  title: string;
  type: string;
  description?: string;
  solutionExplanation?: string;
  fileS3Key?: string;
  fileType?: string;
  thresholdScore: number;
  attemptsLimit: number | null;
  quizCooldownInHours: number | null;
  isSurvey?: boolean;
  outroTitle?: string | null;
  outroBody?: string | null;
  autoAdvance?: boolean | null;
  visibilityCondition?: {
    /** @format uuid */
    questionId: string;
    /** @format uuid */
    optionId: string;
  } | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "brief_response"
      | "detailed_response"
      | "match_words"
      | "scale_1_5"
      | "single_choice"
      | "multiple_choice"
      | "true_or_false"
      | "photo_question_single_choice"
      | "photo_question_multiple_choice"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string;
    photoS3Key?: string | null;
    isSurvey?: boolean;
    required?: boolean;
    options?: {
      /** @format uuid */
      id?: string;
      /** @maxLength 250 */
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean | null;
      /** @format uuid */
      questionId?: string;
      matchedWord?: string | null;
      scaleAnswer?: number | null;
      /** @default "es" */
      language?: "en" | "es";
    }[];
    /** @default "es" */
    language?: "en" | "es";
  }[];
} & {
  /** @format uuid */
  chapterId: string;
  displayOrder?: number;
};

export interface BetaCreateQuizLessonResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export type BetaUpdateQuizLessonBody = ({
  title?: string;
  type?: string;
  description?: string;
  solutionExplanation?: string;
  fileS3Key?: string;
  fileType?: string;
  thresholdScore?: number;
  attemptsLimit?: number | null;
  quizCooldownInHours?: number | null;
  isSurvey?: boolean;
  outroTitle?: string | null;
  outroBody?: string | null;
  autoAdvance?: boolean | null;
  visibilityCondition?: {
    /** @format uuid */
    questionId: string;
    /** @format uuid */
    optionId: string;
  } | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "brief_response"
      | "detailed_response"
      | "match_words"
      | "scale_1_5"
      | "single_choice"
      | "multiple_choice"
      | "true_or_false"
      | "photo_question_single_choice"
      | "photo_question_multiple_choice"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string;
    photoS3Key?: string | null;
    isSurvey?: boolean;
    required?: boolean;
    options?: {
      /** @format uuid */
      id?: string;
      /** @maxLength 250 */
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean | null;
      /** @format uuid */
      questionId?: string;
      matchedWord?: string | null;
      scaleAnswer?: number | null;
      /** @default "es" */
      language?: "en" | "es";
    }[];
    /** @default "es" */
    language?: "en" | "es";
  }[];
} & {
  /** @format uuid */
  chapterId?: string;
  displayOrder?: number;
}) & {
  /** @default "es" */
  language: "en" | "es";
};

export interface BetaUpdateQuizLessonResponse {
  data: {
    message: string;
    disabledConditions: number;
  };
}

export type BetaUpdateLessonBody = ({
  title?: string;
  type?: "content" | "quiz" | "ai_mentor" | "embed";
  description?: string | null;
  fileS3Key?: string | null;
  avatarReferenceUrl?: string;
  fileType?: string | null;
  questions?: {
    /** @format uuid */
    id?: string;
    type:
      | "brief_response"
      | "detailed_response"
      | "match_words"
      | "scale_1_5"
      | "single_choice"
      | "multiple_choice"
      | "true_or_false"
      | "photo_question_single_choice"
      | "photo_question_multiple_choice"
      | "fill_in_the_blanks_text"
      | "fill_in_the_blanks_dnd";
    description?: string | null;
    title: string;
    displayOrder?: number;
    solutionExplanation?: string;
    photoS3Key?: string | null;
    isSurvey?: boolean;
    required?: boolean;
    options?: {
      /** @format uuid */
      id?: string;
      /** @maxLength 250 */
      optionText: string;
      displayOrder: number | null;
      isStudentAnswer?: boolean | null;
      isCorrect: boolean | null;
      /** @format uuid */
      questionId?: string;
      matchedWord?: string | null;
      scaleAnswer?: number | null;
      /** @default "es" */
      language?: "en" | "es";
    }[];
    /** @default "es" */
    language?: "en" | "es";
  }[];
  aiMentor?: {
    /** @format uuid */
    id: string;
    /** @format uuid */
    lessonId: string;
    aiMentorInstructions: string;
    completionConditions: string;
    type: "mentor" | "teacher" | "roleplay";
    avatarReference: string | null;
  } | null;
  completionCriteria?: string | null;
  autoAdvance?: boolean | null;
  persistedFraction?: number;
  outroTitle?: string | null;
  outroBody?: string | null;
  videoWebUrl?: string | null;
  videoMobileUrl?: string | null;
  contentRole?: string | null;
  supplementTitle?: string | null;
  supplementSummary?: string | null;
  supplementEstimatedMinutes?: number | null;
  updatedAt?: string;
} & {
  /** @format uuid */
  chapterId?: string;
  displayOrder?: number;
  contextId?: string;
  visibilityCondition?: {
    /** @format uuid */
    questionId: string;
    /** @format uuid */
    optionId: string;
  } | null;
}) & {
  /** @default "es" */
  language: "en" | "es";
  descriptionEditor?: "visual" | "html";
  discardRichContent?: boolean;
};

export interface BetaUpdateLessonResponse {
  data: {
    message: string;
  };
}

export interface RemoveLessonResponse {
  data: {
    message: string;
  };
}

export interface EvaluationQuizBody {
  /** @format uuid */
  lessonId: string;
  questionsAnswers: {
    /** @format uuid */
    questionId: string;
    answers: (
      | {
          /** @format uuid */
          answerId: string;
        }
      | {
          value: string;
        }
      | {
          /** @format uuid */
          answerId: string;
          value: string;
        }
    )[];
  }[];
  language: "en" | "es";
}

export interface EvaluationQuizResponse {
  data: {
    message: string;
    data: {
      correctAnswerCount: number;
      wrongAnswerCount: number;
      questionCount: number;
      score: number | null;
    };
  };
}

export interface DeleteStudentQuizAnswersResponse {
  data: {
    message: string;
  };
}

export interface SaveQuestionAnswerBody {
  /** @format uuid */
  questionId: string;
  /** @minItems 1 */
  answers: (
    | {
        /** @format uuid */
        answerId: string;
      }
    | {
        value: string;
      }
    | {
        /** @format uuid */
        answerId: string;
        value: string;
      }
  )[];
  language: "en" | "es";
}

export interface SaveQuestionAnswerResponse {
  data: {
    message: string;
    data: {
      completedQuestionCount: number;
      questionCount: number;
    };
  };
}

export interface GetStudentAnswersForLessonResponse {
  data: {
    completedQuestionCount: number;
    questionCount: number;
    answers: {
      /** @format uuid */
      questionId: string;
      answers: {
        answerId: string | null;
        value: string;
      }[];
    }[];
  };
}

export interface CreateEmbedLessonBody {
  title: string;
  type: "content" | "quiz" | "ai_mentor" | "embed";
  /** @format uuid */
  chapterId: string;
  resources: {
    /** @format uuid */
    id?: string;
    fileUrl: string;
    allowFullscreen?: boolean;
  }[];
}

export interface CreateEmbedLessonResponse {
  data: {
    message: string;
  };
}

export interface UpdateEmbedLessonBody {
  title: string;
  type: "content" | "quiz" | "ai_mentor" | "embed";
  resources: {
    /** @format uuid */
    id?: string;
    fileUrl: string;
    allowFullscreen?: boolean;
  }[];
  /** @format uuid */
  lessonId: string;
  /** @default "es" */
  language: "en" | "es";
}

export interface UpdateEmbedLessonResponse {
  data: {
    message: string;
  };
}

export interface UpdateLessonDisplayOrderBody {
  /** @format uuid */
  lessonId: string;
  displayOrder: number;
}

export interface UpdateLessonDisplayOrderResponse {
  data: {
    message: string;
  };
}

export interface MarkLessonAsCompletedResponse {
  data: {
    message: string;
  };
}

export interface SaveLessonProgressBody {
  /**
   * @min 0
   * @max 1
   */
  scrollFraction?: number;
  /** @min 0 */
  videoPositionSeconds?: number;
  /** @min 0 */
  videoWatchedSeconds?: number;
  /** @min 0 */
  videoDurationSeconds?: number;
  /** @maxItems 500 */
  videoWatchedRanges?: [number, number][];
}

export interface SaveLessonProgressResponse {
  data: {
    message: string;
  };
}

export interface GetAllCertificatesResponse {
  data: {
    /** @format uuid */
    id: string;
    userId: string | null;
    courseId: string | null;
    code: string;
    type: "none" | "constancia" | "certificado";
    courseTitle?: string | null;
    completionDate?: string | null;
    fullName?: string | null;
    issuedAt: string;
    createdAt: string;
    signerName: string | null;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export type GetCertificateResponse = {
  /** @format uuid */
  id: string;
  userId: string | null;
  courseId: string | null;
  code: string;
  type: "none" | "constancia" | "certificado";
  courseTitle?: string | null;
  completionDate?: string | null;
  fullName?: string | null;
  issuedAt: string;
  createdAt: string;
  signerName: string | null;
}[];

export interface VerifyCredentialResponse {
  data: {
    status: "valid" | "revoked" | "not_found";
    code?: string;
    type?: "none" | "constancia" | "certificado";
    holderName?: string;
    courseTitle?: string;
    completedAt?: string;
    issuedAt?: string;
    revokedAt?: string;
    signerName?: string | null;
  };
}

export interface RevokeCredentialBody {
  /**
   * @minLength 3
   * @maxLength 500
   */
  reason: string;
}

export interface RevokeCredentialResponse {
  data: {
    message: string;
  };
}

export interface RevokeCredentialByCodeBody {
  /**
   * @minLength 3
   * @maxLength 500
   */
  reason: string;
}

export interface RevokeCredentialByCodeResponse {
  data: {
    message: string;
  };
}

export interface ListAdminCredentialsResponse {
  data: {
    /** @format uuid */
    id: string;
    code: string;
    type: "none" | "constancia" | "certificado";
    status: "valid" | "revoked";
    holderName: string;
    courseTitle: string;
    courseId: string | null;
    userId: string | null;
    userPhone: string | null;
    userDeleted: boolean;
    issuedAt: string;
    completedAt: string;
    revokedAt: string | null;
    revocationReason: string | null;
    nameCorrections: number;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface CorrectCredentialHolderNameBody {
  /**
   * @minLength 2
   * @maxLength 120
   */
  holderName: string;
  /** @maxLength 500 */
  reason?: string;
}

export interface CorrectCredentialHolderNameResponse {
  data: {
    /** @format uuid */
    id: string;
    code: string;
    type: "none" | "constancia" | "certificado";
    status: "valid" | "revoked";
    holderName: string;
    courseTitle: string;
    courseId: string | null;
    userId: string | null;
    userPhone: string | null;
    userDeleted: boolean;
    issuedAt: string;
    completedAt: string;
    revokedAt: string | null;
    revocationReason: string | null;
    nameCorrections: number;
  };
}

export interface GetCredentialHolderNameHistoryResponse {
  data: {
    at: string;
    before: string;
    after: string;
    reason: string | null;
    actorName: string;
    /** @format uuid */
    actorId: string;
  }[];
}

export interface GetThreadResponse {
  data: {
    /** @format uuid */
    id: string;
    /** @format uuid */
    aiMentorLessonId: string;
    /** @format uuid */
    userId: string;
    userLanguage: "en" | "es";
    createdAt: string;
    updatedAt: string;
    status: "active" | "completed" | "archived";
  };
}

export interface GetThreadMessagesResponse {
  data: (({
    content: string;
  } & {
    role: "system" | "user" | "assistant" | "tool" | "summary";
    userName?: string | null;
  }) & {
    id: string;
    isJudge: boolean;
    createdAt: string;
  })[];
}

export interface StreamChatBody {
  /** @format uuid */
  threadId: string;
  /** @minLength 1 */
  content: string;
  /** @format uuid */
  id?: string;
}

export interface JudgeThreadResponse {
  data: {
    summary: string;
    passed: boolean;
  };
}

export interface GetEvaluationsResponse {
  data: {
    /** @format uuid */
    id: string;
    createdAt: string;
    passed: boolean;
    summary: string;
    score: number | null;
    maxScore: number | null;
    percentage: number | null;
  }[];
}

export interface GetAllAssignedDocumentsForLessonResponse {
  data: {
    /** @format uuid */
    id: string;
    name: string;
    type: string;
    size: number;
  }[];
}

export interface GetAuthAttemptsResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    attemptId: string | null;
    context: string;
    surface: string | null;
    phone: string;
    phoneCountry: string | null;
    userId: string | null;
    registrationAttemptId: string | null;
    outcome: string;
    blockReason: string | null;
    verifiedAt: string | null;
    verifyFailures: number;
    lastVerifyError: string | null;
    turnstileTier: string | null;
    turnstileOutcome: string | null;
    turnstileErrorCodes: string[];
    turnstileClientError: string | null;
    turnstileWaitMs: number | null;
    escalated: boolean;
    honeypot: boolean;
    fillMs: number | null;
    interactions: number | null;
    webdriver: boolean | null;
    riskFlags: string[];
    ip: string | null;
    ipCountry: string | null;
    ipAsn: number | null;
    ipOrg: string | null;
    userAgent: string | null;
    anonymousId: string | null;
    analyticsConsent: boolean | null;
    clarityProjectId: string | null;
    clarityUserId: string | null;
    claritySessionId: string | null;
    claritySource: string | null;
    clarityUrl: string | null;
    deviceLabel: string | null;
    user: {
      id: string;
      firstName: string;
      lastName: string;
    } | null;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetAuthAttemptsStatsResponse {
  data: {
    login: {
      attempts: number;
      sent: number;
      verified: number;
      unknownPhone: number;
      blocked: number;
    };
    register: {
      attempts: number;
      sent: number;
      verified: number;
      blocked: number;
    };
    bot: {
      submissions: number;
      silentPass: number;
      managedPass: number;
      stepUps: number;
      blocked: number;
      missingToken: number;
      avgWaitMs: number | null;
      p90WaitMs: number | null;
      escalations: number;
      managedSolved: number;
      abandoned: number;
      widgetErrors: number;
      scriptUnavailable: number;
      byReason: {
        reason: string;
        count: number;
      }[];
      byNetwork: {
        asn: number | null;
        org: string | null;
        country: string | null;
        submissions: number;
        problems: number;
      }[];
    };
    daily: {
      date: string;
      logins: number;
      registers: number;
      blocked: number;
      stepUps: number;
    }[];
  };
}

export interface GetAuthBotEventsResponse {
  data: {
    id: string;
    createdAt: string;
    attemptId: string | null;
    surface: string | null;
    event: string;
    tier: string | null;
    clientError: string | null;
    waitMs: number | null;
    ip: string | null;
    ipCountry: string | null;
    ipAsn: number | null;
    ipOrg: string | null;
    userAgent: string | null;
    anonymousId: string | null;
    analyticsConsent: boolean | null;
    clarityProjectId: string | null;
    clarityUserId: string | null;
    claritySessionId: string | null;
    claritySource: string | null;
    clarityUrl: string | null;
    deviceLabel: string | null;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetAuthCloudflareAnalyticsResponse {
  data: {
    enabled: boolean;
    error?: string | null;
    days?: number;
    from?: string;
    to?: string;
    totals?: {
      issued: number;
      solved: number;
      nonInteractiveSolved: number;
      interactiveSolved: number;
      siteverified: number;
    };
    byEventType?: {
      eventType: string;
      count: number;
    }[];
    byNetwork?: {
      asn: number | null;
      countryCode: string | null;
      issued: number;
      solved: number;
    }[];
    byBrowser?: {
      browserName: string | null;
      issued: number;
      solved: number;
    }[];
    byAction?: {
      action: string | null;
      issued: number;
      solved: number;
    }[];
  };
}

export interface ReportAuthBotEventBody {
  event: "escalated" | "managed_solved" | "widget_error" | "script_unavailable" | "abandoned";
  /** @format uuid */
  attemptId?: string;
  surface?:
    | "login"
    | "register"
    | "enroll"
    | "checkout_login"
    | "checkout_register"
    | "change_phone";
  tier?: "invisible" | "managed";
  /** @maxLength 64 */
  clientError?: string;
  /** @min 0 */
  waitMs?: number;
  /** @maxLength 200 */
  clarity?: string;
}

export interface GetVisitStatusResponse {
  data: {
    ingestEnabled: boolean;
    geoipEnabled: boolean;
    firstVisitAt: string | null;
    lastVisitAt: string | null;
    last24h: {
      documents: number;
      realDocuments: number;
    };
  };
}

export interface GetVisitSummaryResponse {
  data: {
    range: {
      from: string;
      to: string;
      days: number;
      includesToday: boolean;
      granularity: "hour" | "day";
      compare: boolean;
    };
    surface: "site" | "app" | "all";
    /** @format date-time */
    fetchedAt: string;
    firstVisitAt: string | null;
    geoipEnabled: boolean;
    kpis: {
      sessions: number;
      visitors: number;
      pageviews: number;
      pagesPerSession: number;
      bounceRate: number;
      newVisitors: number;
      returningVisitors: number;
      documentRequests: number;
      notRendered: number;
      bots: number;
      prefetchesNotOpened: number;
      prefetchesOpened: number;
    };
    previous: {
      sessions: number;
      visitors: number;
      pageviews: number;
      pagesPerSession: number;
      bounceRate: number;
      newVisitors: number;
      returningVisitors: number;
      documentRequests: number;
      notRendered: number;
      bots: number;
      prefetchesNotOpened: number;
      prefetchesOpened: number;
    } | null;
    bySurface: {
      surface: string;
      sessions: number;
      pageviews: number;
    }[];
    series: {
      day: string;
      hour?: number;
      sessions: number;
      pageviews: number;
      documentRequests: number;
    }[];
    sources: {
      channel: string;
      source: string;
      medium: string | null;
      sessions: number;
      pageviews: number;
    }[];
    campaigns: {
      campaign: string;
      sessions: number;
    }[];
    pages: {
      path: string;
      views: number;
    }[];
    countries: {
      country: string | null;
      sessions: number;
    }[];
    devices: {
      deviceType: string | null;
      label: string | null;
      sessions: number;
    }[];
    inApp: {
      app: string;
      sessions: number;
    }[];
    tiktok: {
      adClicks: number;
      realVisits: number;
      preloadsByUa: number;
      preloadsOpened: number;
      notRendered: number;
      hiddenFirst: number;
    };
  };
}

export interface GetVisitRealtimeResponse {
  data: {
    fetchedAt: string;
    activeVisitors: number;
    pageviews: number;
    byMinute: {
      minutesAgo: number;
      pageviews: number;
    }[];
    topPaths: {
      path: string;
      views: number;
    }[];
  };
}

export interface GetVisitSessionsResponse {
  data: {
    range: {
      from: string;
      to: string;
      days: number;
    };
    fetchedAt: string;
    clarityProjectId: string | null;
    kpis: {
      sessions: number;
      rendered: number;
      withRecording: number;
      recordingCoverage: number;
      viewedCourse: number;
      clickedCta: number;
      reachedSignup: number;
      otpRequested: number;
      registered: number;
    };
    filterOptions: {
      sources: string[];
      mediums: string[];
      campaigns: string[];
    };
    sessions: {
      id: string;
      startedAt: string;
      endedAt: string;
      durationSec: number | null;
      landingPath: string;
      utm: {
        source: string | null;
        medium: string | null;
        campaign: string | null;
        content: string | null;
        term: string | null;
      };
      clickIdType: string | null;
      referrerHost: string | null;
      deviceType: string | null;
      deviceLabel: string | null;
      inApp: string | null;
      country: string | null;
      pages: number;
      rendered: boolean;
      funnel: {
        viewedCourse: boolean;
        clickedCta: boolean;
        reachedSignup: boolean;
        otpRequested: boolean;
        registered: boolean;
      };
      recordingState: "disponible" | "procesando" | "vencida" | "sin_grabacion";
      recordingSearchUrl: string | null;
      hits: {
        at: string;
        kind: "document" | "spa";
        path: string;
        rendered: boolean;
        shownBy: "render" | "clarity" | null;
        renderDelayMs: number | null;
        preload: boolean;
      }[];
      ctaClicks: {
        at: string;
        cta: string;
        path: string;
      }[];
      recordings: {
        state: "disponible" | "procesando" | "vencida";
        playerUrl: string | null;
        firstSeen: string;
        lastSeen: string;
        pageCount: number;
        matchSource: "beacon" | "recordings_api";
        matchDeltaSec: number | null;
        activeSec: number | null;
        totalSec: number | null;
        clicks: number | null;
        lcpMs: number | null;
        pageLoadMs: number | null;
      }[];
    }[];
    nextCursor: string | null;
  };
}

export interface GetClarityFrictionResponse {
  data: {
    status: "not_configured" | "no_data" | "error" | "ok";
    configured: boolean;
    range: {
      from: string;
      to: string;
    };
    days: string[];
    lastFetchedAt: string | null;
    lastError: string | null;
    pages: {
      label: string;
      sessions: number;
      deadClickPct: number | null;
      rageClickPct: number | null;
      quickbackPct: number | null;
      excessiveScrollPct: number | null;
      scriptErrorPct: number | null;
      avgScrollDepth: number | null;
      activeTimeSec: number | null;
    }[];
    sources: {
      label: string;
      sessions: number;
      deadClickPct: number | null;
      rageClickPct: number | null;
      quickbackPct: number | null;
      excessiveScrollPct: number | null;
      scriptErrorPct: number | null;
      avgScrollDepth: number | null;
      activeTimeSec: number | null;
    }[];
    devices: {
      label: string;
      sessions: number;
      deadClickPct: number | null;
      rageClickPct: number | null;
      quickbackPct: number | null;
      excessiveScrollPct: number | null;
      scriptErrorPct: number | null;
      avgScrollDepth: number | null;
      activeTimeSec: number | null;
    }[];
    browsers: {
      label: string;
      sessions: number;
      deadClickPct: number | null;
      rageClickPct: number | null;
      quickbackPct: number | null;
      excessiveScrollPct: number | null;
      scriptErrorPct: number | null;
      avgScrollDepth: number | null;
      activeTimeSec: number | null;
    }[];
  };
}

export interface RefreshClarityFrictionResponse {
  data: {
    status: "fetched" | "skipped_recent" | "skipped_quota" | "not_configured" | "error";
    saved: number;
    requests: number;
    error: string | null;
  };
}

export interface SyncClarityRecordingsResponse {
  data: {
    status:
      | "synced"
      | "up_to_date"
      | "out_of_range"
      | "skipped_quota"
      | "skipped_running"
      | "not_configured"
      | "error";
    window: {
      from: string;
      to: string;
    } | null;
    fetched: number;
    alreadyLinked: number;
    matched: number;
    unmatched: number;
    requests: number;
    remainingToday: number;
    truncated: boolean;
    dryRun: boolean;
    error: string | null;
  };
}

export interface GetAllCategoriesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string | object;
    archived: boolean | null;
    createdAt: string | null;
    slug: string;
    showInMenu?: boolean;
    displayOrder?: number | null;
    heroImageS3Key?: string | null;
    heroImageUrl?: string | null;
    heroTitle?: object | null;
    heroSubtitle?: object | null;
    heroCtaText?: object | null;
    heroCtaUrl?: string | null;
    heroOverlayColor?: string | null;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetMenuCategoriesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string | object;
    slug: string;
    displayOrder: number | null;
  }[];
}

export interface GetCategoryPageResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string | object;
    slug: string;
    heroImageUrl: string | null;
    heroTitle: object | null;
    heroSubtitle: object | null;
    heroCtaText: object | null;
    heroCtaUrl: string | null;
    heroOverlayColor: string | null;
  };
}

export interface GetCategoryByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string | object;
    archived: boolean | null;
    createdAt: string | null;
    slug: string;
    showInMenu?: boolean;
    displayOrder?: number | null;
    heroImageS3Key?: string | null;
    heroImageUrl?: string | null;
    heroTitle?: object | null;
    heroSubtitle?: object | null;
    heroCtaText?: object | null;
    heroCtaUrl?: string | null;
    heroOverlayColor?: string | null;
  };
}

export interface CreateCategoryBody {
  title: object;
  slug?: string;
}

export interface CreateCategoryResponse {
  data: {
    /** @format uuid */
    id: string;
    message: string;
  };
}

export interface UpdateCategoryBody {
  /** @format uuid */
  id?: string;
  title?: object;
  archived?: boolean;
  slug?: string;
  showInMenu?: boolean;
  displayOrder?: number | null;
  heroImageS3Key?: string | null;
  heroTitle?: object | null;
  heroSubtitle?: object | null;
  heroCtaText?: object | null;
  heroCtaUrl?: string | null;
  heroOverlayColor?: string | null;
}

export interface UpdateCategoryResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string | object;
    archived: boolean | null;
    createdAt: string | null;
    slug: string;
    showInMenu?: boolean;
    displayOrder?: number | null;
    heroImageS3Key?: string | null;
    heroImageUrl?: string | null;
    heroTitle?: object | null;
    heroSubtitle?: object | null;
    heroCtaText?: object | null;
    heroCtaUrl?: string | null;
    heroOverlayColor?: string | null;
  };
}

export interface DeleteCategoryResponse {
  data: {
    message: string;
  };
}

export type DeleteManyCategoriesBody = string[];

export interface DeleteManyCategoriesResponse {
  data: {
    message: string;
  };
}

export interface GetOrCreateCustomerResponse {
  data: {
    customerId: string | null;
  };
}

export interface GetCustomerCardsResponse {
  data: {
    id?: string;
    firstSixDigits?: string;
    lastFourDigits?: string;
    expirationMonth?: number;
    expirationYear?: number;
    paymentMethod?: {
      id?: string;
      name?: string;
      paymentTypeId?: string;
      thumbnail?: string;
      secureThumbnail?: string;
    };
    issuer?: {
      id?: number;
      name?: string;
    };
    cardholder?: {
      name?: string;
    };
  }[];
}

export interface DeleteCustomerCardResponse {
  data: {
    success: boolean;
  };
}

export interface HandleWebhookBody {
  id?: number | string;
  live_mode?: boolean;
  type: string;
  date_created?: string;
  user_id?: number | string;
  api_version?: string;
  action?: string;
  data: {
    id: string | number;
  };
}

export interface HandleWebhookResponse {
  data: {
    received: boolean;
  };
}

export type BulkUpsertEnvBody = {
  name: string;
  value: string;
}[];

export interface GetFrontendSSOEnabledResponse {
  data: {
    google?: string;
    microsoft?: string;
    slack?: string;
  };
}

export interface GetMercadoPagoPublicKeyResponse {
  data: {
    publicKey: string | null;
  };
}

export interface GetMercadoPagoConfiguredResponse {
  data: {
    enabled: boolean;
  };
}

export interface GetAIConfiguredResponse {
  data: {
    enabled: boolean;
  };
}

export interface GetIsConfigSetupResponse {
  data: {
    fullyConfigured: string[];
    partiallyConfigured: {
      service: string;
      missingKeys: string[];
    }[];
    notConfigured: {
      service: string;
      missingKeys: string[];
    }[];
    hasIssues: boolean;
    isWarningDismissed: boolean;
  };
}

export interface GetEnvOverviewResponse {
  data: {
    name: string;
    source: "admin" | "server" | "none";
    display: string | null;
    masked: boolean;
    secret: boolean;
    overridesServer: boolean;
  }[];
}

export interface GetCartResponse {
  data: {
    items: {
      /** @format uuid */
      id: string;
      /** @format uuid */
      courseId: string;
      title: string;
      description: string;
      thumbnailUrl: string | null;
      authorName: string;
      categoryName: string | null;
      priceInCents: number;
      mercadopagoPriceInCents: number;
      currency: string;
      mercadopagoProductId: string | null;
      slug: string | null;
      addedAt: string;
      hasFreeChapters: boolean;
      isPreinscription: boolean;
    }[];
    itemCount: number;
  };
}

export interface AddItemBody {
  /** @format uuid */
  courseId: string;
}

export interface AddItemResponse {
  data: {
    success: boolean;
  };
}

export interface RemoveItemResponse {
  data: {
    success: boolean;
  };
}

export interface ClearCartResponse {
  data: {
    success: boolean;
  };
}

export interface MergeGuestCartBody {
  courseIds: string[];
}

export interface MergeGuestCartResponse {
  data: {
    items: {
      /** @format uuid */
      id: string;
      /** @format uuid */
      courseId: string;
      title: string;
      description: string;
      thumbnailUrl: string | null;
      authorName: string;
      categoryName: string | null;
      priceInCents: number;
      mercadopagoPriceInCents: number;
      currency: string;
      mercadopagoProductId: string | null;
      slug: string | null;
      addedAt: string;
      hasFreeChapters: boolean;
      isPreinscription: boolean;
    }[];
    itemCount: number;
    reconciliation: {
      /** @format uuid */
      courseId: string;
      title: string;
      reason: "owned" | "unavailable";
    }[];
  };
}

export interface RequestPaymentLinkBody {
  method: "mercadopago";
  courseIds?: string[];
}

export interface RequestPaymentLinkResponse {
  data: {
    orderId: string;
    status: string;
    debugPaymentUrl?: string;
  };
}

export interface GetOrderStatusResponse {
  data: {
    orderId: string;
    status: string;
    provider: string;
    totalAmountInCents: number;
    currency: string;
    createdAt: string;
  };
}

export interface MercadopagoCheckoutBody {
  token: string;
  paymentMethodId: string;
  /** @format email */
  email: string;
  /** @default 1 */
  installments?: number;
  identification?: {
    type: string;
    number: string;
  };
  courseIds?: string[];
}

export interface MercadopagoCheckoutResponse {
  data: {
    orderId: string;
    paymentId: number;
    status: string;
    statusDetail?: string;
  };
}

export interface FreeCheckoutBody {
  courseIds?: string[];
  items?: {
    /** @format uuid */
    courseId: string;
    accessLevel?: "free_preview" | "full";
  }[];
}

export interface FreeCheckoutResponse {
  data: {
    orderId: string;
    enrolledCourseIds: string[];
    preinscribedCourseIds: string[];
    alreadyOwnedCourseIds?: string[];
    upgradedCourseIds: string[];
    items: {
      courseId: string;
      accessLevel: "free_preview" | "full";
      outcome:
        | "enrolled"
        | "already_owned"
        | "preinscribed"
        | "upgraded"
        | "pending_payment"
        | "revoked";
    }[];
  };
}

export interface PreinscribeBody {
  /** @format uuid */
  courseId: string;
  /** @maxLength 50 */
  source?: string;
}

export interface PreinscribeResponse {
  data: {
    preinscribed: boolean;
  };
}

export interface GetOpenCoursesResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    description: string;
    thumbnailUrl: string;
    priceInCents: number;
    mercadopagoPriceInCents: number;
    mercadopagoProductId: string | null;
    currency: string;
    isPreinscribed: boolean;
    preinscribedCount: number;
  }[];
}

export interface GetMineResponse {
  data: string[];
}

export interface GetAllResponse {
  data: {
    /** @format uuid */
    id: string;
    phone: string;
    kind: "otp" | "payment_link" | "text";
    status: "pending" | "sent" | "delivered" | "read" | "failed" | "error";
    templateName: string | null;
    provider: string;
    orderId: string | null;
    wamid: string | null;
    errorCode: string | null;
    errorDetail: string | null;
    attempts: number;
    resentFromId: string | null;
    userFirstName: string | null;
    userLastName: string | null;
    createdAt: string;
    request: any;
    response: any;
    statusHistory: any;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface ListOrdersResponse {
  data: {
    orders: {
      id: string;
      status: string;
      provider: string;
      totalAmountInCents: number;
      currency: string;
      createdAt: string;
      pendingAmountInCents: number;
      payable: boolean;
      items: {
        id: string;
        courseId: string;
        courseTitle: string;
        courseSlug: string | null;
        courseThumbnailUrl: string | null;
        priceInCents: number;
        currency: string;
        accessLevel: "free_preview" | "full";
        outcome:
          | "enrolled"
          | "already_owned"
          | "preinscribed"
          | "upgraded"
          | "pending_payment"
          | "revoked";
      }[];
    }[];
  };
}

export interface ListPurchaseHistoryResponse {
  data: {
    items: {
      id: string;
      courseId: string;
      courseTitle: string;
      courseThumbnailUrl: string | null;
      kind: "purchase" | "free" | "preinscription";
      status: string;
      orderId: string | null;
      priceInCents: number;
      currency: string;
      transactionAt: string;
      preinscribedAt: string | null;
      enrolledAt: string | null;
      purchasedAt: string | null;
      completedAt: string | null;
      progress: string | null;
      preinscriptionConverted: boolean | null;
    }[];
  };
}

export interface GetOrderPublicResponse {
  data: {
    id: string;
    userId?: string;
    status: string;
    provider: string;
    totalAmountInCents: number;
    currency: string;
    createdAt: string;
    pendingAmountInCents: number;
    payable: boolean;
    items: {
      id: string;
      courseId: string;
      courseTitle: string;
      courseSlug: string | null;
      courseThumbnailUrl: string | null;
      priceInCents: number;
      currency: string;
      accessLevel: "free_preview" | "full";
      outcome:
        | "enrolled"
        | "already_owned"
        | "preinscribed"
        | "upgraded"
        | "pending_payment"
        | "revoked";
    }[];
  };
}

export interface GetPaymentLinkResponse {
  data: {
    orderId: string;
    paymentUrl: string;
    regenerated: boolean;
  };
}

export interface GetOrderResponse {
  data: {
    id: string;
    status: string;
    provider: string;
    totalAmountInCents: number;
    currency: string;
    createdAt: string;
    pendingAmountInCents: number;
    payable: boolean;
    items: {
      id: string;
      courseId: string;
      courseTitle: string;
      courseSlug: string | null;
      courseThumbnailUrl: string | null;
      priceInCents: number;
      currency: string;
      accessLevel: "free_preview" | "full";
      outcome:
        | "enrolled"
        | "already_owned"
        | "preinscribed"
        | "upgraded"
        | "pending_payment"
        | "revoked";
    }[];
  };
}

export interface ResendPaymentLinkResponse {
  data: {
    orderId: string;
    messageId: string | null;
    sentTo: string;
  };
}

export interface GetOrdersResponse {
  data: {
    /** @format uuid */
    id: string;
    status: string;
    provider: string;
    totalAmountInCents: number;
    currency: string;
    paymentUrl: string | null;
    createdAt: string;
    /** @format uuid */
    userId: string;
    userFirstName: string;
    userLastName: string;
    userPhone: string | null;
    itemCount: number;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetOrdersStatsResponse {
  data: {
    totalOrders: number;
    freeOrders: number;
    completedOrders: number;
    awaitingPaymentOrders: number;
    revenueInCents: number;
    conversionPercent: number | null;
    byStatus: {
      status: string;
      count: number;
    }[];
    daily: {
      date: string;
      orders: number;
      free: number;
      completed: number;
      revenueInCents: number;
    }[];
  };
}

export interface GetByIdResponse {
  data: {
    /** @format uuid */
    id: string;
    status: string;
    provider: string;
    totalAmountInCents: number;
    currency: string;
    paymentUrl: string | null;
    createdAt: string;
    /** @format uuid */
    userId: string;
    userFirstName: string;
    userLastName: string;
    userPhone: string | null;
    itemCount: number;
    items: {
      /** @format uuid */
      courseId: string;
      courseTitle: string;
      courseSlug: string | null;
      priceInCents: number;
      currency: string;
      accessLevel: "free_preview" | "full";
      outcome:
        | "enrolled"
        | "already_owned"
        | "preinscribed"
        | "upgraded"
        | "pending_payment"
        | "revoked";
    }[];
    payments: {
      /** @format uuid */
      id: string;
      provider: string;
      providerPaymentId: string;
      amountInCents: number;
      currency: string;
      status: string;
      statusDetail: string | null;
      paymentMethod: string | null;
      installments: number | null;
      payerEmail: string | null;
      createdAt: string;
    }[];
    messages: {
      /** @format uuid */
      id: string;
      kind: string;
      status: string;
      phone: string;
      errorDetail: string | null;
      createdAt: string;
    }[];
  };
}

export interface CancelResponse {
  data: {
    /** @format uuid */
    id: string;
    status: string;
  };
}

export interface GetStatsResponse {
  data: {
    total: number;
    sent: number;
    delivered: number;
    read: number;
    failed: number;
    daily: {
      date: string;
      total: number;
      delivered: number;
      failed: number;
    }[];
  };
}

export interface UploadScormPackageResponse {
  data: {
    message: string;
    metadata: {
      /** @format uuid */
      id: string;
      createdAt: string;
      updatedAt: string;
      /** @format uuid */
      courseId: string;
      /** @format uuid */
      fileId: string;
      version: string;
      entryPoint: string;
      s3Key: string;
    };
  };
}

export interface GetScormMetadataResponse {
  data: {
    /** @format uuid */
    id: string;
    createdAt: string;
    updatedAt: string;
    /** @format uuid */
    courseId: string;
    /** @format uuid */
    fileId: string;
    version: string;
    entryPoint: string;
    s3Key: string;
  };
}

export interface GetAllAnnouncementsResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    title: string;
    content: string;
    authorId: string;
    isEveryone: boolean;
    authorName: string;
    authorProfilePictureUrl: string | null;
  }[];
}

export interface GetLatestUnreadAnnouncementsResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    title: string;
    content: string;
    authorId: string;
    isEveryone: boolean;
    authorName: string;
    authorProfilePictureUrl: string | null;
  }[];
}

export interface GetUnreadAnnouncementsCountResponse {
  data: {
    unreadCount: number;
  };
}

export interface GetAnnouncementsForUserResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    title: string;
    content: string;
    authorId: string;
    isEveryone: boolean;
    authorName: string;
    authorProfilePictureUrl: string | null;
    isRead: boolean;
  }[];
}

export interface CreateAnnouncementBody {
  /**
   * @minLength 1
   * @maxLength 120
   */
  title: string;
  /** @minLength 1 */
  content: string;
  /** @default null */
  groupId: string | null;
}

export interface CreateAnnouncementResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    title: string;
    content: string;
    authorId: string;
    isEveryone: boolean;
  };
}

export interface MarkAnnouncementAsReadResponse {
  data: {
    id: string;
    createdAt: string;
    updatedAt: string;
    userId: string;
    announcementId: string;
    isRead: boolean;
    readAt: string | null;
  };
}

export interface GetQAResponse {
  /** @format uuid */
  id: string;
  title: string | null;
  description: string | null;
  baseLanguage: "en" | "es";
  availableLocales: ("en" | "es")[];
}

export type GetAllQAResponse = {
  /** @format uuid */
  id: string;
  title: string | null;
  description: string | null;
  baseLanguage: "en" | "es";
  availableLocales: ("en" | "es")[];
}[];

export interface CreateQABody {
  title: string;
  description: string;
  language: "en" | "es";
}

export interface UpdateQABody {
  title?: string;
  description?: string;
}

export interface GetDraftNewsListResponse {
  data: {
    id: string;
    title: string;
    content: string;
    summary: string;
    status: string;
    isPublic: boolean;
    /** @default "es" */
    baseLanguage: "en" | "es";
    availableLocales: ("en" | "es")[];
    publishedAt: string | null;
    authorName: string;
    resources?: {
      images: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        title?: string;
        description?: string;
        fileName?: string;
      }[];
      videos: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        title?: string;
        description?: string;
        fileName?: string;
      }[];
      attachments: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        title?: string;
        description?: string;
        fileName?: string;
      }[];
      coverImage?: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        title?: string;
        description?: string;
        fileName?: string;
      };
    };
    createdAt: string;
    updatedAt: string;
    nextNews?: string | null;
    previousNews?: string | null;
    seoTldr?: string | null;
    aiContext?: {
      geographic?: string[];
      audience?: string[];
      intent?:
        | "how-to-guide"
        | "course-overview"
        | "concept-explanation"
        | "comparison"
        | "case-study"
        | "reference"
        | "opinion"
        | "tutorial";
      topics?: string[];
      cite_when?: string[];
      expertise_level?: "beginner" | "intermediate" | "advanced";
    } | null;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GenerateNewsPreviewBody {
  /** @format uuid */
  newsId: string;
  /** @default "es" */
  language: "en" | "es";
  content: string;
}

export interface GenerateNewsPreviewResponse {
  data: {
    parsedContent: string;
  };
}

export interface GetNewsResponse {
  data: {
    id: string;
    title: string;
    content: string;
    plainContent: string;
    summary: string;
    status: string;
    isPublic: boolean;
    /** @default "es" */
    baseLanguage: "en" | "es";
    availableLocales: ("en" | "es")[];
    publishedAt: string | null;
    authorName: string;
    resources?: {
      images: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        title?: string;
        description?: string;
        fileName?: string;
      }[];
      videos: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        title?: string;
        description?: string;
        fileName?: string;
      }[];
      attachments: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        title?: string;
        description?: string;
        fileName?: string;
      }[];
      coverImage?: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        title?: string;
        description?: string;
        fileName?: string;
      };
    };
    createdAt: string;
    updatedAt: string;
    nextNews?: string | null;
    previousNews?: string | null;
    seoTldr?: string | null;
    aiContext?: {
      geographic?: string[];
      audience?: string[];
      intent?:
        | "how-to-guide"
        | "course-overview"
        | "concept-explanation"
        | "comparison"
        | "case-study"
        | "reference"
        | "opinion"
        | "tutorial";
      topics?: string[];
      cite_when?: string[];
      expertise_level?: "beginner" | "intermediate" | "advanced";
    } | null;
  };
}

export interface GetNewsListResponse {
  data: {
    id: string;
    title: string;
    content: string;
    summary: string;
    status: string;
    isPublic: boolean;
    /** @default "es" */
    baseLanguage: "en" | "es";
    availableLocales: ("en" | "es")[];
    publishedAt: string | null;
    authorName: string;
    resources?: {
      images: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        title?: string;
        description?: string;
        fileName?: string;
      }[];
      videos: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        title?: string;
        description?: string;
        fileName?: string;
      }[];
      attachments: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        title?: string;
        description?: string;
        fileName?: string;
      }[];
      coverImage?: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        title?: string;
        description?: string;
        fileName?: string;
      };
    };
    createdAt: string;
    updatedAt: string;
    nextNews?: string | null;
    previousNews?: string | null;
    seoTldr?: string | null;
    aiContext?: {
      geographic?: string[];
      audience?: string[];
      intent?:
        | "how-to-guide"
        | "course-overview"
        | "concept-explanation"
        | "comparison"
        | "case-study"
        | "reference"
        | "opinion"
        | "tutorial";
      topics?: string[];
      cite_when?: string[];
      expertise_level?: "beginner" | "intermediate" | "advanced";
    } | null;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface CreateNewsBody {
  /** @default "es" */
  language: "en" | "es";
}

export interface CreateNewsResponse {
  data: {
    id: string;
    title: string;
  };
}

export interface UpdateNewsBody {
  /** @default "es" */
  language: "en" | "es";
  title?: string;
  summary?: string;
  content?: string;
  status?: "draft" | "published";
  isPublic?: boolean | "true" | "false";
  /**
   * Cover image file
   * @format binary
   */
  cover?: File;
  seoTldr?: string | null;
  aiContext?: {
    geographic?: string[];
    audience?: string[];
    intent?:
      | "how-to-guide"
      | "course-overview"
      | "concept-explanation"
      | "comparison"
      | "case-study"
      | "reference"
      | "opinion"
      | "tutorial";
    topics?: string[];
    cite_when?: string[];
    expertise_level?: "beginner" | "intermediate" | "advanced";
  } | null;
}

export interface UpdateNewsResponse {
  data: {
    id: string;
    title: string;
  };
}

export interface AddNewLanguageBody {
  /** @default "es" */
  language: "en" | "es";
}

export interface AddNewLanguageResponse {
  data: {
    id: string;
    title: string;
  };
}

export interface DeleteNewsLanguageResponse {
  data: {
    /** @format uuid */
    id: string;
    availableLocales: string[];
  };
}

export interface DeleteNewsResponse {
  data: {
    /** @format uuid */
    id: string;
  };
}

export interface UploadFileToNewsResponse {
  data: {
    /** @format uuid */
    resourceId: string;
  };
}

export interface CreateArticleSectionBody {
  /** @default "es" */
  language: "en" | "es";
}

export interface CreateArticleSectionResponse {
  data: {
    id: string;
    title: string;
  };
}

export interface GetArticleSectionResponse {
  data: {
    /** @format uuid */
    id: string;
    title: string;
    /** @default "es" */
    baseLanguage: "en" | "es";
    availableLocales: ("en" | "es")[];
    assignedArticlesCount: number;
  };
}

export interface UpdateArticleSectionBody {
  /** @default "es" */
  language: "en" | "es";
  title?: string;
}

export interface UpdateArticleSectionResponse {
  data: {
    id: string;
    title: string;
  };
}

export interface AddNewLanguageToSectionBody {
  /** @default "es" */
  language: "en" | "es";
}

export interface AddNewLanguageToSectionResponse {
  data: {
    id: string;
    title: string;
  };
}

export type GetDraftArticlesResponse = {
  id: string;
  title: string;
  status: string;
  isPublic: boolean;
  publishedAt: string | null;
  authorName: string;
  /** @format uuid */
  authorId: string;
  resources?: {
    images: {
      /** @format uuid */
      id: string;
      fileUrl: string;
      contentType: string | null;
      fileUrlError?: boolean;
      title?: string;
      description?: string;
      fileName?: string;
    }[];
    videos: {
      /** @format uuid */
      id: string;
      fileUrl: string;
      contentType: string | null;
      fileUrlError?: boolean;
      title?: string;
      description?: string;
      fileName?: string;
    }[];
    attachments: {
      /** @format uuid */
      id: string;
      fileUrl: string;
      contentType: string | null;
      fileUrlError?: boolean;
      title?: string;
      description?: string;
      fileName?: string;
    }[];
    coverImage?: {
      /** @format uuid */
      id: string;
      fileUrl: string;
      contentType: string | null;
      fileUrlError?: boolean;
      title?: string;
      description?: string;
      fileName?: string;
    };
  };
  createdAt: string;
  updatedAt: string;
  nextArticle?: string | null;
  previousArticle?: string | null;
  seoTldr?: string | null;
  aiContext?: {
    geographic?: string[];
    audience?: string[];
    intent?:
      | "how-to-guide"
      | "course-overview"
      | "concept-explanation"
      | "comparison"
      | "case-study"
      | "reference"
      | "opinion"
      | "tutorial";
    topics?: string[];
    cite_when?: string[];
    expertise_level?: "beginner" | "intermediate" | "advanced";
  } | null;
}[];

export interface GetArticleTocResponse {
  data: {
    sections: {
      /** @format uuid */
      id: string;
      title: string;
      articles: {
        /** @format uuid */
        id: string;
        title: string;
      }[];
    }[];
  };
}

export interface GetArticleResponse {
  data: {
    id: string;
    title: string;
    content: string;
    plainContent: string;
    summary: string;
    status: string;
    isPublic: boolean;
    /** @default "es" */
    baseLanguage: "en" | "es";
    availableLocales: ("en" | "es")[];
    publishedAt: string | null;
    authorName: string;
    /** @format uuid */
    authorId: string;
    resources?: {
      images: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        fileUrlError?: boolean;
        title?: string;
        description?: string;
        fileName?: string;
      }[];
      videos: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        fileUrlError?: boolean;
        title?: string;
        description?: string;
        fileName?: string;
      }[];
      attachments: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        fileUrlError?: boolean;
        title?: string;
        description?: string;
        fileName?: string;
      }[];
      coverImage?: {
        /** @format uuid */
        id: string;
        fileUrl: string;
        contentType: string | null;
        fileUrlError?: boolean;
        title?: string;
        description?: string;
        fileName?: string;
      };
    };
    createdAt: string;
    updatedAt: string;
    nextArticle?: string | null;
    previousArticle?: string | null;
    seoTldr?: string | null;
    aiContext?: {
      geographic?: string[];
      audience?: string[];
      intent?:
        | "how-to-guide"
        | "course-overview"
        | "concept-explanation"
        | "comparison"
        | "case-study"
        | "reference"
        | "opinion"
        | "tutorial";
      topics?: string[];
      cite_when?: string[];
      expertise_level?: "beginner" | "intermediate" | "advanced";
    } | null;
  };
}

export type GetArticlesResponse = {
  id: string;
  title: string;
  status: string;
  isPublic: boolean;
  publishedAt: string | null;
  authorName: string;
  /** @format uuid */
  authorId: string;
  resources?: {
    images: {
      /** @format uuid */
      id: string;
      fileUrl: string;
      contentType: string | null;
      fileUrlError?: boolean;
      title?: string;
      description?: string;
      fileName?: string;
    }[];
    videos: {
      /** @format uuid */
      id: string;
      fileUrl: string;
      contentType: string | null;
      fileUrlError?: boolean;
      title?: string;
      description?: string;
      fileName?: string;
    }[];
    attachments: {
      /** @format uuid */
      id: string;
      fileUrl: string;
      contentType: string | null;
      fileUrlError?: boolean;
      title?: string;
      description?: string;
      fileName?: string;
    }[];
    coverImage?: {
      /** @format uuid */
      id: string;
      fileUrl: string;
      contentType: string | null;
      fileUrlError?: boolean;
      title?: string;
      description?: string;
      fileName?: string;
    };
  };
  createdAt: string;
  updatedAt: string;
  nextArticle?: string | null;
  previousArticle?: string | null;
  seoTldr?: string | null;
  aiContext?: {
    geographic?: string[];
    audience?: string[];
    intent?:
      | "how-to-guide"
      | "course-overview"
      | "concept-explanation"
      | "comparison"
      | "case-study"
      | "reference"
      | "opinion"
      | "tutorial";
    topics?: string[];
    cite_when?: string[];
    expertise_level?: "beginner" | "intermediate" | "advanced";
  } | null;
}[];

export interface CreateArticleBody {
  /** @default "es" */
  language: "en" | "es";
  /** @format uuid */
  sectionId: string;
}

export interface CreateArticleResponse {
  data: {
    id: string;
    title: string;
  };
}

export interface UpdateArticleBody {
  /** @default "es" */
  language: "en" | "es";
  title?: string;
  summary?: string;
  content?: string;
  status?: "draft" | "published" | "";
  isPublic?: boolean | "true" | "false" | "";
  /**
   * Cover image file
   * @format binary
   */
  cover?: File;
  seoTldr?: string | null;
  aiContext?: {
    geographic?: string[];
    audience?: string[];
    intent?:
      | "how-to-guide"
      | "course-overview"
      | "concept-explanation"
      | "comparison"
      | "case-study"
      | "reference"
      | "opinion"
      | "tutorial";
    topics?: string[];
    cite_when?: string[];
    expertise_level?: "beginner" | "intermediate" | "advanced";
  } | null;
}

export interface UpdateArticleResponse {
  data: {
    id: string;
    title: string;
  };
}

export interface UploadFileToArticleBody {
  /**
   * File
   * @format binary
   */
  file?: File;
  /** @default "es" */
  language: "en" | "es";
  title: string;
  description: string;
}

export interface UploadFileToArticleResponse {
  data: {
    /** @format uuid */
    resourceId: string;
  };
}

export interface GenerateArticlePreviewBody {
  /** @format uuid */
  articleId: string;
  /** @default "es" */
  language: "en" | "es";
  content: string;
}

export interface GenerateArticlePreviewResponse {
  data: {
    parsedContent: string;
  };
}

export interface GetRegistrationAttemptsResponse {
  data: {
    id: string;
    phone: string;
    source: string;
    cartSnapshot:
      | {
          courseId?: string;
          title?: string;
          priceInCents?: number;
          mercadopagoPriceInCents?: number | null;
          currency?: string;
        }[]
      | null;
    termsAccepted: boolean;
    registered: boolean;
    registeredAt?: string | null;
    userId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    totalPriceUsdCents?: number | null;
    totalPriceArsCents?: number | null;
    createdAt: string;
    updatedAt: string;
    clarityUrl?: string | null;
    analyticsConsent?: boolean | null;
  }[];
  pagination: {
    totalItems: number;
    page: number;
    perPage: number;
  };
  appliedFilters?: object;
}

export interface GetRegistrationAttemptsStatsResponse {
  data: {
    totalAttempts: number;
    totalRegistered: number;
    conversionRate: number;
    bySource: {
      source: string;
      count: number;
    }[];
    daily: {
      date: string;
      attempts: number;
      registered: number;
    }[];
  };
}

export interface GetCourseAnalyticsOverviewResponse {
  data: {
    course: {
      /** @format uuid */
      id: string;
      title: string;
      status: string;
      lessonCount: number;
      lessonBreakdown: {
        classes: number;
        questions: number;
        quizzes: number;
        evaluations: number;
      };
    };
    enrolled: number;
    started: number;
    notStarted: number;
    activeLast7Days: number;
    inactive: number;
    completed: number;
    completionRate: number;
    averageProgressPct: number;
    medianDaysToComplete: number | null;
    certificatesIssued: number;
    finalQuiz: {
      /** @format uuid */
      lessonId: string;
      lessonTitle: string;
      submitted: number;
      passed: number;
      passRate: number;
      averageScore: number | null;
    } | null;
    signals: {
      kind: "contact_consent" | "next_course_interest" | "next_course_topic";
      /** @format uuid */
      questionId: string;
      questionTitle: string;
      answered: number;
      positive: number;
      options: {
        optionId: string | null;
        text: string;
        count: number;
        pct: number;
      }[];
    }[];
  };
}

export interface GetCourseAnalyticsStudentsResponse {
  data: {
    /** @format uuid */
    studentId: string;
    firstName: string;
    lastName: string;
    phone: string | null;
    enrolledAt: string | null;
    completedAt: string | null;
    lastActivityAt: string | null;
    completedLessons: number;
    totalLessons: number;
    completedClasses: number;
    totalClasses: number;
    progressPct: number;
    status: "not_started" | "in_progress" | "inactive" | "completed";
    stoppedAtLessonId: string | null;
    finalQuiz: {
      /** @format uuid */
      lessonId: string;
      score: number | null;
      attempts: number | null;
      passed: boolean | null;
    } | null;
    certificate: {
      code: string;
      issuedAt: string;
    } | null;
    contactConsent: ("yes" | "no") | null;
    nextCourseInterest: string | null;
  }[];
}

export interface GetCourseAnalyticsStudentDetailResponse {
  data: {
    student: {
      /** @format uuid */
      studentId: string;
      firstName: string;
      lastName: string;
      phone: string | null;
      enrolledAt: string | null;
      completedAt: string | null;
      lastActivityAt: string | null;
      completedLessons: number;
      totalLessons: number;
      completedClasses: number;
      totalClasses: number;
      progressPct: number;
      status: "not_started" | "in_progress" | "inactive" | "completed";
      stoppedAtLessonId: string | null;
      finalQuiz: {
        /** @format uuid */
        lessonId: string;
        score: number | null;
        attempts: number | null;
        passed: boolean | null;
      } | null;
      certificate: {
        code: string;
        issuedAt: string;
      } | null;
      contactConsent: ("yes" | "no") | null;
      nextCourseInterest: string | null;
    };
    lessons: {
      /** @format uuid */
      lessonId: string;
      chapterTitle: string;
      chapterPosition: number;
      lessonPosition: number;
      title: string;
      type: string;
      isSurvey: boolean;
      state: "not_started" | "viewed" | "completed" | "skipped";
      completedAt: string | null;
      lastViewedAt: string | null;
      videoPct: number | null;
      quizScore: number | null;
      attempts: number | null;
    }[];
    submissions: {
      submissionId: string;
      /** @format uuid */
      lessonId: string;
      lessonTitle: string;
      attemptNumber: number;
      submittedAt: string;
      isSurvey: boolean;
      score: number | null;
      recovered: boolean;
      answers: {
        /** @format uuid */
        questionId: string;
        questionTitle: string;
        type: string;
        answer: string[];
        isCorrect: boolean | null;
        correctAnswer: string[];
      }[];
    }[];
  };
}

export interface GetCourseAnalyticsQuestionsResponse {
  data: {
    kind: "quiz" | "survey";
    respondents: number;
    questions: {
      /** @format uuid */
      questionId: string;
      /** @format uuid */
      lessonId: string;
      lessonTitle: string;
      chapterPosition: number;
      lessonPosition: number;
      position: number;
      title: string;
      type: string;
      isSurvey: boolean;
      signal: ("contact_consent" | "next_course_interest" | "next_course_topic") | null;
      answeredCount: number;
      submissions: number;
      gradedCount: number;
      correctCount: number;
      correctRate: number | null;
      firstTryAnsweredCount: number;
      firstTryCorrectRate: number | null;
      options: {
        /** @format uuid */
        optionId: string;
        text: string;
        isCorrect: boolean | null;
        count: number;
        pct: number;
        firstTryCount: number;
      }[];
      otherCount: number;
      openAnswers: {
        /** @format uuid */
        studentId: string;
        studentName: string;
        text: string;
        answeredAt: string;
      }[];
    }[];
  };
}

export interface GetCourseAnalyticsFunnelResponse {
  data: {
    enrolled: number;
    lessons: {
      /** @format uuid */
      lessonId: string;
      chapterTitle: string;
      chapterPosition: number;
      lessonPosition: number;
      title: string;
      type: string;
      isSurvey: boolean;
      hasCondition: boolean;
      reached: number;
      completed: number;
      skipped: number;
      stoppedHere: number;
    }[];
  };
}

export interface GetTrackingPublicConfigResponse {
  data: {
    metaPixelId: string | null;
    tiktokPixelId: string | null;
    ga4MeasurementId: string | null;
    googleAdsTagId: string | null;
    xPixelId: string | null;
    xEventIds: {
      lead?: string;
      sign_up?: string;
      enroll_free?: string;
      purchase?: string;
      course_completed?: string;
      cta_click?: string;
      engaged_visit?: string;
    };
    linkedinPartnerId: string | null;
    clarityProjectId: string | null;
    posthogKey: string | null;
    posthogHost: string | null;
    serverDestinations: ("meta" | "tiktok" | "ga4" | "google_ads" | "x" | "linkedin")[];
    verification: {
      google: string | null;
      meta: string | null;
      bing: string | null;
    };
    consentDefault: "granted" | "denied";
    consentBanner: boolean;
    consentVersion: string;
  };
}

export interface UpdateTrackingConsentBody {
  analytics: boolean;
  ads: boolean;
  source?: "banner" | "privacy" | "registro" | "cuenta";
}

export interface UpdateTrackingConsentResponse {
  data: {
    analytics: boolean;
    ads: boolean;
    version: string;
  };
}

export interface GetTrackingStatusResponse {
  data: {
    testMode: boolean;
    consentBanner: boolean;
    consentDefault: "granted" | "denied";
    effectiveConsent: "granted" | "denied";
    destinations: {
      destination: "meta" | "tiktok" | "ga4" | "google_ads" | "x" | "linkedin";
      status: "connected" | "partial" | "not_configured";
      missing: string[];
      mappedEvents: string[] | null;
    }[];
  };
}

export interface TestTrackingDestinationResponse {
  data: {
    ok: boolean;
    message: string;
  };
}

export interface TestTrackingEventResponse {
  data: {
    event: "view_content" | "engaged_visit" | "cta_click";
    results: {
      destination: "meta" | "tiktok" | "ga4" | "google_ads" | "x" | "linkedin";
      ok: boolean;
      message: string;
    }[];
  };
}

export interface GetRecentConversionsResponse {
  data: {
    id: string;
    eventId: string;
    eventName: string;
    eventTime: string;
    valueInCents: number | null;
    currency: string | null;
    userId: string | null;
    consentAds: boolean | null;
    deliveries: {
      destination: string;
      status: string;
      attempts: number;
      lastError: string | null;
      sentAt: string | null;
    }[];
  }[];
}

export interface GetGoogleStatusResponse {
  data: {
    serviceAccount: {
      configured: boolean;
      source: "secret" | "env" | "file" | null;
      clientEmail: string | null;
      error: string | null;
    };
    ga4: {
      connected: boolean;
      reason:
        | (
            | "no_credentials"
            | "invalid_credentials"
            | "no_property"
            | "no_access"
            | "api_disabled"
            | "quota"
            | "error"
          )
        | null;
      message: string | null;
      clientEmail: string | null;
      resource: string | null;
    };
    searchConsole: {
      connected: boolean;
      reason:
        | (
            | "no_credentials"
            | "invalid_credentials"
            | "no_property"
            | "no_access"
            | "api_disabled"
            | "quota"
            | "error"
          )
        | null;
      message: string | null;
      clientEmail: string | null;
      resource: string | null;
    };
    checkedAt: string;
  };
}

export interface GetGoogleTrafficResponse {
  data: {
    connection: {
      connected: boolean;
      reason:
        | (
            | "no_credentials"
            | "invalid_credentials"
            | "no_property"
            | "no_access"
            | "api_disabled"
            | "quota"
            | "error"
          )
        | null;
      message: string | null;
      clientEmail: string | null;
      resource: string | null;
    };
    range: {
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      from: string;
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      to: string;
      days: number;
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      previousFrom: string;
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      previousTo: string;
      includesToday: boolean;
      granularity: "hour" | "day";
      isToday: boolean;
      compare: boolean;
    };
    /** @format date-time */
    fetchedAt: string;
    data: {
      totals: {
        current: {
          users: number;
          newUsers: number;
          sessions: number;
          engagedSessions: number;
          engagementRate: number;
          averageSessionDuration: number;
          pageViews: number;
          keyEvents: number;
        };
        previous: {
          users: number;
          newUsers: number;
          sessions: number;
          engagedSessions: number;
          engagementRate: number;
          averageSessionDuration: number;
          pageViews: number;
          keyEvents: number;
        } | null;
      };
      daily: {
        date: string;
        /**
         * @min 0
         * @max 23
         */
        hour?: number;
        users: number;
        sessions: number;
        pageViews: number;
        keyEvents: number;
      }[];
      previousDaily: {
        date: string;
        /**
         * @min 0
         * @max 23
         */
        hour?: number;
        users: number;
        sessions: number;
        pageViews: number;
        keyEvents: number;
      }[];
      dataThrough: string | null;
      pages: {
        path: string;
        title: string | null;
        views: number;
        users: number;
      }[];
      sources: {
        source: string;
        medium: string;
        sessions: number;
        users: number;
        engagementRate: number;
        keyEvents: number;
      }[];
      campaigns: {
        campaign: string;
        source: string;
        medium: string;
        sessions: number;
        users: number;
        keyEvents: number;
      }[];
      devices: {
        device: string;
        users: number;
        sessions: number;
      }[];
      countries: {
        country: string;
        countryId: string | null;
        users: number;
        sessions: number;
      }[];
      cities: {
        city: string;
        country: string;
        users: number;
        sessions: number;
      }[];
      keyEvents: {
        eventName: string;
        count: number;
      }[];
    } | null;
  };
}

export interface GetGoogleSearchResponse {
  data: {
    connection: {
      connected: boolean;
      reason:
        | (
            | "no_credentials"
            | "invalid_credentials"
            | "no_property"
            | "no_access"
            | "api_disabled"
            | "quota"
            | "error"
          )
        | null;
      message: string | null;
      clientEmail: string | null;
      resource: string | null;
    };
    range: {
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      from: string;
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      to: string;
      days: number;
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      previousFrom: string;
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      previousTo: string;
      includesToday: boolean;
      granularity: "hour" | "day";
      isToday: boolean;
      compare: boolean;
    };
    /** @format date-time */
    fetchedAt: string;
    data: {
      totals: {
        current: {
          clicks: number;
          impressions: number;
          ctr: number;
          position: number;
        };
        previous: {
          clicks: number;
          impressions: number;
          ctr: number;
          position: number;
        } | null;
      };
      daily: {
        date: string;
        clicks: number;
        impressions: number;
        ctr: number;
        position: number;
      }[];
      queries: {
        key: string;
        clicks: number;
        impressions: number;
        ctr: number;
        position: number;
      }[];
      pages: {
        key: string;
        clicks: number;
        impressions: number;
        ctr: number;
        position: number;
        url: string;
      }[];
      countries: {
        key: string;
        clicks: number;
        impressions: number;
        ctr: number;
        position: number;
      }[];
      devices: {
        key: string;
        clicks: number;
        impressions: number;
        ctr: number;
        position: number;
      }[];
      latestDate: string | null;
      delayDays: number;
      dataState: "all" | "final";
      firstIncompleteDate: string | null;
      dayTimeZone: string;
      requestedFrom: string;
      requestedTo: string;
    } | null;
  };
}

export interface GetGoogleRealtimeResponse {
  data: {
    connection: {
      connected: boolean;
      reason:
        | (
            | "no_credentials"
            | "invalid_credentials"
            | "no_property"
            | "no_access"
            | "api_disabled"
            | "quota"
            | "error"
          )
        | null;
      message: string | null;
      clientEmail: string | null;
      resource: string | null;
    };
    data: {
      activeUsers: number;
      pages: {
        page: string;
        activeUsers: number;
      }[];
      countries: {
        country: string;
        countryId: string | null;
        activeUsers: number;
      }[];
      devices: {
        device: string;
        activeUsers: number;
      }[];
      perMinute: {
        minutesAgo: number;
        activeUsers: number;
      }[];
      fetchedAt: string;
    } | null;
  };
}

export interface GetGoogleFunnelResponse {
  data: {
    range: {
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      from: string;
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      to: string;
      days: number;
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      previousFrom: string;
      /** @pattern ^\d{4}-\d{2}-\d{2}$ */
      previousTo: string;
      includesToday: boolean;
      granularity: "hour" | "day";
      isToday: boolean;
      compare: boolean;
    };
    ga4: {
      connected: boolean;
      reason:
        | (
            | "no_credentials"
            | "invalid_credentials"
            | "no_property"
            | "no_access"
            | "api_disabled"
            | "quota"
            | "error"
          )
        | null;
      message: string | null;
      clientEmail: string | null;
      resource: string | null;
    };
    freeCourses: {
      id: string;
      title: string;
    }[];
    steps: {
      key:
        | "visits"
        | "engaged"
        | "clickedCta"
        | "attempts"
        | "registered"
        | "enrolledFree"
        | "completedFree"
        | "purchased";
      current: number | null;
      previous: number | null;
      source?: "propio" | "ga4" | "mixto";
      ga4?: number | null;
      firstPartySince?: string | null;
    }[];
    activity: {
      current: {
        sessions: number | null;
        users: number | null;
        realSessions?: number;
        attempts: number;
        registrations: number;
        enrollments: number;
        freeEnrollments: number;
        completions: number;
        purchases: number;
        revenueInCents: number;
      };
      previous: {
        sessions: number | null;
        users: number | null;
        realSessions?: number;
        attempts: number;
        registrations: number;
        enrollments: number;
        freeEnrollments: number;
        completions: number;
        purchases: number;
        revenueInCents: number;
      } | null;
    };
    revenueByCurrency: {
      currency: string;
      amountInCents: number;
      orders: number;
    }[];
    daily: {
      date: string;
      /**
       * @min 0
       * @max 23
       */
      hour?: number;
      sessions: number | null;
      users: number | null;
      realSessions?: number | null;
      attempts: number;
      registrations: number;
      enrollments: number;
      freeEnrollments: number;
      completions: number;
      purchases: number;
      revenueInCents: number;
    }[];
    hourly?: {
      date: string;
      /**
       * @min 0
       * @max 23
       */
      hour?: number;
      sessions: number | null;
      users: number | null;
      realSessions?: number | null;
      attempts: number;
      registrations: number;
      enrollments: number;
      freeEnrollments: number;
      completions: number;
      purchases: number;
      revenueInCents: number;
    }[];
    bySource: {
      source: string;
      medium: string;
      sessions: number | null;
      attempts: number;
      registered: number;
      enrolledFree: number;
      completedFree: number;
      purchased: number;
      revenueInCents: number;
    }[];
    byCampaign: {
      campaign: string;
      source: string;
      medium: string;
      sessions: number | null;
      attempts: number;
      registered: number;
      enrolledFree: number;
      completedFree: number;
      purchased: number;
      revenueInCents: number;
    }[];
  };
}

export interface GetStatusResponse {
  data: {
    id:
      | "tiktok"
      | "tiktok_ads"
      | "instagram"
      | "facebook"
      | "meta_ads"
      | "youtube"
      | "x"
      | "google_ads"
      | "linkedin";
    name: string;
    state:
      | "connected"
      | "connected_no_data"
      | "missing_permission"
      | "not_connected"
      | "not_configured"
      | "api_disabled"
      | "error";
    kind: "live" | "static";
    message: string | null;
    missingKeys: string[];
    setupHref: string;
    docsUrl: string | null;
    dayTimeZone: string | null;
    connectedSince: string | null;
    /** @format date-time */
    checkedAt: string;
    canUploadDrafts?: boolean;
    actionUrl?: string;
    ownerAnalytics?: {
      state: "not_configured" | "not_connected" | "connected" | "api_disabled" | "error";
      message: string | null;
      actionUrl?: string;
      connectedSince: string | null;
    };
  }[];
}

export interface GetFacebookResponse {
  data: {
    status: {
      id:
        | "tiktok"
        | "tiktok_ads"
        | "instagram"
        | "facebook"
        | "meta_ads"
        | "youtube"
        | "x"
        | "google_ads"
        | "linkedin";
      name: string;
      state:
        | "connected"
        | "connected_no_data"
        | "missing_permission"
        | "not_connected"
        | "not_configured"
        | "api_disabled"
        | "error";
      kind: "live" | "static";
      message: string | null;
      missingKeys: string[];
      setupHref: string;
      docsUrl: string | null;
      dayTimeZone: string | null;
      connectedSince: string | null;
      /** @format date-time */
      checkedAt: string;
      canUploadDrafts?: boolean;
      actionUrl?: string;
      ownerAnalytics?: {
        state: "not_configured" | "not_connected" | "connected" | "api_disabled" | "error";
        message: string | null;
        actionUrl?: string;
        connectedSince: string | null;
      };
    };
    range: {
      from: string;
      to: string;
      includesToday: boolean;
      granularity: "hour" | "day";
    };
    sourceRange: {
      from: string;
      to: string;
    };
    /** @format date-time */
    fetchedAt: string;
    partial: boolean;
    kpis: {
      key: string;
      label: string;
      value: number | null;
      previous: number | null;
      hint?: string;
      unit?: "count" | "usd" | "pct" | "ms";
    }[];
    series: {
      day: string;
      /**
       * @min 0
       * @max 23
       */
      hour?: number;
      values: object;
    }[];
    top: {
      id: string;
      title: string;
      url: string | null;
      publishedAt: string | null;
      metrics: object;
    }[];
    topLabel?: string;
    notes: string[];
  };
}

export interface GetInstagramResponse {
  data: {
    status: {
      id:
        | "tiktok"
        | "tiktok_ads"
        | "instagram"
        | "facebook"
        | "meta_ads"
        | "youtube"
        | "x"
        | "google_ads"
        | "linkedin";
      name: string;
      state:
        | "connected"
        | "connected_no_data"
        | "missing_permission"
        | "not_connected"
        | "not_configured"
        | "api_disabled"
        | "error";
      kind: "live" | "static";
      message: string | null;
      missingKeys: string[];
      setupHref: string;
      docsUrl: string | null;
      dayTimeZone: string | null;
      connectedSince: string | null;
      /** @format date-time */
      checkedAt: string;
      canUploadDrafts?: boolean;
      actionUrl?: string;
      ownerAnalytics?: {
        state: "not_configured" | "not_connected" | "connected" | "api_disabled" | "error";
        message: string | null;
        actionUrl?: string;
        connectedSince: string | null;
      };
    };
    range: {
      from: string;
      to: string;
      includesToday: boolean;
      granularity: "hour" | "day";
    };
    sourceRange: {
      from: string;
      to: string;
    };
    /** @format date-time */
    fetchedAt: string;
    partial: boolean;
    kpis: {
      key: string;
      label: string;
      value: number | null;
      previous: number | null;
      hint?: string;
      unit?: "count" | "usd" | "pct" | "ms";
    }[];
    series: {
      day: string;
      /**
       * @min 0
       * @max 23
       */
      hour?: number;
      values: object;
    }[];
    top: {
      id: string;
      title: string;
      url: string | null;
      publishedAt: string | null;
      metrics: object;
    }[];
    topLabel?: string;
    notes: string[];
  };
}

export interface GetMetaAdsResponse {
  data: {
    status: {
      id:
        | "tiktok"
        | "tiktok_ads"
        | "instagram"
        | "facebook"
        | "meta_ads"
        | "youtube"
        | "x"
        | "google_ads"
        | "linkedin";
      name: string;
      state:
        | "connected"
        | "connected_no_data"
        | "missing_permission"
        | "not_connected"
        | "not_configured"
        | "api_disabled"
        | "error";
      kind: "live" | "static";
      message: string | null;
      missingKeys: string[];
      setupHref: string;
      docsUrl: string | null;
      dayTimeZone: string | null;
      connectedSince: string | null;
      /** @format date-time */
      checkedAt: string;
      canUploadDrafts?: boolean;
      actionUrl?: string;
      ownerAnalytics?: {
        state: "not_configured" | "not_connected" | "connected" | "api_disabled" | "error";
        message: string | null;
        actionUrl?: string;
        connectedSince: string | null;
      };
    };
    range: {
      from: string;
      to: string;
      includesToday: boolean;
      granularity: "hour" | "day";
    };
    sourceRange: {
      from: string;
      to: string;
    };
    /** @format date-time */
    fetchedAt: string;
    partial: boolean;
    kpis: {
      key: string;
      label: string;
      value: number | null;
      previous: number | null;
      hint?: string;
      unit?: "count" | "usd" | "pct" | "ms";
    }[];
    series: {
      day: string;
      /**
       * @min 0
       * @max 23
       */
      hour?: number;
      values: object;
    }[];
    top: {
      id: string;
      title: string;
      url: string | null;
      publishedAt: string | null;
      metrics: object;
    }[];
    topLabel?: string;
    notes: string[];
  };
}

export interface GetTikTokResponse {
  data: {
    status: {
      id:
        | "tiktok"
        | "tiktok_ads"
        | "instagram"
        | "facebook"
        | "meta_ads"
        | "youtube"
        | "x"
        | "google_ads"
        | "linkedin";
      name: string;
      state:
        | "connected"
        | "connected_no_data"
        | "missing_permission"
        | "not_connected"
        | "not_configured"
        | "api_disabled"
        | "error";
      kind: "live" | "static";
      message: string | null;
      missingKeys: string[];
      setupHref: string;
      docsUrl: string | null;
      dayTimeZone: string | null;
      connectedSince: string | null;
      /** @format date-time */
      checkedAt: string;
      canUploadDrafts?: boolean;
      actionUrl?: string;
      ownerAnalytics?: {
        state: "not_configured" | "not_connected" | "connected" | "api_disabled" | "error";
        message: string | null;
        actionUrl?: string;
        connectedSince: string | null;
      };
    };
    range: {
      from: string;
      to: string;
      includesToday: boolean;
      granularity: "hour" | "day";
    };
    sourceRange: {
      from: string;
      to: string;
    };
    /** @format date-time */
    fetchedAt: string;
    partial: boolean;
    kpis: {
      key: string;
      label: string;
      value: number | null;
      previous: number | null;
      hint?: string;
      unit?: "count" | "usd" | "pct" | "ms";
    }[];
    series: {
      day: string;
      /**
       * @min 0
       * @max 23
       */
      hour?: number;
      values: object;
    }[];
    top: {
      id: string;
      title: string;
      url: string | null;
      publishedAt: string | null;
      metrics: object;
    }[];
    topLabel?: string;
    notes: string[];
  };
}

export interface GetYouTubeResponse {
  data: {
    status: {
      id:
        | "tiktok"
        | "tiktok_ads"
        | "instagram"
        | "facebook"
        | "meta_ads"
        | "youtube"
        | "x"
        | "google_ads"
        | "linkedin";
      name: string;
      state:
        | "connected"
        | "connected_no_data"
        | "missing_permission"
        | "not_connected"
        | "not_configured"
        | "api_disabled"
        | "error";
      kind: "live" | "static";
      message: string | null;
      missingKeys: string[];
      setupHref: string;
      docsUrl: string | null;
      dayTimeZone: string | null;
      connectedSince: string | null;
      /** @format date-time */
      checkedAt: string;
      canUploadDrafts?: boolean;
      actionUrl?: string;
      ownerAnalytics?: {
        state: "not_configured" | "not_connected" | "connected" | "api_disabled" | "error";
        message: string | null;
        actionUrl?: string;
        connectedSince: string | null;
      };
    };
    range: {
      from: string;
      to: string;
      includesToday: boolean;
      granularity: "hour" | "day";
    };
    sourceRange: {
      from: string;
      to: string;
    };
    /** @format date-time */
    fetchedAt: string;
    partial: boolean;
    kpis: {
      key: string;
      label: string;
      value: number | null;
      previous: number | null;
      hint?: string;
      unit?: "count" | "usd" | "pct" | "ms";
    }[];
    series: {
      day: string;
      /**
       * @min 0
       * @max 23
       */
      hour?: number;
      values: object;
    }[];
    top: {
      id: string;
      title: string;
      url: string | null;
      publishedAt: string | null;
      metrics: object;
    }[];
    topLabel?: string;
    notes: string[];
  };
}

export interface GetTikTokAdsResponse {
  data: {
    status: {
      id:
        | "tiktok"
        | "tiktok_ads"
        | "instagram"
        | "facebook"
        | "meta_ads"
        | "youtube"
        | "x"
        | "google_ads"
        | "linkedin";
      name: string;
      state:
        | "connected"
        | "connected_no_data"
        | "missing_permission"
        | "not_connected"
        | "not_configured"
        | "api_disabled"
        | "error";
      kind: "live" | "static";
      message: string | null;
      missingKeys: string[];
      setupHref: string;
      docsUrl: string | null;
      dayTimeZone: string | null;
      connectedSince: string | null;
      /** @format date-time */
      checkedAt: string;
      canUploadDrafts?: boolean;
      actionUrl?: string;
      ownerAnalytics?: {
        state: "not_configured" | "not_connected" | "connected" | "api_disabled" | "error";
        message: string | null;
        actionUrl?: string;
        connectedSince: string | null;
      };
    };
    range: {
      from: string;
      to: string;
      includesToday: boolean;
      granularity: "hour" | "day";
    };
    sourceRange: {
      from: string;
      to: string;
    };
    /** @format date-time */
    fetchedAt: string;
    partial: boolean;
    kpis: {
      key: string;
      label: string;
      value: number | null;
      previous: number | null;
      hint?: string;
      unit?: "count" | "usd" | "pct" | "ms";
    }[];
    series: {
      day: string;
      /**
       * @min 0
       * @max 23
       */
      hour?: number;
      values: object;
    }[];
    top: {
      id: string;
      title: string;
      url: string | null;
      publishedAt: string | null;
      metrics: object;
    }[];
    topLabel?: string;
    notes: string[];
  };
}

export interface ConnectResponse {
  data: {
    url: string;
  };
}

export interface AdsConnectResponse {
  data: {
    url: string;
  };
}

export interface AdsExchangeBody {
  /**
   * @minLength 8
   * @maxLength 512
   */
  authCode: string;
}

export interface AdsExchangeResponse {
  data: {
    ok: boolean;
    motivo:
      | (
          | "estado_invalido"
          | "cancelado"
          | "permiso_parcial"
          | "canje_fallido"
          | "cuenta_distinta"
          | "sin_configurar"
          | "error_tiktok"
        )
      | null;
  };
}

export interface DisconnectBody {
  product: "display" | "ads";
}

export interface DisconnectResponse {
  data: {
    ok: boolean;
  };
}

export interface GetIndexNowKeyResponse {
  data: {
    key: string | null;
  };
}

export interface GetIndexNowStatusResponse {
  data: {
    enabled: boolean;
    reason: string | null;
    siteUrl: string;
    keyConfigured: boolean;
    keyValid: boolean;
    keySource: "secret" | "env" | null;
    keyLocation: string | null;
    keyServed: boolean | null;
    lastSubmission: {
      at: string;
      source: string;
      urlCount: number;
      ok: boolean;
      batches: {
        status: number | null;
        count: number;
        error: string | null;
      }[];
      message: string;
    } | null;
  };
}

export interface SubmitAllToIndexNowResponse {
  data: {
    at: string;
    source: string;
    urlCount: number;
    ok: boolean;
    batches: {
      status: number | null;
      count: number;
      error: string | null;
    }[];
    message: string;
  };
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AcademIA API
 * @version 1.0
 * @contact
 *
 * AcademIA LMS REST API
 */
export class API<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @name AuthControllerSendOtp
     * @request POST:/api/auth/send-otp
     */
    authControllerSendOtp: (data: SendOTPBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/auth/send-otp`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthControllerGetAuthBotCheckConfig
     * @request GET:/api/auth/bot-check/config
     */
    authControllerGetAuthBotCheckConfig: (params: RequestParams = {}) =>
      this.request<GetAuthBotCheckConfigResponse, any>({
        path: `/api/auth/bot-check/config`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthControllerVerifyOtp
     * @request POST:/api/auth/verify-otp
     */
    authControllerVerifyOtp: (data: VerifyOTPBody, params: RequestParams = {}) =>
      this.request<VerifyOTPResponse, any>({
        path: `/api/auth/verify-otp`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthControllerRegister
     * @request POST:/api/auth/register
     */
    authControllerRegister: (data: RegisterBody, params: RequestParams = {}) =>
      this.request<RegisterResponse, any>({
        path: `/api/auth/register`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthControllerLogout
     * @request POST:/api/auth/logout
     */
    authControllerLogout: (params: RequestParams = {}) =>
      this.request<LogoutResponse, any>({
        path: `/api/auth/logout`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthControllerRefreshTokens
     * @request POST:/api/auth/refresh
     */
    authControllerRefreshTokens: (params: RequestParams = {}) =>
      this.request<RefreshTokensResponse, any>({
        path: `/api/auth/refresh`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthControllerCurrentUser
     * @request GET:/api/auth/current-user
     */
    authControllerCurrentUser: (params: RequestParams = {}) =>
      this.request<CurrentUserResponse, any>({
        path: `/api/auth/current-user`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StatisticsControllerGetUserStatistics
     * @request GET:/api/statistics/user-stats
     */
    statisticsControllerGetUserStatistics: (
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserStatisticsResponse, any>({
        path: `/api/statistics/user-stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StatisticsControllerGetAdminOverview
     * @request GET:/api/statistics/overview
     */
    statisticsControllerGetAdminOverview: (
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAdminOverviewResponse, any>({
        path: `/api/statistics/overview`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerProxyFile
     * @request GET:/api/file/proxy/*
     */
    fileControllerProxyFile: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/file/proxy/*`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerUploadFile
     * @request POST:/api/file
     */
    fileControllerUploadFile: (
      data: {
        /** @format binary */
        file?: File;
        /** Optional resource type */
        resource?: string;
        /** Optional lesson ID for existing lessons */
        lessonId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FileUploadResponse, any>({
        path: `/api/file`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerDeleteFile
     * @request DELETE:/api/file
     */
    fileControllerDeleteFile: (
      query: {
        /** Key of the file to delete */
        fileKey: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/file`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerInitVideoUpload
     * @request POST:/api/file/videos/init
     */
    fileControllerInitVideoUpload: (data: InitVideoUploadBody, params: RequestParams = {}) =>
      this.request<InitVideoUploadResponse, any>({
        path: `/api/file/videos/init`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerTusOptionsBase
     * @request OPTIONS:/api/file/videos/tus
     */
    fileControllerTusOptionsBase: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/file/videos/tus`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerCreateTusUpload
     * @request POST:/api/file/videos/tus
     */
    fileControllerCreateTusUpload: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/file/videos/tus`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerTusOptionsUpload
     * @request OPTIONS:/api/file/videos/tus/{id}
     */
    fileControllerTusOptionsUpload: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/file/videos/tus/${id}`,
        method: "OPTIONS",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerGetTusUpload
     * @request HEAD:/api/file/videos/tus/{id}
     */
    fileControllerGetTusUpload: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/file/videos/tus/${id}`,
        method: "HEAD",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerPatchTusUpload
     * @request PATCH:/api/file/videos/tus/{id}
     */
    fileControllerPatchTusUpload: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/file/videos/tus/${id}`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerGetVideoUploadStatus
     * @request GET:/api/file/videos/{id}
     */
    fileControllerGetVideoUploadStatus: (id: string, params: RequestParams = {}) =>
      this.request<GetVideoUploadStatusResponse, any>({
        path: `/api/file/videos/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name FileControllerHandleBunnyWebhook
     * @request POST:/api/file/bunny/webhook
     */
    fileControllerHandleBunnyWebhook: (data: HandleBunnyWebhookBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/file/bunny/webhook`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUsers
     * @request GET:/api/user/all
     */
    userControllerGetUsers: (
      query?: {
        keyword?: string;
        role?: "admin" | "student" | "content_creator";
        archived?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?:
          | "firstName"
          | "lastName"
          | "phone"
          | "email"
          | "createdAt"
          | "groupName"
          | "-firstName"
          | "-lastName"
          | "-phone"
          | "-email"
          | "-createdAt"
          | "-groupName";
        groups?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUsersResponse, any>({
        path: `/api/user/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUserById
     * @request GET:/api/user
     */
    userControllerGetUserById: (
      query: {
        /** @format uuid */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserByIdResponse, any>({
        path: `/api/user`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerUpdateUser
     * @request PATCH:/api/user
     */
    userControllerUpdateUser: (
      query: {
        /** @format uuid */
        id: string;
      },
      data: UpdateUserBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserResponse, any>({
        path: `/api/user`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerDeleteBulkUsers
     * @request DELETE:/api/user
     */
    userControllerDeleteBulkUsers: (data: DeleteBulkUsersBody, params: RequestParams = {}) =>
      this.request<DeleteBulkUsersResponse, any>({
        path: `/api/user`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerCreateUser
     * @request POST:/api/user
     */
    userControllerCreateUser: (data: CreateUserBody, params: RequestParams = {}) =>
      this.request<CreateUserResponse, any>({
        path: `/api/user`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUserCoursesProgress
     * @request GET:/api/user/{id}/courses-progress
     */
    userControllerGetUserCoursesProgress: (id: string, params: RequestParams = {}) =>
      this.request<GetUserCoursesProgressResponse, any>({
        path: `/api/user/${id}/courses-progress`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUserOrders
     * @request GET:/api/user/{id}/orders
     */
    userControllerGetUserOrders: (id: string, params: RequestParams = {}) =>
      this.request<GetUserOrdersResponse, any>({
        path: `/api/user/${id}/orders`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUserActivity
     * @request GET:/api/user/{id}/activity
     */
    userControllerGetUserActivity: (id: string, params: RequestParams = {}) =>
      this.request<GetUserActivityResponse, any>({
        path: `/api/user/${id}/activity`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetSecurityStatus
     * @request GET:/api/user/security
     */
    userControllerGetSecurityStatus: (params: RequestParams = {}) =>
      this.request<GetSecurityStatusResponse, any>({
        path: `/api/user/security`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerGetUserDetails
     * @request GET:/api/user/details
     */
    userControllerGetUserDetails: (
      query: {
        /** @format uuid */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserDetailsResponse, any>({
        path: `/api/user/details`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerUpsertUserDetails
     * @request PATCH:/api/user/details
     */
    userControllerUpsertUserDetails: (data: UpsertUserDetailsBody, params: RequestParams = {}) =>
      this.request<UpsertUserDetailsResponse, any>({
        path: `/api/user/details`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerChangePhone
     * @request PATCH:/api/user/phone
     */
    userControllerChangePhone: (data: ChangePhoneBody, params: RequestParams = {}) =>
      this.request<ChangePhoneResponse, any>({
        path: `/api/user/phone`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerUpdateUserProfile
     * @request PATCH:/api/user/profile
     */
    userControllerUpdateUserProfile: (
      data: {
        /** @format binary */
        userAvatar?: File;
        /** @format string */
        data?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/user/profile`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerAdminUpdateUser
     * @request PATCH:/api/user/admin
     */
    userControllerAdminUpdateUser: (
      query: {
        /** @format uuid */
        id: string;
      },
      data: AdminUpdateUserBody,
      params: RequestParams = {},
    ) =>
      this.request<AdminUpdateUserResponse, any>({
        path: `/api/user/admin`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerBulkAssignUsersToGroup
     * @request PATCH:/api/user/bulk/groups
     */
    userControllerBulkAssignUsersToGroup: (
      data: BulkAssignUsersToGroupBody,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/user/bulk/groups`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerArchiveBulkUsers
     * @request PATCH:/api/user/bulk/archive
     */
    userControllerArchiveBulkUsers: (data: ArchiveBulkUsersBody, params: RequestParams = {}) =>
      this.request<ArchiveBulkUsersResponse, any>({
        path: `/api/user/bulk/archive`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerBulkUpdateUsersRoles
     * @request PATCH:/api/user/bulk/roles
     */
    userControllerBulkUpdateUsersRoles: (
      data: BulkUpdateUsersRolesBody,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/user/bulk/roles`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerImportUsers
     * @request POST:/api/user/import
     */
    userControllerImportUsers: (
      data: {
        /** @format binary */
        usersFile?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImportUsersResponse, any>({
        path: `/api/user/import`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerResetOnboardingStatus
     * @request PATCH:/api/user/onboarding-status/reset
     */
    userControllerResetOnboardingStatus: (params: RequestParams = {}) =>
      this.request<ResetOnboardingStatusResponse, any>({
        path: `/api/user/onboarding-status/reset`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UserControllerMarkOnboardingComplete
     * @request PATCH:/api/user/onboarding-status/{page}
     */
    userControllerMarkOnboardingComplete: (page: string, params: RequestParams = {}) =>
      this.request<MarkOnboardingCompleteResponse, any>({
        path: `/api/user/onboarding-status/${page}`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerGetPublicGlobalSettings
     * @request GET:/api/settings/global
     */
    settingsControllerGetPublicGlobalSettings: (params: RequestParams = {}) =>
      this.request<GetPublicGlobalSettingsResponse, any>({
        path: `/api/settings/global`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerGetUserSettings
     * @request GET:/api/settings
     */
    settingsControllerGetUserSettings: (params: RequestParams = {}) =>
      this.request<GetUserSettingsResponse, any>({
        path: `/api/settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateUserSettings
     * @request PUT:/api/settings
     */
    settingsControllerUpdateUserSettings: (
      data: UpdateUserSettingsBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserSettingsResponse, any>({
        path: `/api/settings`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateUnregisteredUserCoursesAccessibility
     * @request PATCH:/api/settings/admin/unregistered-user-courses-accessibility
     */
    settingsControllerUpdateUnregisteredUserCoursesAccessibility: (params: RequestParams = {}) =>
      this.request<UpdateUnregisteredUserCoursesAccessibilityResponse, any>({
        path: `/api/settings/admin/unregistered-user-courses-accessibility`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateEnforceSso
     * @request PATCH:/api/settings/admin/enforce-sso
     */
    settingsControllerUpdateEnforceSso: (params: RequestParams = {}) =>
      this.request<UpdateEnforceSSOResponse, any>({
        path: `/api/settings/admin/enforce-sso`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerGetPlatformLogo
     * @request GET:/api/settings/platform-logo
     */
    settingsControllerGetPlatformLogo: (params: RequestParams = {}) =>
      this.request<GetPlatformLogoResponse, any>({
        path: `/api/settings/platform-logo`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdatePlatformLogo
     * @request PATCH:/api/settings/platform-logo
     */
    settingsControllerUpdatePlatformLogo: (
      data: {
        /** @format binary */
        logo?: File | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/settings/platform-logo`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerGetPlatformSimpleLogo
     * @request GET:/api/settings/platform-simple-logo
     */
    settingsControllerGetPlatformSimpleLogo: (params: RequestParams = {}) =>
      this.request<GetPlatformSimpleLogoResponse, any>({
        path: `/api/settings/platform-simple-logo`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdatePlatformSimpleLogo
     * @request PATCH:/api/settings/platform-simple-logo
     */
    settingsControllerUpdatePlatformSimpleLogo: (
      data: {
        /** @format binary */
        logo?: File | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/settings/platform-simple-logo`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerGetLoginBackground
     * @request GET:/api/settings/login-background
     */
    settingsControllerGetLoginBackground: (params: RequestParams = {}) =>
      this.request<GetLoginBackgroundResponse, any>({
        path: `/api/settings/login-background`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateLoginBackground
     * @request PATCH:/api/settings/login-background
     */
    settingsControllerUpdateLoginBackground: (
      data: {
        /** @format binary */
        "login-background"?: File | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/settings/login-background`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerGetCompanyInformation
     * @request GET:/api/settings/company-information
     */
    settingsControllerGetCompanyInformation: (params: RequestParams = {}) =>
      this.request<GetCompanyInformationResponse, any>({
        path: `/api/settings/company-information`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateCompanyInformation
     * @request PATCH:/api/settings/company-information
     */
    settingsControllerUpdateCompanyInformation: (
      data: UpdateCompanyInformationBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCompanyInformationResponse, any>({
        path: `/api/settings/company-information`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateMfaEnforcedRoles
     * @request PATCH:/api/settings/admin/mfa-enforced-roles
     */
    settingsControllerUpdateMfaEnforcedRoles: (
      data: UpdateMFAEnforcedRolesBody,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/settings/admin/mfa-enforced-roles`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateCertificateBackground
     * @request PATCH:/api/settings/certificate-background
     */
    settingsControllerUpdateCertificateBackground: (
      data: {
        /** @format binary */
        "certificate-background"?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/settings/certificate-background`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateDefaultCourseCurrency
     * @request PATCH:/api/settings/admin/default-course-currency
     */
    settingsControllerUpdateDefaultCourseCurrency: (
      data: UpdateDefaultCourseCurrencyBody,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/settings/admin/default-course-currency`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateInviteOnlyRegistration
     * @request PATCH:/api/settings/admin/invite-only-registration
     */
    settingsControllerUpdateInviteOnlyRegistration: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/settings/admin/invite-only-registration`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateConfigWarningDismissed
     * @request PATCH:/api/settings/admin/config-warning-dismissed
     */
    settingsControllerUpdateConfigWarningDismissed: (
      data: UpdateConfigWarningDismissedBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateConfigWarningDismissedResponse, any>({
        path: `/api/settings/admin/config-warning-dismissed`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateQaSetting
     * @request PATCH:/api/settings/admin/qa/{setting}
     */
    settingsControllerUpdateQaSetting: (
      setting: "QAEnabled" | "unregisteredUserQAAccessibility",
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/settings/admin/qa/${setting}`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateNewsSetting
     * @request PATCH:/api/settings/admin/news/{setting}
     */
    settingsControllerUpdateNewsSetting: (
      setting: "newsEnabled" | "unregisteredUserNewsAccessibility",
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/settings/admin/news/${setting}`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateArticlesSetting
     * @request PATCH:/api/settings/admin/articles/{setting}
     */
    settingsControllerUpdateArticlesSetting: (
      setting: "articlesEnabled" | "unregisteredUserArticlesAccessibility",
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/settings/admin/articles/${setting}`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateAgeLimit
     * @request PATCH:/api/settings/admin/age-limit
     */
    settingsControllerUpdateAgeLimit: (data: UpdateAgeLimitBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/settings/admin/age-limit`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerUpdateLoginPageFiles
     * @request PATCH:/api/settings/admin/login-page-files
     */
    settingsControllerUpdateLoginPageFiles: (
      data: {
        /** @format binary */
        file: File;
        /** @format uuid */
        id?: string;
        /** @minLength 1 */
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/settings/admin/login-page-files`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerGetLoginPageFiles
     * @request GET:/api/settings/login-page-files
     */
    settingsControllerGetLoginPageFiles: (params: RequestParams = {}) =>
      this.request<GetLoginPageFilesResponse, any>({
        path: `/api/settings/login-page-files`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SettingsControllerDeleteLoginPageFile
     * @request DELETE:/api/settings/login-page-files/{id}
     */
    settingsControllerDeleteLoginPageFile: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/settings/login-page-files/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupControllerGetAllGroups
     * @request GET:/api/group/all
     */
    groupControllerGetAllGroups: (
      query?: {
        keyword?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllGroupsResponse, any>({
        path: `/api/group/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupControllerGetGroupById
     * @request GET:/api/group/{groupId}
     */
    groupControllerGetGroupById: (groupId: string, params: RequestParams = {}) =>
      this.request<GetGroupByIdResponse, any>({
        path: `/api/group/${groupId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupControllerUpdateGroup
     * @request PATCH:/api/group/{groupId}
     */
    groupControllerUpdateGroup: (
      groupId: string,
      data: UpdateGroupBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateGroupResponse, any>({
        path: `/api/group/${groupId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupControllerDeleteGroup
     * @request DELETE:/api/group/{groupId}
     */
    groupControllerDeleteGroup: (groupId: string, params: RequestParams = {}) =>
      this.request<DeleteGroupResponse, any>({
        path: `/api/group/${groupId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupControllerGetUserGroups
     * @request GET:/api/group/user/{userId}
     */
    groupControllerGetUserGroups: (
      userId: string,
      query?: {
        keyword?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetUserGroupsResponse, any>({
        path: `/api/group/user/${userId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupControllerCreateGroup
     * @request POST:/api/group
     */
    groupControllerCreateGroup: (data: CreateGroupBody, params: RequestParams = {}) =>
      this.request<CreateGroupResponse, any>({
        path: `/api/group`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupControllerBulkDeleteGroups
     * @request DELETE:/api/group
     */
    groupControllerBulkDeleteGroups: (data: BulkDeleteGroupsBody, params: RequestParams = {}) =>
      this.request<BulkDeleteGroupsResponse, any>({
        path: `/api/group`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupControllerSetUserGroups
     * @request POST:/api/group/set
     */
    groupControllerSetUserGroups: (
      data: GroupIds,
      query?: {
        /** @format uuid */
        userId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SetUserGroupsResponse, any>({
        path: `/api/group/set`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GroupControllerGetGroupsByCourse
     * @request GET:/api/group/by-course/{courseId}
     */
    groupControllerGetGroupsByCourse: (courseId: string, params: RequestParams = {}) =>
      this.request<GetGroupsByCourseResponse, any>({
        path: `/api/group/by-course/${courseId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetAllCourses
     * @request GET:/api/course/all
     */
    courseControllerGetAllCourses: (
      query?: {
        title?: string;
        description?: string;
        searchQuery?: string;
        category?: string;
        author?: string;
        creationDateRange?: string[];
        status?: "draft" | "published" | "private";
        sort?:
          | "title"
          | "category"
          | "creationDate"
          | "author"
          | "chapterCount"
          | "enrolledParticipantsCount"
          | "-title"
          | "-category"
          | "-creationDate"
          | "-author"
          | "-chapterCount"
          | "-enrolledParticipantsCount";
        /** @min 1 */
        page?: number;
        perPage?: number;
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllCoursesResponse, any>({
        path: `/api/course/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetStudentCourses
     * @request GET:/api/course/get-student-courses
     */
    courseControllerGetStudentCourses: (
      query?: {
        title?: string;
        description?: string;
        searchQuery?: string;
        category?: string;
        author?: string;
        "creationDateRange[0]"?: string;
        "creationDateRange[1]"?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?:
          | "title"
          | "category"
          | "creationDate"
          | "author"
          | "chapterCount"
          | "enrolledParticipantsCount"
          | "-title"
          | "-category"
          | "-creationDate"
          | "-author"
          | "-chapterCount"
          | "-enrolledParticipantsCount";
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetStudentCoursesResponse, any>({
        path: `/api/course/get-student-courses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetStudentsWithEnrollmentDate
     * @request GET:/api/course/{courseId}/students
     */
    courseControllerGetStudentsWithEnrollmentDate: (
      courseId: string,
      query?: {
        keyword?: string;
        sort?:
          | "enrolledAt"
          | "firstName"
          | "lastName"
          | "isEnrolledByGroup"
          | "-enrolledAt"
          | "-firstName"
          | "-lastName"
          | "-isEnrolledByGroup";
        groups?: string[];
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetStudentsWithEnrollmentDateResponse, any>({
        path: `/api/course/${courseId}/students`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetAvailableCourses
     * @request GET:/api/course/available-courses
     */
    courseControllerGetAvailableCourses: (
      query?: {
        title?: string;
        description?: string;
        searchQuery?: string;
        category?: string;
        author?: string;
        "creationDateRange[0]"?: string;
        "creationDateRange[1]"?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?:
          | "title"
          | "category"
          | "creationDate"
          | "author"
          | "chapterCount"
          | "enrolledParticipantsCount"
          | "-title"
          | "-category"
          | "-creationDate"
          | "-author"
          | "-chapterCount"
          | "-enrolledParticipantsCount";
        /** @format uuid */
        excludeCourseId?: string;
        /** @default "es" */
        language?: "en" | "es";
        /** @default "es" */
        filterLanguage?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAvailableCoursesResponse, any>({
        path: `/api/course/available-courses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetContentCreatorCourses
     * @request GET:/api/course/content-creator-courses
     */
    courseControllerGetContentCreatorCourses: (
      query: {
        /** @format uuid */
        authorId: string;
        scope?: "all" | "enrolled" | "available";
        /** @format uuid */
        excludeCourseId?: string;
        title?: string;
        description?: string;
        searchQuery?: string;
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetContentCreatorCoursesResponse, any>({
        path: `/api/course/content-creator-courses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetCourse
     * @request GET:/api/course
     */
    courseControllerGetCourse: (
      query: {
        id: string;
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCourseResponse, any>({
        path: `/api/course`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerCreateCourse
     * @request POST:/api/course
     */
    courseControllerCreateCourse: (data: CreateCourseBody, params: RequestParams = {}) =>
      this.request<CreateCourseResponse, any>({
        path: `/api/course`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerLookupCourse
     * @request GET:/api/course/lookup
     */
    courseControllerLookupCourse: (
      query: {
        id: string;
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<LookupCourseResponse, any>({
        path: `/api/course/lookup`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetBetaCourseById
     * @request GET:/api/course/beta-course-by-id
     */
    courseControllerGetBetaCourseById: (
      query: {
        /** @format uuid */
        id: string;
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetBetaCourseByIdResponse, any>({
        path: `/api/course/beta-course-by-id`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerUpdateCourse
     * @request PATCH:/api/course/{id}
     */
    courseControllerUpdateCourse: (
      id: string,
      data: UpdateCourseBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCourseResponse, any>({
        path: `/api/course/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerUpdateCredentialType
     * @request PATCH:/api/course/{id}/credential-type
     */
    courseControllerUpdateCredentialType: (
      id: string,
      data: UpdateCredentialTypeBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCredentialTypeResponse, any>({
        path: `/api/course/${id}/credential-type`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerUpdateCourseSettings
     * @request PATCH:/api/course/settings/{courseId}
     */
    courseControllerUpdateCourseSettings: (
      courseId: string,
      data: UpdateCourseSettingsBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCourseSettingsResponse, any>({
        path: `/api/course/settings/${courseId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetCourseSettings
     * @request GET:/api/course/settings/{courseId}
     */
    courseControllerGetCourseSettings: (courseId: string, params: RequestParams = {}) =>
      this.request<GetCourseSettingsResponse, any>({
        path: `/api/course/settings/${courseId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetLessonSequenceEnabled
     * @request GET:/api/course/lesson-sequence-enabled/{courseId}
     */
    courseControllerGetLessonSequenceEnabled: (courseId: string, params: RequestParams = {}) =>
      this.request<GetLessonSequenceEnabledResponse, any>({
        path: `/api/course/lesson-sequence-enabled/${courseId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerEnrollCourse
     * @request POST:/api/course/enroll-course
     */
    courseControllerEnrollCourse: (
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EnrollCourseResponse, any>({
        path: `/api/course/enroll-course`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerInstantEnroll
     * @request POST:/api/course/{courseId}/enroll
     */
    courseControllerInstantEnroll: (
      courseId: string,
      query?: {
        accessLevel?: "free_preview" | "full";
      },
      params: RequestParams = {},
    ) =>
      this.request<InstantEnrollResponse, any>({
        path: `/api/course/${courseId}/enroll`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerEnrollCourses
     * @request POST:/api/course/{courseId}/enroll-courses
     */
    courseControllerEnrollCourses: (
      courseId: string,
      data: EnrollCoursesBody,
      params: RequestParams = {},
    ) =>
      this.request<EnrollCoursesResponse, any>({
        path: `/api/course/${courseId}/enroll-courses`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerEnrollGroupsToCourse
     * @request POST:/api/course/{courseId}/enroll-groups-to-course
     */
    courseControllerEnrollGroupsToCourse: (
      courseId: string,
      data: EnrollGroupsToCourseBody,
      params: RequestParams = {},
    ) =>
      this.request<EnrollGroupsToCourseResponse, any>({
        path: `/api/course/${courseId}/enroll-groups-to-course`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerUnenrollGroupsFromCourse
     * @request DELETE:/api/course/{courseId}/unenroll-groups-from-course
     */
    courseControllerUnenrollGroupsFromCourse: (
      courseId: string,
      data: UnenrollGroupsFromCourseBody,
      params: RequestParams = {},
    ) =>
      this.request<UnenrollGroupsFromCourseResponse, any>({
        path: `/api/course/${courseId}/unenroll-groups-from-course`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerDeleteCourse
     * @request DELETE:/api/course/deleteCourse/{id}
     */
    courseControllerDeleteCourse: (id: string, params: RequestParams = {}) =>
      this.request<DeleteCourseResponse, any>({
        path: `/api/course/deleteCourse/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerDeleteManyCourses
     * @request DELETE:/api/course/deleteManyCourses
     */
    courseControllerDeleteManyCourses: (data: DeleteManyCoursesBody, params: RequestParams = {}) =>
      this.request<DeleteManyCoursesResponse, any>({
        path: `/api/course/deleteManyCourses`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerUnenrollCourses
     * @request DELETE:/api/course/unenroll-course
     */
    courseControllerUnenrollCourses: (
      query?: {
        /** @format uuid */
        courseId?: string;
        userIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<UnenrollCoursesResponse, any>({
        path: `/api/course/unenroll-course`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetCourseStatistics
     * @request GET:/api/course/{courseId}/statistics
     */
    courseControllerGetCourseStatistics: (
      courseId: string,
      query?: {
        /** @format uuid */
        groupId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCourseStatisticsResponse, any>({
        path: `/api/course/${courseId}/statistics`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetCourseLearningTimeStatistics
     * @request GET:/api/course/{courseId}/statistics/learning-time
     */
    courseControllerGetCourseLearningTimeStatistics: (
      courseId: string,
      query?: {
        /** @format uuid */
        userId?: string;
        /** @format uuid */
        groupId?: string;
        search?: string;
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
        sort?: "studentName" | "totalSeconds" | "-studentName" | "-totalSeconds";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCourseLearningTimeStatisticsResponse, any>({
        path: `/api/course/${courseId}/statistics/learning-time`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetCourseLearningStatisticsFilterOptions
     * @request GET:/api/course/{courseId}/statistics/learning-time-filter-options
     */
    courseControllerGetCourseLearningStatisticsFilterOptions: (
      courseId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetCourseLearningStatisticsFilterOptionsResponse, any>({
        path: `/api/course/${courseId}/statistics/learning-time-filter-options`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetAverageQuizScores
     * @request GET:/api/course/{courseId}/statistics/average-quiz-score
     */
    courseControllerGetAverageQuizScores: (
      courseId: string,
      query?: {
        /** @format uuid */
        groupId?: string;
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAverageQuizScoresResponse, any>({
        path: `/api/course/${courseId}/statistics/average-quiz-score`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetCourseStudentsProgress
     * @request GET:/api/course/{courseId}/statistics/students-progress
     */
    courseControllerGetCourseStudentsProgress: (
      courseId: string,
      query?: {
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
        search?: string;
        /** @format uuid */
        groupId?: string;
        sort?:
          | "studentName"
          | "groupName"
          | "completedLessonsCount"
          | "lastActivity"
          | "lastCompletedLessonName"
          | "-studentName"
          | "-groupName"
          | "-completedLessonsCount"
          | "-lastActivity"
          | "-lastCompletedLessonName";
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCourseStudentsProgressResponse, any>({
        path: `/api/course/${courseId}/statistics/students-progress`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetCourseStudentsQuizResults
     * @request GET:/api/course/{courseId}/statistics/students-quiz-results
     */
    courseControllerGetCourseStudentsQuizResults: (
      courseId: string,
      query?: {
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
        /** @format uuid */
        quizId?: string;
        /** @format uuid */
        groupId?: string;
        search?: string;
        sort?:
          | "studentName"
          | "quizName"
          | "quizScore"
          | "attempts"
          | "lastAttempt"
          | "-studentName"
          | "-quizName"
          | "-quizScore"
          | "-attempts"
          | "-lastAttempt";
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCourseStudentsQuizResultsResponse, any>({
        path: `/api/course/${courseId}/statistics/students-quiz-results`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetCourseStudentsAiMentorResults
     * @request GET:/api/course/{courseId}/statistics/students-ai-mentor-results
     */
    courseControllerGetCourseStudentsAiMentorResults: (
      courseId: string,
      query?: {
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
        /** @format uuid */
        lessonId?: string;
        /** @format uuid */
        groupId?: string;
        search?: string;
        sort?:
          | "studentName"
          | "lessonName"
          | "score"
          | "lastSession"
          | "lastCompletedLessonName"
          | "-studentName"
          | "-lessonName"
          | "-score"
          | "-lastSession"
          | "-lastCompletedLessonName";
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCourseStudentsAiMentorResultsResponse, any>({
        path: `/api/course/${courseId}/statistics/students-ai-mentor-results`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerTransferCourseOwnership
     * @request POST:/api/course/course-ownership/transfer
     */
    courseControllerTransferCourseOwnership: (
      data: TransferCourseOwnershipBody,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/course/course-ownership/transfer`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseControllerGetCourseOwnership
     * @request GET:/api/course/course-ownership/{courseId}
     */
    courseControllerGetCourseOwnership: (courseId: string, params: RequestParams = {}) =>
      this.request<GetCourseOwnershipResponse, any>({
        path: `/api/course/course-ownership/${courseId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseAuthoringControllerGetDeletionImpact
     * @request GET:/api/course/{courseId}/deletion-impact
     */
    courseAuthoringControllerGetDeletionImpact: (
      courseId: string,
      query?: {
        /** @format uuid */
        chapterId?: string;
        /** @format uuid */
        lessonId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDeletionImpactResponse, any>({
        path: `/api/course/${courseId}/deletion-impact`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseAuthoringControllerGetPublishChecklist
     * @request GET:/api/course/{courseId}/publish-checklist
     */
    courseAuthoringControllerGetPublishChecklist: (courseId: string, params: RequestParams = {}) =>
      this.request<GetPublishChecklistResponse, any>({
        path: `/api/course/${courseId}/publish-checklist`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseAuthoringControllerDuplicateCourse
     * @request POST:/api/course/{courseId}/duplicate
     */
    courseAuthoringControllerDuplicateCourse: (courseId: string, params: RequestParams = {}) =>
      this.request<DuplicateCourseResponse, any>({
        path: `/api/course/${courseId}/duplicate`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChapterControllerGetChapterWithLesson
     * @request GET:/api/chapter
     */
    chapterControllerGetChapterWithLesson: (
      query: {
        /** @format uuid */
        id: string;
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetChapterWithLessonResponse, any>({
        path: `/api/chapter`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChapterControllerUpdateChapter
     * @request PATCH:/api/chapter
     */
    chapterControllerUpdateChapter: (
      data: UpdateChapterBody,
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UpdateChapterResponse, any>({
        path: `/api/chapter`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChapterControllerRemoveChapter
     * @request DELETE:/api/chapter
     */
    chapterControllerRemoveChapter: (
      query: {
        /** @format uuid */
        chapterId: string;
        confirmStudentDataLoss?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RemoveChapterResponse, any>({
        path: `/api/chapter`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChapterControllerBetaCreateChapter
     * @request POST:/api/chapter/beta-create-chapter
     */
    chapterControllerBetaCreateChapter: (data: BetaCreateChapterBody, params: RequestParams = {}) =>
      this.request<BetaCreateChapterResponse, any>({
        path: `/api/chapter/beta-create-chapter`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChapterControllerUpdateChapterDisplayOrder
     * @request PATCH:/api/chapter/chapter-display-order
     */
    chapterControllerUpdateChapterDisplayOrder: (
      data: UpdateChapterDisplayOrderBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateChapterDisplayOrderResponse, any>({
        path: `/api/chapter/chapter-display-order`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ChapterControllerUpdateFreemiumStatus
     * @request PATCH:/api/chapter/freemium-status
     */
    chapterControllerUpdateFreemiumStatus: (
      data: UpdateFreemiumStatusBody,
      query?: {
        /** @format uuid */
        chapterId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UpdateFreemiumStatusResponse, any>({
        path: `/api/chapter/freemium-status`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerGetLessons
     * @request GET:/api/lesson/all
     */
    lessonControllerGetLessons: (
      query?: {
        title?: string;
        description?: string;
        searchQuery?: string;
        lessonCompleted?: string;
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetLessonsResponse, any>({
        path: `/api/lesson/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerGetLessonById
     * @request GET:/api/lesson/{id}
     */
    lessonControllerGetLessonById: (
      id: string,
      query?: {
        /** @default "es" */
        language?: "en" | "es";
        studentId?: string | "";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetLessonByIdResponse, any>({
        path: `/api/lesson/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaCreateLesson
     * @request POST:/api/lesson/beta-create-lesson
     */
    lessonControllerBetaCreateLesson: (data: BetaCreateLessonBody, params: RequestParams = {}) =>
      this.request<BetaCreateLessonResponse, any>({
        path: `/api/lesson/beta-create-lesson`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerInitializeLessonContext
     * @request POST:/api/lesson/initialize-lesson-context
     */
    lessonControllerInitializeLessonContext: (params: RequestParams = {}) =>
      this.request<InitializeLessonContextResponse, any>({
        path: `/api/lesson/initialize-lesson-context`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaCreateAiMentorLesson
     * @request POST:/api/lesson/beta-create-lesson/ai
     */
    lessonControllerBetaCreateAiMentorLesson: (
      data: BetaCreateAiMentorLessonBody,
      params: RequestParams = {},
    ) =>
      this.request<BetaCreateAiMentorLessonResponse, any>({
        path: `/api/lesson/beta-create-lesson/ai`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaUpdateAiMentorLesson
     * @request PATCH:/api/lesson/beta-update-lesson/ai
     */
    lessonControllerBetaUpdateAiMentorLesson: (
      data: BetaUpdateAiMentorLessonBody,
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BetaUpdateAiMentorLessonResponse, any>({
        path: `/api/lesson/beta-update-lesson/ai`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaCreateQuizLesson
     * @request POST:/api/lesson/beta-create-lesson/quiz
     */
    lessonControllerBetaCreateQuizLesson: (
      data: BetaCreateQuizLessonBody,
      params: RequestParams = {},
    ) =>
      this.request<BetaCreateQuizLessonResponse, any>({
        path: `/api/lesson/beta-create-lesson/quiz`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaUpdateQuizLesson
     * @request PATCH:/api/lesson/beta-update-lesson/quiz
     */
    lessonControllerBetaUpdateQuizLesson: (
      data: BetaUpdateQuizLessonBody,
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BetaUpdateQuizLessonResponse, any>({
        path: `/api/lesson/beta-update-lesson/quiz`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerBetaUpdateLesson
     * @request PATCH:/api/lesson/beta-update-lesson
     */
    lessonControllerBetaUpdateLesson: (
      data: BetaUpdateLessonBody,
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BetaUpdateLessonResponse, any>({
        path: `/api/lesson/beta-update-lesson`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerRemoveLesson
     * @request DELETE:/api/lesson
     */
    lessonControllerRemoveLesson: (
      query: {
        /** @format uuid */
        lessonId: string;
        confirmStudentDataLoss?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RemoveLessonResponse, any>({
        path: `/api/lesson`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerEvaluationQuiz
     * @request POST:/api/lesson/evaluation-quiz
     */
    lessonControllerEvaluationQuiz: (data: EvaluationQuizBody, params: RequestParams = {}) =>
      this.request<EvaluationQuizResponse, any>({
        path: `/api/lesson/evaluation-quiz`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerUploadFileToLesson
     * @request POST:/api/lesson/upload-files-to-lesson
     */
    lessonControllerUploadFileToLesson: (
      data: {
        /** @format uuid */
        lessonId?: string;
        /** @format binary */
        file: File;
        language: "en" | "es";
        title: string;
        description: string;
        contextId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success: boolean;
          data: {
            resourceId: string;
          };
          message: string;
        },
        any
      >({
        path: `/api/lesson/upload-files-to-lesson`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerDeleteStudentQuizAnswers
     * @request DELETE:/api/lesson/delete-student-quiz-answers
     */
    lessonControllerDeleteStudentQuizAnswers: (
      query: {
        /** @format uuid */
        lessonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeleteStudentQuizAnswersResponse, any>({
        path: `/api/lesson/delete-student-quiz-answers`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerSaveQuestionAnswer
     * @request PATCH:/api/lesson/{lessonId}/answer
     */
    lessonControllerSaveQuestionAnswer: (
      lessonId: string,
      data: SaveQuestionAnswerBody,
      params: RequestParams = {},
    ) =>
      this.request<SaveQuestionAnswerResponse, any>({
        path: `/api/lesson/${lessonId}/answer`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerGetStudentAnswersForLesson
     * @request GET:/api/lesson/{lessonId}/answers
     */
    lessonControllerGetStudentAnswersForLesson: (
      lessonId: string,
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetStudentAnswersForLessonResponse, any>({
        path: `/api/lesson/${lessonId}/answers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerCreateEmbedLesson
     * @request POST:/api/lesson/create-lesson/embed
     */
    lessonControllerCreateEmbedLesson: (data: CreateEmbedLessonBody, params: RequestParams = {}) =>
      this.request<CreateEmbedLessonResponse, any>({
        path: `/api/lesson/create-lesson/embed`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerUpdateEmbedLesson
     * @request PATCH:/api/lesson/update-lesson/embed/{id}
     */
    lessonControllerUpdateEmbedLesson: (
      id: string,
      data: UpdateEmbedLessonBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateEmbedLessonResponse, any>({
        path: `/api/lesson/update-lesson/embed/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerGetLessonImage
     * @request GET:/api/lesson/lesson-image/{resourceId}
     */
    lessonControllerGetLessonImage: (resourceId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/lesson/lesson-image/${resourceId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerGetLessonResource
     * @request GET:/api/lesson/lesson-resource/{resourceId}
     */
    lessonControllerGetLessonResource: (resourceId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/lesson/lesson-resource/${resourceId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerUploadAiMentorAvatar
     * @request POST:/api/lesson/ai-mentor/avatar
     */
    lessonControllerUploadAiMentorAvatar: (
      data: {
        /** @format uuid */
        lessonId: string;
        /** @format binary */
        file: File | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/lesson/ai-mentor/avatar`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name LessonControllerUpdateLessonDisplayOrder
     * @request PATCH:/api/lesson/update-lesson-display-order
     */
    lessonControllerUpdateLessonDisplayOrder: (
      data: UpdateLessonDisplayOrderBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateLessonDisplayOrderResponse, any>({
        path: `/api/lesson/update-lesson-display-order`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StudentLessonProgressControllerMarkLessonAsCompleted
     * @request POST:/api/studentLessonProgress
     */
    studentLessonProgressControllerMarkLessonAsCompleted: (
      query: {
        /** @format uuid */
        id: string;
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<MarkLessonAsCompletedResponse, any>({
        path: `/api/studentLessonProgress`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name StudentLessonProgressControllerSaveLessonProgress
     * @request POST:/api/studentLessonProgress/heartbeat
     */
    studentLessonProgressControllerSaveLessonProgress: (
      query: {
        /** @format uuid */
        id: string;
      },
      data: SaveLessonProgressBody,
      params: RequestParams = {},
    ) =>
      this.request<SaveLessonProgressResponse, any>({
        path: `/api/studentLessonProgress/heartbeat`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CertificatesControllerGetAllCertificates
     * @request GET:/api/certificates/all
     */
    certificatesControllerGetAllCertificates: (
      query?: {
        /** @format uuid */
        userId?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllCertificatesResponse, any>({
        path: `/api/certificates/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CertificatesControllerGetCertificate
     * @request GET:/api/certificates/certificate
     */
    certificatesControllerGetCertificate: (
      query?: {
        /** @format uuid */
        courseId?: string;
        /** @format uuid */
        userId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCertificateResponse, any>({
        path: `/api/certificates/certificate`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CertificatesControllerVerifyCredential
     * @request GET:/api/certificates/verify/{code}
     */
    certificatesControllerVerifyCredential: (code: string, params: RequestParams = {}) =>
      this.request<VerifyCredentialResponse, any>({
        path: `/api/certificates/verify/${code}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CertificatesControllerDownloadCredentialPdf
     * @request GET:/api/certificates/{code}/pdf
     */
    certificatesControllerDownloadCredentialPdf: (code: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/certificates/${code}/pdf`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name CertificatesControllerRevokeCredential
     * @request PATCH:/api/certificates/{id}/revoke
     */
    certificatesControllerRevokeCredential: (
      id: string,
      data: RevokeCredentialBody,
      params: RequestParams = {},
    ) =>
      this.request<RevokeCredentialResponse, any>({
        path: `/api/certificates/${id}/revoke`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CertificatesControllerRevokeCredentialByCode
     * @request PATCH:/api/certificates/by-code/{code}/revoke
     */
    certificatesControllerRevokeCredentialByCode: (
      code: string,
      data: RevokeCredentialByCodeBody,
      params: RequestParams = {},
    ) =>
      this.request<RevokeCredentialByCodeResponse, any>({
        path: `/api/certificates/by-code/${code}/revoke`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminCredentialsControllerListAdminCredentials
     * @request GET:/api/admin/credentials
     */
    adminCredentialsControllerListAdminCredentials: (
      query?: {
        /** @format uuid */
        courseId?: string;
        /** @format uuid */
        userId?: string;
        status?: "valid" | "revoked";
        /** @maxLength 100 */
        search?: string;
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListAdminCredentialsResponse, any>({
        path: `/api/admin/credentials`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminCredentialsControllerCorrectCredentialHolderName
     * @request PATCH:/api/admin/credentials/{id}/holder-name
     */
    adminCredentialsControllerCorrectCredentialHolderName: (
      id: string,
      data: CorrectCredentialHolderNameBody,
      params: RequestParams = {},
    ) =>
      this.request<CorrectCredentialHolderNameResponse, any>({
        path: `/api/admin/credentials/${id}/holder-name`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminCredentialsControllerGetCredentialHolderNameHistory
     * @request GET:/api/admin/credentials/{id}/holder-name-history
     */
    adminCredentialsControllerGetCredentialHolderNameHistory: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<GetCredentialHolderNameHistoryResponse, any>({
        path: `/api/admin/credentials/${id}/holder-name-history`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AiControllerGetThread
     * @request GET:/api/ai/thread
     */
    aiControllerGetThread: (
      query?: {
        /** @format uuid */
        thread?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetThreadResponse, any>({
        path: `/api/ai/thread`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AiControllerGetThreadMessages
     * @request GET:/api/ai/thread/messages
     */
    aiControllerGetThreadMessages: (
      query?: {
        /** @format uuid */
        thread?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetThreadMessagesResponse, any>({
        path: `/api/ai/thread/messages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AiControllerStreamChat
     * @request POST:/api/ai/chat
     */
    aiControllerStreamChat: (data: StreamChatBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/ai/chat`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name AiControllerJudgeThread
     * @request POST:/api/ai/judge/{threadId}
     */
    aiControllerJudgeThread: (threadId: string, params: RequestParams = {}) =>
      this.request<JudgeThreadResponse, any>({
        path: `/api/ai/judge/${threadId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AiControllerGetEvaluations
     * @request GET:/api/ai/evaluations/{lessonId}
     */
    aiControllerGetEvaluations: (lessonId: string, params: RequestParams = {}) =>
      this.request<GetEvaluationsResponse, any>({
        path: `/api/ai/evaluations/${lessonId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AiControllerRetakeLesson
     * @request POST:/api/ai/retake/{lessonId}
     */
    aiControllerRetakeLesson: (lessonId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/ai/retake/${lessonId}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name IngestionControllerIngest
     * @request POST:/api/ingestion/ingest
     */
    ingestionControllerIngest: (
      data: {
        /** @format uuid */
        lessonId: string;
        files: File[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/ingestion/ingest`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @name IngestionControllerGetAllAssignedDocumentsForLesson
     * @request GET:/api/ingestion/{lessonId}
     */
    ingestionControllerGetAllAssignedDocumentsForLesson: (
      lessonId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetAllAssignedDocumentsForLessonResponse, any>({
        path: `/api/ingestion/${lessonId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name IngestionControllerDeleteDocumentLink
     * @request DELETE:/api/ingestion/{documentLinkId}
     */
    ingestionControllerDeleteDocumentLink: (documentLinkId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/ingestion/${documentLinkId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthAttemptsControllerGetAuthAttempts
     * @request GET:/api/auth-attempts
     */
    authAttemptsControllerGetAuthAttempts: (
      query?: {
        context?: "login" | "register" | "change_phone";
        outcome?: "sent" | "unknown_phone" | "step_up" | "blocked" | "error";
        /** @format uuid */
        userId?: string;
        /** @maxLength 100 */
        search?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        onlyBot?: "true" | "false";
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
        sort?:
          | "createdAt"
          | "phone"
          | "context"
          | "outcome"
          | "-createdAt"
          | "-phone"
          | "-context"
          | "-outcome";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAuthAttemptsResponse, any>({
        path: `/api/auth-attempts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthAttemptsControllerGetAuthAttemptsStats
     * @request GET:/api/auth-attempts/stats
     */
    authAttemptsControllerGetAuthAttemptsStats: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAuthAttemptsStatsResponse, any>({
        path: `/api/auth-attempts/stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthAttemptsControllerGetAuthBotEvents
     * @request GET:/api/auth-attempts/bot-events
     */
    authAttemptsControllerGetAuthBotEvents: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        event?:
          | "escalated"
          | "managed_solved"
          | "widget_error"
          | "script_unavailable"
          | "abandoned";
        /** @format uuid */
        attemptId?: string;
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAuthBotEventsResponse, any>({
        path: `/api/auth-attempts/bot-events`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthAttemptsControllerGetAuthCloudflareAnalytics
     * @request GET:/api/auth-attempts/cloudflare
     */
    authAttemptsControllerGetAuthCloudflareAnalytics: (
      query?: {
        /**
         * @min 1
         * @max 7
         */
        days?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAuthCloudflareAnalyticsResponse, any>({
        path: `/api/auth-attempts/cloudflare`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AuthBotEventControllerReportAuthBotEvent
     * @request POST:/api/auth/bot-event
     */
    authBotEventControllerReportAuthBotEvent: (
      data: ReportAuthBotEventBody,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/auth/bot-event`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name SiteVisitsInsightsControllerGetVisitStatus
     * @request GET:/api/analytics/visits/status
     */
    siteVisitsInsightsControllerGetVisitStatus: (params: RequestParams = {}) =>
      this.request<GetVisitStatusResponse, any>({
        path: `/api/analytics/visits/status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SiteVisitsInsightsControllerGetVisitSummary
     * @request GET:/api/analytics/visits/summary
     */
    siteVisitsInsightsControllerGetVisitSummary: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        compare?: "true" | "false";
        surface?: "site" | "app" | "all";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVisitSummaryResponse, any>({
        path: `/api/analytics/visits/summary`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SiteVisitsInsightsControllerGetVisitRealtime
     * @request GET:/api/analytics/visits/realtime
     */
    siteVisitsInsightsControllerGetVisitRealtime: (
      query?: {
        surface?: "site" | "app" | "all";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVisitRealtimeResponse, any>({
        path: `/api/analytics/visits/realtime`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SiteVisitsInsightsControllerGetVisitSessions
     * @request GET:/api/analytics/visits/sessions
     */
    siteVisitsInsightsControllerGetVisitSessions: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        surface?: "site" | "app" | "all";
        /**
         * @minLength 1
         * @maxLength 200
         */
        source?: string;
        /**
         * @minLength 1
         * @maxLength 200
         */
        medium?: string;
        /**
         * @minLength 1
         * @maxLength 200
         */
        campaign?: string;
        inApp?: "tiktok" | "instagram" | "facebook" | "none";
        device?: "mobile" | "tablet" | "desktop";
        withRecording?: "true" | "false";
        reached?: "true" | "false";
        includePreloads?: "true" | "false";
        /** @maxLength 200 */
        cursor?: string;
        /** @pattern ^[0-9]{1,3}$ */
        limit?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetVisitSessionsResponse, any>({
        path: `/api/analytics/visits/sessions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SiteVisitsInsightsControllerGetClarityFriction
     * @request GET:/api/analytics/visits/clarity-friction
     */
    siteVisitsInsightsControllerGetClarityFriction: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetClarityFrictionResponse, any>({
        path: `/api/analytics/visits/clarity-friction`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SiteVisitsInsightsControllerRefreshClarityFriction
     * @request POST:/api/analytics/visits/clarity-friction/refresh
     */
    siteVisitsInsightsControllerRefreshClarityFriction: (params: RequestParams = {}) =>
      this.request<RefreshClarityFrictionResponse, any>({
        path: `/api/analytics/visits/clarity-friction/refresh`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name SiteVisitsInsightsControllerSyncClarityRecordings
     * @request POST:/api/analytics/visits/clarity-recordings/sync
     */
    siteVisitsInsightsControllerSyncClarityRecordings: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SyncClarityRecordingsResponse, any>({
        path: `/api/analytics/visits/clarity-recordings/sync`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name HealthControllerCheck
     * @request GET:/api/healthcheck
     */
    healthControllerCheck: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "ok" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        },
        {
          /** @example "error" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"redis":{"status":"down","message":"Could not connect"}} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        }
      >({
        path: `/api/healthcheck`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name HealthControllerCheckReady
     * @request GET:/api/healthcheck/ready
     */
    healthControllerCheckReady: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "ok" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        },
        {
          /** @example "error" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"redis":{"status":"down","message":"Could not connect"}} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        }
      >({
        path: `/api/healthcheck/ready`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name HealthControllerCheckPdf
     * @request GET:/api/healthcheck/pdf
     */
    healthControllerCheckPdf: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "ok" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        },
        {
          /** @example "error" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"redis":{"status":"down","message":"Could not connect"}} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        }
      >({
        path: `/api/healthcheck/pdf`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TestConfigControllerSetup
     * @request POST:/api/test-config/setup
     */
    testConfigControllerSetup: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/test-config/setup`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name TestConfigControllerTeardown
     * @request POST:/api/test-config/teardown
     */
    testConfigControllerTeardown: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/test-config/teardown`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @name CategoryControllerGetAllCategories
     * @request GET:/api/category
     */
    categoryControllerGetAllCategories: (
      query?: {
        title?: string;
        archived?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
        sort?: "title" | "creationDate" | "-title" | "-creationDate";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllCategoriesResponse, any>({
        path: `/api/category`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CategoryControllerCreateCategory
     * @request POST:/api/category
     */
    categoryControllerCreateCategory: (data: CreateCategoryBody, params: RequestParams = {}) =>
      this.request<CreateCategoryResponse, any>({
        path: `/api/category`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CategoryControllerGetMenuCategories
     * @request GET:/api/category/menu
     */
    categoryControllerGetMenuCategories: (params: RequestParams = {}) =>
      this.request<GetMenuCategoriesResponse, any>({
        path: `/api/category/menu`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CategoryControllerGetCategoryPage
     * @request GET:/api/category/page/{slug}
     */
    categoryControllerGetCategoryPage: (slug: string, params: RequestParams = {}) =>
      this.request<GetCategoryPageResponse, any>({
        path: `/api/category/page/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CategoryControllerGetCategoryById
     * @request GET:/api/category/{id}
     */
    categoryControllerGetCategoryById: (id: string, params: RequestParams = {}) =>
      this.request<GetCategoryByIdResponse, any>({
        path: `/api/category/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CategoryControllerUpdateCategory
     * @request PATCH:/api/category/{id}
     */
    categoryControllerUpdateCategory: (
      id: string,
      data: UpdateCategoryBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCategoryResponse, any>({
        path: `/api/category/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CategoryControllerDeleteCategory
     * @request DELETE:/api/category/deleteCategory/{id}
     */
    categoryControllerDeleteCategory: (id: string, params: RequestParams = {}) =>
      this.request<DeleteCategoryResponse, any>({
        path: `/api/category/deleteCategory/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CategoryControllerDeleteManyCategories
     * @request DELETE:/api/category/deleteManyCategories
     */
    categoryControllerDeleteManyCategories: (
      data: DeleteManyCategoriesBody,
      params: RequestParams = {},
    ) =>
      this.request<DeleteManyCategoriesResponse, any>({
        path: `/api/category/deleteManyCategories`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name MercadoPagoControllerGetOrCreateCustomer
     * @request POST:/api/mercadopago/customer
     */
    mercadoPagoControllerGetOrCreateCustomer: (params: RequestParams = {}) =>
      this.request<GetOrCreateCustomerResponse, any>({
        path: `/api/mercadopago/customer`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name MercadoPagoControllerGetCustomerCards
     * @request GET:/api/mercadopago/customer/cards
     */
    mercadoPagoControllerGetCustomerCards: (params: RequestParams = {}) =>
      this.request<GetCustomerCardsResponse, any>({
        path: `/api/mercadopago/customer/cards`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name MercadoPagoControllerDeleteCustomerCard
     * @request DELETE:/api/mercadopago/customer/cards/{cardId}
     */
    mercadoPagoControllerDeleteCustomerCard: (cardId: string, params: RequestParams = {}) =>
      this.request<DeleteCustomerCardResponse, any>({
        path: `/api/mercadopago/customer/cards/${cardId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name MercadoPagoControllerHandleWebhook
     * @request POST:/api/mercadopago/webhook
     */
    mercadoPagoControllerHandleWebhook: (data: HandleWebhookBody, params: RequestParams = {}) =>
      this.request<HandleWebhookResponse, any>({
        path: `/api/mercadopago/webhook`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EnvControllerBulkUpsertEnv
     * @request POST:/api/env/bulk
     */
    envControllerBulkUpsertEnv: (data: BulkUpsertEnvBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/env/bulk`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name EnvControllerGetFrontendSsoEnabled
     * @request GET:/api/env/frontend/sso
     */
    envControllerGetFrontendSsoEnabled: (params: RequestParams = {}) =>
      this.request<GetFrontendSSOEnabledResponse, any>({
        path: `/api/env/frontend/sso`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EnvControllerGetMercadoPagoPublicKey
     * @request GET:/api/env/mercadopago/public-key
     */
    envControllerGetMercadoPagoPublicKey: (params: RequestParams = {}) =>
      this.request<GetMercadoPagoPublicKeyResponse, any>({
        path: `/api/env/mercadopago/public-key`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EnvControllerGetMercadoPagoConfigured
     * @request GET:/api/env/frontend/mercadopago
     */
    envControllerGetMercadoPagoConfigured: (params: RequestParams = {}) =>
      this.request<GetMercadoPagoConfiguredResponse, any>({
        path: `/api/env/frontend/mercadopago`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EnvControllerGetAiConfigured
     * @request GET:/api/env/ai
     */
    envControllerGetAiConfigured: (params: RequestParams = {}) =>
      this.request<GetAIConfiguredResponse, any>({
        path: `/api/env/ai`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EnvControllerGetIsConfigSetup
     * @request GET:/api/env/config/setup
     */
    envControllerGetIsConfigSetup: (params: RequestParams = {}) =>
      this.request<GetIsConfigSetupResponse, any>({
        path: `/api/env/config/setup`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name EnvControllerGetEnvOverview
     * @request GET:/api/env/overview
     */
    envControllerGetEnvOverview: (params: RequestParams = {}) =>
      this.request<GetEnvOverviewResponse, any>({
        path: `/api/env/overview`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CartControllerGetCart
     * @request GET:/api/cart
     */
    cartControllerGetCart: (params: RequestParams = {}) =>
      this.request<GetCartResponse, any>({
        path: `/api/cart`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CartControllerClearCart
     * @request DELETE:/api/cart
     */
    cartControllerClearCart: (params: RequestParams = {}) =>
      this.request<ClearCartResponse, any>({
        path: `/api/cart`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CartControllerAddItem
     * @request POST:/api/cart/items
     */
    cartControllerAddItem: (data: AddItemBody, params: RequestParams = {}) =>
      this.request<AddItemResponse, any>({
        path: `/api/cart/items`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CartControllerRemoveItem
     * @request DELETE:/api/cart/items/{courseId}
     */
    cartControllerRemoveItem: (courseId: string, params: RequestParams = {}) =>
      this.request<RemoveItemResponse, any>({
        path: `/api/cart/items/${courseId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CartControllerMergeGuestCart
     * @request POST:/api/cart/merge
     */
    cartControllerMergeGuestCart: (data: MergeGuestCartBody, params: RequestParams = {}) =>
      this.request<MergeGuestCartResponse, any>({
        path: `/api/cart/merge`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CheckoutControllerRequestPaymentLink
     * @request POST:/api/checkout/request-payment-link
     */
    checkoutControllerRequestPaymentLink: (
      data: RequestPaymentLinkBody,
      params: RequestParams = {},
    ) =>
      this.request<RequestPaymentLinkResponse, any>({
        path: `/api/checkout/request-payment-link`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CheckoutControllerGetOrderStatus
     * @request GET:/api/checkout/orders/{id}/status
     */
    checkoutControllerGetOrderStatus: (id: string, params: RequestParams = {}) =>
      this.request<GetOrderStatusResponse, any>({
        path: `/api/checkout/orders/${id}/status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CheckoutControllerMercadopagoCheckout
     * @request POST:/api/checkout/mercadopago
     */
    checkoutControllerMercadopagoCheckout: (
      data: MercadopagoCheckoutBody,
      params: RequestParams = {},
    ) =>
      this.request<MercadopagoCheckoutResponse, any>({
        path: `/api/checkout/mercadopago`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CheckoutControllerFreeCheckout
     * @request POST:/api/checkout/free
     */
    checkoutControllerFreeCheckout: (data: FreeCheckoutBody, params: RequestParams = {}) =>
      this.request<FreeCheckoutResponse, any>({
        path: `/api/checkout/free`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CoursePreinscriptionsControllerPreinscribe
     * @request POST:/api/course-preinscriptions
     */
    coursePreinscriptionsControllerPreinscribe: (
      data: PreinscribeBody,
      params: RequestParams = {},
    ) =>
      this.request<PreinscribeResponse, any>({
        path: `/api/course-preinscriptions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CoursePreinscriptionsControllerGetAll
     * @request GET:/api/course-preinscriptions
     */
    coursePreinscriptionsControllerGetAll: (
      query?: {
        /** @format uuid */
        courseId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllResponse, any>({
        path: `/api/course-preinscriptions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CoursePreinscriptionsControllerGetOpenCourses
     * @request GET:/api/course-preinscriptions/open
     */
    coursePreinscriptionsControllerGetOpenCourses: (
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetOpenCoursesResponse, any>({
        path: `/api/course-preinscriptions/open`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CoursePreinscriptionsControllerGetMine
     * @request GET:/api/course-preinscriptions/mine
     */
    coursePreinscriptionsControllerGetMine: (params: RequestParams = {}) =>
      this.request<GetMineResponse, any>({
        path: `/api/course-preinscriptions/mine`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name OrderControllerListOrders
     * @request GET:/api/orders
     */
    orderControllerListOrders: (params: RequestParams = {}) =>
      this.request<ListOrdersResponse, any>({
        path: `/api/orders`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name OrderControllerListPurchaseHistory
     * @request GET:/api/orders/purchases
     */
    orderControllerListPurchaseHistory: (params: RequestParams = {}) =>
      this.request<ListPurchaseHistoryResponse, any>({
        path: `/api/orders/purchases`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name OrderControllerGetOrderPublic
     * @request GET:/api/orders/{id}/public
     */
    orderControllerGetOrderPublic: (id: string, params: RequestParams = {}) =>
      this.request<GetOrderPublicResponse, any>({
        path: `/api/orders/${id}/public`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name OrderControllerGetPaymentLink
     * @request GET:/api/orders/{id}/payment-link
     */
    orderControllerGetPaymentLink: (id: string, params: RequestParams = {}) =>
      this.request<GetPaymentLinkResponse, any>({
        path: `/api/orders/${id}/payment-link`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name OrderControllerGetOrder
     * @request GET:/api/orders/{id}
     */
    orderControllerGetOrder: (id: string, params: RequestParams = {}) =>
      this.request<GetOrderResponse, any>({
        path: `/api/orders/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name OrderControllerResendPaymentLink
     * @request POST:/api/orders/{id}/payment-link/resend
     */
    orderControllerResendPaymentLink: (id: string, params: RequestParams = {}) =>
      this.request<ResendPaymentLinkResponse, any>({
        path: `/api/orders/${id}/payment-link/resend`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminOrdersControllerGetOrders
     * @request GET:/api/admin/orders
     */
    adminOrdersControllerGetOrders: (
      query?: {
        keyword?: string;
        status?: string;
        provider?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        dateFrom?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        dateTo?: string;
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetOrdersResponse, any>({
        path: `/api/admin/orders`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminOrdersControllerGetOrdersStats
     * @request GET:/api/admin/orders/stats
     */
    adminOrdersControllerGetOrdersStats: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        dateFrom?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        dateTo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetOrdersStatsResponse, any>({
        path: `/api/admin/orders/stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminOrdersControllerGetById
     * @request GET:/api/admin/orders/{id}
     */
    adminOrdersControllerGetById: (id: string, params: RequestParams = {}) =>
      this.request<GetByIdResponse, any>({
        path: `/api/admin/orders/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminOrdersControllerCancel
     * @request PATCH:/api/admin/orders/{id}/cancel
     */
    adminOrdersControllerCancel: (id: string, params: RequestParams = {}) =>
      this.request<CancelResponse, any>({
        path: `/api/admin/orders/${id}/cancel`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminWhatsappControllerGetAll
     * @request GET:/api/admin/whatsapp-messages
     */
    adminWhatsappControllerGetAll: (
      query?: {
        phone?: string;
        kind?: string;
        status?: string;
        dateFrom?: string;
        dateTo?: string;
        /** @min 1 */
        page?: number;
        perPage?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllResponse, any>({
        path: `/api/admin/whatsapp-messages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AdminWhatsappControllerGetStats
     * @request GET:/api/admin/whatsapp-messages/stats
     */
    adminWhatsappControllerGetStats: (
      query?: {
        dateFrom?: string;
        dateTo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetStatsResponse, any>({
        path: `/api/admin/whatsapp-messages/stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ReportControllerDownloadSummaryReport
     * @request GET:/api/report/summary
     */
    reportControllerDownloadSummaryReport: (
      query?: {
        /** @default "es" */
        language?: "en" | "es";
        /** @format uuid */
        courseId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/report/summary`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name ScormControllerUploadScormPackage
     * @request POST:/api/scorm/upload
     */
    scormControllerUploadScormPackage: (
      query: {
        courseId: string;
      },
      data: {
        /** @format binary */
        file?: File;
        /** Optional resource type */
        resource?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadScormPackageResponse, any>({
        path: `/api/scorm/upload`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ScormControllerServeScormContent
     * @request GET:/api/scorm/{courseId}/content
     */
    scormControllerServeScormContent: (
      courseId: string,
      query: {
        path: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/scorm/${courseId}/content`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name ScormControllerGetScormMetadata
     * @request GET:/api/scorm/{courseId}/metadata
     */
    scormControllerGetScormMetadata: (courseId: string, params: RequestParams = {}) =>
      this.request<GetScormMetadataResponse, any>({
        path: `/api/scorm/${courseId}/metadata`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AnnouncementsControllerGetAllAnnouncements
     * @request GET:/api/announcements
     */
    announcementsControllerGetAllAnnouncements: (params: RequestParams = {}) =>
      this.request<GetAllAnnouncementsResponse, any>({
        path: `/api/announcements`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AnnouncementsControllerCreateAnnouncement
     * @request POST:/api/announcements
     */
    announcementsControllerCreateAnnouncement: (
      data: CreateAnnouncementBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateAnnouncementResponse, any>({
        path: `/api/announcements`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AnnouncementsControllerGetLatestUnreadAnnouncements
     * @request GET:/api/announcements/latest
     */
    announcementsControllerGetLatestUnreadAnnouncements: (params: RequestParams = {}) =>
      this.request<GetLatestUnreadAnnouncementsResponse, any>({
        path: `/api/announcements/latest`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AnnouncementsControllerGetUnreadAnnouncementsCount
     * @request GET:/api/announcements/unread
     */
    announcementsControllerGetUnreadAnnouncementsCount: (params: RequestParams = {}) =>
      this.request<GetUnreadAnnouncementsCountResponse, any>({
        path: `/api/announcements/unread`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AnnouncementsControllerGetAnnouncementsForUser
     * @request GET:/api/announcements/user/me
     */
    announcementsControllerGetAnnouncementsForUser: (
      query?: {
        title?: string;
        content?: string;
        authorName?: string;
        search?: string;
        isRead?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAnnouncementsForUserResponse, any>({
        path: `/api/announcements/user/me`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AnnouncementsControllerMarkAnnouncementAsRead
     * @request PATCH:/api/announcements/{id}/read
     */
    announcementsControllerMarkAnnouncementAsRead: (id: string, params: RequestParams = {}) =>
      this.request<MarkAnnouncementAsReadResponse, any>({
        path: `/api/announcements/${id}/read`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name QaControllerGetQa
     * @request GET:/api/qa/{qaId}
     */
    qaControllerGetQa: (
      qaId: string,
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetQAResponse, any>({
        path: `/api/qa/${qaId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name QaControllerUpdateQa
     * @request PATCH:/api/qa/{qaId}
     */
    qaControllerUpdateQa: (
      qaId: string,
      data: UpdateQABody,
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/qa/${qaId}`,
        method: "PATCH",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name QaControllerDeleteQa
     * @request DELETE:/api/qa/{qaId}
     */
    qaControllerDeleteQa: (qaId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/qa/${qaId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name QaControllerGetAllQa
     * @request GET:/api/qa
     */
    qaControllerGetAllQa: (
      query?: {
        /** @default "es" */
        language?: "en" | "es";
        searchQuery?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAllQAResponse, any>({
        path: `/api/qa`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name QaControllerCreateQa
     * @request POST:/api/qa
     */
    qaControllerCreateQa: (data: CreateQABody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/qa`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name QaControllerCreateLanguage
     * @request POST:/api/qa/create-language/{qaId}
     */
    qaControllerCreateLanguage: (
      qaId: string,
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/qa/create-language/${qaId}`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name QaControllerDeleteLanguage
     * @request DELETE:/api/qa/language/{qaId}
     */
    qaControllerDeleteLanguage: (
      qaId: string,
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/qa/language/${qaId}`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name NewsControllerGetDraftNewsList
     * @request GET:/api/news/drafts
     */
    newsControllerGetDraftNewsList: (
      query?: {
        /** @default "es" */
        language?: "en" | "es";
        /** @min 1 */
        page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDraftNewsListResponse, any>({
        path: `/api/news/drafts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name NewsControllerGenerateNewsPreview
     * @request POST:/api/news/preview
     */
    newsControllerGenerateNewsPreview: (
      data: GenerateNewsPreviewBody,
      params: RequestParams = {},
    ) =>
      this.request<GenerateNewsPreviewResponse, any>({
        path: `/api/news/preview`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name NewsControllerGetNewsResource
     * @request GET:/api/news/news-resource/{resourceId}
     */
    newsControllerGetNewsResource: (resourceId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/news/news-resource/${resourceId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name NewsControllerGetNews
     * @request GET:/api/news/{id}
     */
    newsControllerGetNews: (
      id: string,
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetNewsResponse, any>({
        path: `/api/news/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name NewsControllerUpdateNews
     * @request PATCH:/api/news/{id}
     */
    newsControllerUpdateNews: (id: string, data: UpdateNewsBody, params: RequestParams = {}) =>
      this.request<UpdateNewsResponse, any>({
        path: `/api/news/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name NewsControllerAddNewLanguage
     * @summary Add a new language to a news item
     * @request POST:/api/news/{id}
     */
    newsControllerAddNewLanguage: (
      id: string,
      data: AddNewLanguageBody,
      params: RequestParams = {},
    ) =>
      this.request<AddNewLanguageResponse, any>({
        path: `/api/news/${id}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name NewsControllerDeleteNews
     * @request DELETE:/api/news/{id}
     */
    newsControllerDeleteNews: (id: string, params: RequestParams = {}) =>
      this.request<DeleteNewsResponse, any>({
        path: `/api/news/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name NewsControllerGetNewsList
     * @request GET:/api/news
     */
    newsControllerGetNewsList: (
      query?: {
        /** @default "es" */
        language?: "en" | "es";
        searchQuery?: string;
        /** @min 1 */
        page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetNewsListResponse, any>({
        path: `/api/news`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name NewsControllerCreateNews
     * @request POST:/api/news
     */
    newsControllerCreateNews: (data: CreateNewsBody, params: RequestParams = {}) =>
      this.request<CreateNewsResponse, any>({
        path: `/api/news`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name NewsControllerDeleteNewsLanguage
     * @request DELETE:/api/news/{id}/language
     */
    newsControllerDeleteNewsLanguage: (
      id: string,
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<DeleteNewsLanguageResponse, any>({
        path: `/api/news/${id}/language`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name NewsControllerUploadFileToNews
     * @request POST:/api/news/{id}/upload
     */
    newsControllerUploadFileToNews: (
      id: string,
      data: {
        /** @format binary */
        file: File;
        language: "en" | "es";
        title: string;
        description: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadFileToNewsResponse, any>({
        path: `/api/news/${id}/upload`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerCreateArticleSection
     * @request POST:/api/articles/section
     */
    articlesControllerCreateArticleSection: (
      data: CreateArticleSectionBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateArticleSectionResponse, any>({
        path: `/api/articles/section`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerGetArticleSection
     * @request GET:/api/articles/section/{id}
     */
    articlesControllerGetArticleSection: (
      id: string,
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetArticleSectionResponse, any>({
        path: `/api/articles/section/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerUpdateArticleSection
     * @request PATCH:/api/articles/section/{id}
     */
    articlesControllerUpdateArticleSection: (
      id: string,
      data: UpdateArticleSectionBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateArticleSectionResponse, any>({
        path: `/api/articles/section/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerDeleteArticleSection
     * @request DELETE:/api/articles/section/{id}
     */
    articlesControllerDeleteArticleSection: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/articles/section/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerAddNewLanguageToSection
     * @summary Add a new language to an article section
     * @request POST:/api/articles/section/{id}/language
     */
    articlesControllerAddNewLanguageToSection: (
      id: string,
      data: AddNewLanguageToSectionBody,
      params: RequestParams = {},
    ) =>
      this.request<AddNewLanguageToSectionResponse, any>({
        path: `/api/articles/section/${id}/language`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerDeleteArticleSectionLanguage
     * @request DELETE:/api/articles/section/{id}/language
     */
    articlesControllerDeleteArticleSectionLanguage: (
      id: string,
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/articles/section/${id}/language`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerGetDraftArticles
     * @request GET:/api/articles/drafts
     */
    articlesControllerGetDraftArticles: (
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDraftArticlesResponse, any>({
        path: `/api/articles/drafts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerGetArticleToc
     * @request GET:/api/articles/toc
     */
    articlesControllerGetArticleToc: (
      query?: {
        /** @default "es" */
        language?: "en" | "es";
        isDraftMode?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetArticleTocResponse, any>({
        path: `/api/articles/toc`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerGetArticleResource
     * @request GET:/api/articles/articles-resource/{resourceId}
     */
    articlesControllerGetArticleResource: (resourceId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/articles/articles-resource/${resourceId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerGetArticle
     * @request GET:/api/articles/{id}
     */
    articlesControllerGetArticle: (
      id: string,
      query?: {
        /** @default "es" */
        language?: "en" | "es";
        isDraftMode?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetArticleResponse, any>({
        path: `/api/articles/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerUpdateArticle
     * @request PATCH:/api/articles/{id}
     */
    articlesControllerUpdateArticle: (
      id: string,
      data: UpdateArticleBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateArticleResponse, any>({
        path: `/api/articles/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerDeleteArticle
     * @request DELETE:/api/articles/{id}
     */
    articlesControllerDeleteArticle: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/articles/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerGetArticles
     * @request GET:/api/articles
     */
    articlesControllerGetArticles: (
      query?: {
        /** @default "es" */
        language?: "en" | "es";
        searchQuery?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetArticlesResponse, any>({
        path: `/api/articles`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerCreateArticle
     * @request POST:/api/articles/article
     */
    articlesControllerCreateArticle: (data: CreateArticleBody, params: RequestParams = {}) =>
      this.request<CreateArticleResponse, any>({
        path: `/api/articles/article`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerAddNewLanguage
     * @summary Add a new language to an article
     * @request POST:/api/articles/article/{id}
     */
    articlesControllerAddNewLanguage: (
      id: string,
      data: AddNewLanguageBody,
      params: RequestParams = {},
    ) =>
      this.request<AddNewLanguageResponse, any>({
        path: `/api/articles/article/${id}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerDeleteArticleLanguage
     * @request DELETE:/api/articles/{id}/language
     */
    articlesControllerDeleteArticleLanguage: (
      id: string,
      query?: {
        /** @default "es" */
        language?: "en" | "es";
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/articles/${id}/language`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerUploadFileToArticle
     * @request POST:/api/articles/{id}/upload
     */
    articlesControllerUploadFileToArticle: (
      id: string,
      data: UploadFileToArticleBody,
      params: RequestParams = {},
    ) =>
      this.request<UploadFileToArticleResponse, any>({
        path: `/api/articles/${id}/upload`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ArticlesControllerGenerateArticlePreview
     * @request POST:/api/articles/preview
     */
    articlesControllerGenerateArticlePreview: (
      data: GenerateArticlePreviewBody,
      params: RequestParams = {},
    ) =>
      this.request<GenerateArticlePreviewResponse, any>({
        path: `/api/articles/preview`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name WhatsAppControllerHandleWebhook
     * @request POST:/api/whatsapp/webhook
     */
    whatsAppControllerHandleWebhook: (params: RequestParams = {}) =>
      this.request<HandleWebhookResponse, any>({
        path: `/api/whatsapp/webhook`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RegistrationAttemptsControllerGetRegistrationAttempts
     * @request GET:/api/registration-attempts
     */
    registrationAttemptsControllerGetRegistrationAttempts: (
      query?: {
        keyword?: string;
        source?: string;
        registered?: "true" | "false";
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        dateFrom?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        dateTo?: string;
        /** @min 1 */
        page?: number;
        /**
         * @min 1
         * @max 100
         */
        perPage?: number;
        sort?:
          | "createdAt"
          | "phone"
          | "source"
          | "registered"
          | "-createdAt"
          | "-phone"
          | "-source"
          | "-registered";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetRegistrationAttemptsResponse, any>({
        path: `/api/registration-attempts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RegistrationAttemptsControllerGetRegistrationAttemptsStats
     * @request GET:/api/registration-attempts/stats
     */
    registrationAttemptsControllerGetRegistrationAttemptsStats: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        dateFrom?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        dateTo?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetRegistrationAttemptsStatsResponse, any>({
        path: `/api/registration-attempts/stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseAnalyticsControllerGetCourseAnalyticsOverview
     * @request GET:/api/course-analytics/{courseId}/overview
     */
    courseAnalyticsControllerGetCourseAnalyticsOverview: (
      courseId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetCourseAnalyticsOverviewResponse, any>({
        path: `/api/course-analytics/${courseId}/overview`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseAnalyticsControllerGetCourseAnalyticsStudents
     * @request GET:/api/course-analytics/{courseId}/students
     */
    courseAnalyticsControllerGetCourseAnalyticsStudents: (
      courseId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetCourseAnalyticsStudentsResponse, any>({
        path: `/api/course-analytics/${courseId}/students`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseAnalyticsControllerGetCourseAnalyticsStudentDetail
     * @request GET:/api/course-analytics/{courseId}/students/{studentId}
     */
    courseAnalyticsControllerGetCourseAnalyticsStudentDetail: (
      courseId: string,
      studentId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetCourseAnalyticsStudentDetailResponse, any>({
        path: `/api/course-analytics/${courseId}/students/${studentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseAnalyticsControllerGetCourseAnalyticsQuestions
     * @request GET:/api/course-analytics/{courseId}/questions
     */
    courseAnalyticsControllerGetCourseAnalyticsQuestions: (
      courseId: string,
      query?: {
        kind?: "quiz" | "survey";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCourseAnalyticsQuestionsResponse, any>({
        path: `/api/course-analytics/${courseId}/questions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseAnalyticsControllerGetCourseAnalyticsFunnel
     * @request GET:/api/course-analytics/{courseId}/funnel
     */
    courseAnalyticsControllerGetCourseAnalyticsFunnel: (
      courseId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetCourseAnalyticsFunnelResponse, any>({
        path: `/api/course-analytics/${courseId}/funnel`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name CourseAnalyticsControllerExportCourseAnalyticsCsv
     * @request GET:/api/course-analytics/{courseId}/export.csv
     */
    courseAnalyticsControllerExportCourseAnalyticsCsv: (
      courseId: string,
      query?: {
        dataset?: "students" | "answers";
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/course-analytics/${courseId}/export.csv`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @name TrackingControllerGetTrackingPublicConfig
     * @request GET:/api/tracking/public-config
     */
    trackingControllerGetTrackingPublicConfig: (params: RequestParams = {}) =>
      this.request<GetTrackingPublicConfigResponse, any>({
        path: `/api/tracking/public-config`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TrackingControllerUpdateTrackingConsent
     * @request POST:/api/tracking/consent
     */
    trackingControllerUpdateTrackingConsent: (
      data: UpdateTrackingConsentBody,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTrackingConsentResponse, any>({
        path: `/api/tracking/consent`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TrackingControllerGetTrackingStatus
     * @request GET:/api/tracking/admin/status
     */
    trackingControllerGetTrackingStatus: (params: RequestParams = {}) =>
      this.request<GetTrackingStatusResponse, any>({
        path: `/api/tracking/admin/status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TrackingControllerTestTrackingDestination
     * @request POST:/api/tracking/admin/test/{destination}
     */
    trackingControllerTestTrackingDestination: (
      destination: "meta" | "tiktok" | "ga4" | "google_ads" | "x" | "linkedin",
      params: RequestParams = {},
    ) =>
      this.request<TestTrackingDestinationResponse, any>({
        path: `/api/tracking/admin/test/${destination}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TrackingControllerTestTrackingEvent
     * @request POST:/api/tracking/admin/test-event/{event}
     */
    trackingControllerTestTrackingEvent: (
      event: "view_content" | "engaged_visit" | "cta_click",
      params: RequestParams = {},
    ) =>
      this.request<TestTrackingEventResponse, any>({
        path: `/api/tracking/admin/test-event/${event}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TrackingControllerGetRecentConversions
     * @request GET:/api/tracking/admin/events
     */
    trackingControllerGetRecentConversions: (
      query?: {
        limit?: number;
        scope?: "conversions" | "funnel" | "all";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetRecentConversionsResponse, any>({
        path: `/api/tracking/admin/events`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GoogleInsightsControllerGetGoogleStatus
     * @request GET:/api/analytics/google/status
     */
    googleInsightsControllerGetGoogleStatus: (params: RequestParams = {}) =>
      this.request<GetGoogleStatusResponse, any>({
        path: `/api/analytics/google/status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GoogleInsightsControllerGetGoogleTraffic
     * @request GET:/api/analytics/google/traffic
     */
    googleInsightsControllerGetGoogleTraffic: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        compare?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetGoogleTrafficResponse, any>({
        path: `/api/analytics/google/traffic`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GoogleInsightsControllerGetGoogleSearch
     * @request GET:/api/analytics/google/search
     */
    googleInsightsControllerGetGoogleSearch: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        compare?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetGoogleSearchResponse, any>({
        path: `/api/analytics/google/search`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GoogleInsightsControllerGetGoogleRealtime
     * @request GET:/api/analytics/google/realtime
     */
    googleInsightsControllerGetGoogleRealtime: (params: RequestParams = {}) =>
      this.request<GetGoogleRealtimeResponse, any>({
        path: `/api/analytics/google/realtime`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GoogleInsightsControllerGetGoogleFunnel
     * @request GET:/api/analytics/google/funnel
     */
    googleInsightsControllerGetGoogleFunnel: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        compare?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetGoogleFunnelResponse, any>({
        path: `/api/analytics/google/funnel`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PlatformInsightsControllerGetStatus
     * @request GET:/api/analytics/platforms/status
     */
    platformInsightsControllerGetStatus: (params: RequestParams = {}) =>
      this.request<GetStatusResponse, any>({
        path: `/api/analytics/platforms/status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PlatformInsightsControllerGetFacebook
     * @request GET:/api/analytics/platforms/facebook
     */
    platformInsightsControllerGetFacebook: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        compare?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFacebookResponse, any>({
        path: `/api/analytics/platforms/facebook`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PlatformInsightsControllerGetInstagram
     * @request GET:/api/analytics/platforms/instagram
     */
    platformInsightsControllerGetInstagram: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        compare?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetInstagramResponse, any>({
        path: `/api/analytics/platforms/instagram`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PlatformInsightsControllerGetMetaAds
     * @request GET:/api/analytics/platforms/meta-ads
     */
    platformInsightsControllerGetMetaAds: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        compare?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetMetaAdsResponse, any>({
        path: `/api/analytics/platforms/meta-ads`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PlatformInsightsControllerGetTikTok
     * @request GET:/api/analytics/platforms/tiktok
     */
    platformInsightsControllerGetTikTok: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        compare?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetTikTokResponse, any>({
        path: `/api/analytics/platforms/tiktok`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PlatformInsightsControllerGetYouTube
     * @request GET:/api/analytics/platforms/youtube
     */
    platformInsightsControllerGetYouTube: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        compare?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetYouTubeResponse, any>({
        path: `/api/analytics/platforms/youtube`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name PlatformInsightsControllerGetTikTokAds
     * @request GET:/api/analytics/platforms/tiktok-ads
     */
    platformInsightsControllerGetTikTokAds: (
      query?: {
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        from?: string;
        /** @pattern ^\d{4}-\d{2}-\d{2}$ */
        to?: string;
        compare?: "true" | "false";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetTikTokAdsResponse, any>({
        path: `/api/analytics/platforms/tiktok-ads`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TikTokOAuthControllerConnect
     * @request GET:/api/analytics/tiktok/connect
     */
    tikTokOAuthControllerConnect: (params: RequestParams = {}) =>
      this.request<ConnectResponse, any>({
        path: `/api/analytics/tiktok/connect`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TikTokOAuthControllerAdsConnect
     * @request GET:/api/analytics/tiktok/ads-connect
     */
    tikTokOAuthControllerAdsConnect: (params: RequestParams = {}) =>
      this.request<AdsConnectResponse, any>({
        path: `/api/analytics/tiktok/ads-connect`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TikTokOAuthControllerAdsExchange
     * @request POST:/api/analytics/tiktok/ads-exchange
     */
    tikTokOAuthControllerAdsExchange: (data: AdsExchangeBody, params: RequestParams = {}) =>
      this.request<AdsExchangeResponse, any>({
        path: `/api/analytics/tiktok/ads-exchange`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name TikTokOAuthControllerDisconnect
     * @request POST:/api/analytics/tiktok/disconnect
     */
    tikTokOAuthControllerDisconnect: (data: DisconnectBody, params: RequestParams = {}) =>
      this.request<DisconnectResponse, any>({
        path: `/api/analytics/tiktok/disconnect`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name YouTubeOAuthControllerConnect
     * @request GET:/api/analytics/youtube/connect
     */
    youTubeOAuthControllerConnect: (params: RequestParams = {}) =>
      this.request<ConnectResponse, any>({
        path: `/api/analytics/youtube/connect`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name YouTubeOAuthControllerDisconnect
     * @request POST:/api/analytics/youtube/disconnect
     */
    youTubeOAuthControllerDisconnect: (params: RequestParams = {}) =>
      this.request<DisconnectResponse, any>({
        path: `/api/analytics/youtube/disconnect`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name IndexNowControllerGetIndexNowKey
     * @request GET:/api/indexnow/key
     */
    indexNowControllerGetIndexNowKey: (params: RequestParams = {}) =>
      this.request<GetIndexNowKeyResponse, any>({
        path: `/api/indexnow/key`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name IndexNowControllerGetIndexNowStatus
     * @request GET:/api/indexnow/admin/status
     */
    indexNowControllerGetIndexNowStatus: (params: RequestParams = {}) =>
      this.request<GetIndexNowStatusResponse, any>({
        path: `/api/indexnow/admin/status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name IndexNowControllerSubmitAllToIndexNow
     * @request POST:/api/indexnow/submit-all
     */
    indexNowControllerSubmitAllToIndexNow: (params: RequestParams = {}) =>
      this.request<SubmitAllToIndexNowResponse, any>({
        path: `/api/indexnow/submit-all`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
}
